// This file is generated by scripts/generate-proto-models.ts

// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension="
// @generated from file _gen.models.proto (package models, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from '@bufbuild/protobuf'
import { DoubleValue, Message, proto3, StringValue, Struct } from '@bufbuild/protobuf'

/**
 * @generated from message models.UsecaseTableCompanyOverview
 */
export class UsecaseTableCompanyOverview extends Message<UsecaseTableCompanyOverview> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string edinet_file_id = 2;
   */
  edinetFileId = ''

  /**
   * @generated from field: string submission_date = 3;
   */
  submissionDate = ''

  /**
   * @generated from field: string edinet_code = 4;
   */
  edinetCode = ''

  /**
   * @generated from field: google.protobuf.StringValue filer_name = 5;
   */
  filerName?: string

  /**
   * @generated from field: google.protobuf.StringValue sec_code = 6;
   */
  secCode?: string

  /**
   * @generated from field: string doc_id = 7;
   */
  docId = ''

  /**
   * @generated from field: string doc_description = 8;
   */
  docDescription = ''

  /**
   * @generated from field: repeated string securities_report_chunk_ids = 9;
   */
  securitiesReportChunkIds: string[] = []

  /**
   * @generated from field: string original_filename = 10;
   */
  originalFilename = ''

  /**
   * @generated from field: string period_start = 11;
   */
  periodStart = ''

  /**
   * @generated from field: string period_end = 12;
   */
  periodEnd = ''

  /**
   * @generated from field: string doc_type_code = 13;
   */
  docTypeCode = ''

  /**
   * @generated from field: double fiscal_year_end_year = 14;
   */
  fiscalYearEndYear = 0

  /**
   * @generated from field: double fiscal_year_end_month = 15;
   */
  fiscalYearEndMonth = 0

  /**
   * @generated from field: google.protobuf.StringValue company_name_ja = 16;
   */
  companyNameJa?: string

  /**
   * @generated from field: google.protobuf.StringValue company_name_en = 17;
   */
  companyNameEn?: string

  /**
   * @generated from field: google.protobuf.StringValue head_quater_address = 18;
   */
  headQuaterAddress?: string

  /**
   * @generated from field: google.protobuf.StringValue president_role = 19;
   */
  presidentRole?: string

  /**
   * @generated from field: google.protobuf.StringValue president_name = 20;
   */
  presidentName?: string

  /**
   * @generated from field: google.protobuf.StringValue phone_number = 21;
   */
  phoneNumber?: string

  /**
   * @generated from field: google.protobuf.DoubleValue consolidated_employees = 22;
   */
  consolidatedEmployees?: number

  /**
   * @generated from field: google.protobuf.DoubleValue consolidated_subsidiaries_count = 23;
   */
  consolidatedSubsidiariesCount?: number

  /**
   * @generated from field: repeated string reportable_segments = 24;
   */
  reportableSegments: string[] = []

  /**
   * @generated from field: google.protobuf.Struct column_missing_reason = 25;
   */
  columnMissingReason?: Struct

  constructor(data?: PartialMessage<UsecaseTableCompanyOverview>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.UsecaseTableCompanyOverview'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'edinet_file_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'submission_date', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'edinet_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'filer_name', kind: 'message', T: StringValue },
    { no: 6, name: 'sec_code', kind: 'message', T: StringValue },
    { no: 7, name: 'doc_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 8, name: 'doc_description', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 9, name: 'securities_report_chunk_ids', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: 'original_filename', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 11, name: 'period_start', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 12, name: 'period_end', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 13, name: 'doc_type_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 14, name: 'fiscal_year_end_year', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 15, name: 'fiscal_year_end_month', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 16, name: 'company_name_ja', kind: 'message', T: StringValue },
    { no: 17, name: 'company_name_en', kind: 'message', T: StringValue },
    { no: 18, name: 'head_quater_address', kind: 'message', T: StringValue },
    { no: 19, name: 'president_role', kind: 'message', T: StringValue },
    { no: 20, name: 'president_name', kind: 'message', T: StringValue },
    { no: 21, name: 'phone_number', kind: 'message', T: StringValue },
    { no: 22, name: 'consolidated_employees', kind: 'message', T: DoubleValue },
    { no: 23, name: 'consolidated_subsidiaries_count', kind: 'message', T: DoubleValue },
    { no: 24, name: 'reportable_segments', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 25, name: 'column_missing_reason', kind: 'message', T: Struct },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UsecaseTableCompanyOverview {
    return new UsecaseTableCompanyOverview().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UsecaseTableCompanyOverview {
    return new UsecaseTableCompanyOverview().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UsecaseTableCompanyOverview {
    return new UsecaseTableCompanyOverview().fromJsonString(jsonString, options)
  }

  static equals(
    a: UsecaseTableCompanyOverview | PlainMessage<UsecaseTableCompanyOverview> | undefined,
    b: UsecaseTableCompanyOverview | PlainMessage<UsecaseTableCompanyOverview> | undefined,
  ): boolean {
    return proto3.util.equals(UsecaseTableCompanyOverview, a, b)
  }
}

/**
 * @generated from message models.UsecaseTablePlHighlight
 */
export class UsecaseTablePlHighlight extends Message<UsecaseTablePlHighlight> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string edinet_file_id = 2;
   */
  edinetFileId = ''

  /**
   * @generated from field: string submission_date = 3;
   */
  submissionDate = ''

  /**
   * @generated from field: string edinet_code = 4;
   */
  edinetCode = ''

  /**
   * @generated from field: google.protobuf.StringValue filer_name = 5;
   */
  filerName?: string

  /**
   * @generated from field: google.protobuf.StringValue sec_code = 6;
   */
  secCode?: string

  /**
   * @generated from field: string doc_id = 7;
   */
  docId = ''

  /**
   * @generated from field: string doc_description = 8;
   */
  docDescription = ''

  /**
   * @generated from field: repeated string securities_report_chunk_ids = 9;
   */
  securitiesReportChunkIds: string[] = []

  /**
   * @generated from field: string original_filename = 10;
   */
  originalFilename = ''

  /**
   * @generated from field: string period_start = 11;
   */
  periodStart = ''

  /**
   * @generated from field: string period_end = 12;
   */
  periodEnd = ''

  /**
   * @generated from field: string doc_type_code = 13;
   */
  docTypeCode = ''

  /**
   * @generated from field: double fiscal_year_end_year = 14;
   */
  fiscalYearEndYear = 0

  /**
   * @generated from field: double fiscal_year_end_month = 15;
   */
  fiscalYearEndMonth = 0

  /**
   * @generated from field: google.protobuf.DoubleValue unit = 16;
   */
  unit?: number

  /**
   * @generated from field: google.protobuf.StringValue unit_text = 17;
   */
  unitText?: string

  /**
   * @generated from field: google.protobuf.DoubleValue revenue_jpy = 18;
   */
  revenueJpy?: number

  /**
   * @generated from field: google.protobuf.DoubleValue cost_of_sales_jpy = 19;
   */
  costOfSalesJpy?: number

  /**
   * @generated from field: google.protobuf.DoubleValue gross_profit_jpy = 20;
   */
  grossProfitJpy?: number

  /**
   * @generated from field: google.protobuf.DoubleValue selling_general_admin_expenses_jpy = 21;
   */
  sellingGeneralAdminExpensesJpy?: number

  /**
   * @generated from field: google.protobuf.DoubleValue operating_profit_jpy = 22;
   */
  operatingProfitJpy?: number

  /**
   * @generated from field: google.protobuf.Struct column_missing_reason = 23;
   */
  columnMissingReason?: Struct

  /**
   * @generated from field: google.protobuf.Struct calculation_dependency = 24;
   */
  calculationDependency?: Struct

  constructor(data?: PartialMessage<UsecaseTablePlHighlight>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.UsecaseTablePlHighlight'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'edinet_file_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'submission_date', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'edinet_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'filer_name', kind: 'message', T: StringValue },
    { no: 6, name: 'sec_code', kind: 'message', T: StringValue },
    { no: 7, name: 'doc_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 8, name: 'doc_description', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 9, name: 'securities_report_chunk_ids', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: 'original_filename', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 11, name: 'period_start', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 12, name: 'period_end', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 13, name: 'doc_type_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 14, name: 'fiscal_year_end_year', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 15, name: 'fiscal_year_end_month', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 16, name: 'unit', kind: 'message', T: DoubleValue },
    { no: 17, name: 'unit_text', kind: 'message', T: StringValue },
    { no: 18, name: 'revenue_jpy', kind: 'message', T: DoubleValue },
    { no: 19, name: 'cost_of_sales_jpy', kind: 'message', T: DoubleValue },
    { no: 20, name: 'gross_profit_jpy', kind: 'message', T: DoubleValue },
    { no: 21, name: 'selling_general_admin_expenses_jpy', kind: 'message', T: DoubleValue },
    { no: 22, name: 'operating_profit_jpy', kind: 'message', T: DoubleValue },
    { no: 23, name: 'column_missing_reason', kind: 'message', T: Struct },
    { no: 24, name: 'calculation_dependency', kind: 'message', T: Struct },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UsecaseTablePlHighlight {
    return new UsecaseTablePlHighlight().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UsecaseTablePlHighlight {
    return new UsecaseTablePlHighlight().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UsecaseTablePlHighlight {
    return new UsecaseTablePlHighlight().fromJsonString(jsonString, options)
  }

  static equals(
    a: UsecaseTablePlHighlight | PlainMessage<UsecaseTablePlHighlight> | undefined,
    b: UsecaseTablePlHighlight | PlainMessage<UsecaseTablePlHighlight> | undefined,
  ): boolean {
    return proto3.util.equals(UsecaseTablePlHighlight, a, b)
  }
}

/**
 * @generated from message models.UsecaseTableBsHighlight
 */
export class UsecaseTableBsHighlight extends Message<UsecaseTableBsHighlight> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string edinet_file_id = 2;
   */
  edinetFileId = ''

  /**
   * @generated from field: string submission_date = 3;
   */
  submissionDate = ''

  /**
   * @generated from field: string edinet_code = 4;
   */
  edinetCode = ''

  /**
   * @generated from field: google.protobuf.StringValue filer_name = 5;
   */
  filerName?: string

  /**
   * @generated from field: google.protobuf.StringValue sec_code = 6;
   */
  secCode?: string

  /**
   * @generated from field: string doc_id = 7;
   */
  docId = ''

  /**
   * @generated from field: string doc_description = 8;
   */
  docDescription = ''

  /**
   * @generated from field: repeated string securities_report_chunk_ids = 9;
   */
  securitiesReportChunkIds: string[] = []

  /**
   * @generated from field: string original_filename = 10;
   */
  originalFilename = ''

  /**
   * @generated from field: string period_start = 11;
   */
  periodStart = ''

  /**
   * @generated from field: string period_end = 12;
   */
  periodEnd = ''

  /**
   * @generated from field: string doc_type_code = 13;
   */
  docTypeCode = ''

  /**
   * @generated from field: double fiscal_year_end_year = 14;
   */
  fiscalYearEndYear = 0

  /**
   * @generated from field: double fiscal_year_end_month = 15;
   */
  fiscalYearEndMonth = 0

  /**
   * @generated from field: google.protobuf.DoubleValue unit = 16;
   */
  unit?: number

  /**
   * @generated from field: google.protobuf.StringValue unit_text = 17;
   */
  unitText?: string

  /**
   * @generated from field: google.protobuf.DoubleValue cash_and_deposits_jpy = 18;
   */
  cashAndDepositsJpy?: number

  /**
   * @generated from field: google.protobuf.DoubleValue accounts_receivable_jpy = 19;
   */
  accountsReceivableJpy?: number

  /**
   * @generated from field: google.protobuf.DoubleValue inventories_jpy = 20;
   */
  inventoriesJpy?: number

  /**
   * @generated from field: google.protobuf.DoubleValue property_plant_equipment_jpy = 21;
   */
  propertyPlantEquipmentJpy?: number

  /**
   * @generated from field: google.protobuf.DoubleValue total_assets_jpy = 22;
   */
  totalAssetsJpy?: number

  /**
   * @generated from field: google.protobuf.Struct column_missing_reason = 23;
   */
  columnMissingReason?: Struct

  /**
   * @generated from field: google.protobuf.Struct calculation_dependency = 24;
   */
  calculationDependency?: Struct

  constructor(data?: PartialMessage<UsecaseTableBsHighlight>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.UsecaseTableBsHighlight'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'edinet_file_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'submission_date', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'edinet_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'filer_name', kind: 'message', T: StringValue },
    { no: 6, name: 'sec_code', kind: 'message', T: StringValue },
    { no: 7, name: 'doc_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 8, name: 'doc_description', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 9, name: 'securities_report_chunk_ids', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: 'original_filename', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 11, name: 'period_start', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 12, name: 'period_end', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 13, name: 'doc_type_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 14, name: 'fiscal_year_end_year', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 15, name: 'fiscal_year_end_month', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 16, name: 'unit', kind: 'message', T: DoubleValue },
    { no: 17, name: 'unit_text', kind: 'message', T: StringValue },
    { no: 18, name: 'cash_and_deposits_jpy', kind: 'message', T: DoubleValue },
    { no: 19, name: 'accounts_receivable_jpy', kind: 'message', T: DoubleValue },
    { no: 20, name: 'inventories_jpy', kind: 'message', T: DoubleValue },
    { no: 21, name: 'property_plant_equipment_jpy', kind: 'message', T: DoubleValue },
    { no: 22, name: 'total_assets_jpy', kind: 'message', T: DoubleValue },
    { no: 23, name: 'column_missing_reason', kind: 'message', T: Struct },
    { no: 24, name: 'calculation_dependency', kind: 'message', T: Struct },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UsecaseTableBsHighlight {
    return new UsecaseTableBsHighlight().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UsecaseTableBsHighlight {
    return new UsecaseTableBsHighlight().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UsecaseTableBsHighlight {
    return new UsecaseTableBsHighlight().fromJsonString(jsonString, options)
  }

  static equals(
    a: UsecaseTableBsHighlight | PlainMessage<UsecaseTableBsHighlight> | undefined,
    b: UsecaseTableBsHighlight | PlainMessage<UsecaseTableBsHighlight> | undefined,
  ): boolean {
    return proto3.util.equals(UsecaseTableBsHighlight, a, b)
  }
}

/**
 * @generated from message models.UsecaseTableCfHighlight
 */
export class UsecaseTableCfHighlight extends Message<UsecaseTableCfHighlight> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string edinet_file_id = 2;
   */
  edinetFileId = ''

  /**
   * @generated from field: string submission_date = 3;
   */
  submissionDate = ''

  /**
   * @generated from field: string edinet_code = 4;
   */
  edinetCode = ''

  /**
   * @generated from field: google.protobuf.StringValue filer_name = 5;
   */
  filerName?: string

  /**
   * @generated from field: google.protobuf.StringValue sec_code = 6;
   */
  secCode?: string

  /**
   * @generated from field: string doc_id = 7;
   */
  docId = ''

  /**
   * @generated from field: string doc_description = 8;
   */
  docDescription = ''

  /**
   * @generated from field: repeated string securities_report_chunk_ids = 9;
   */
  securitiesReportChunkIds: string[] = []

  /**
   * @generated from field: string original_filename = 10;
   */
  originalFilename = ''

  /**
   * @generated from field: string period_start = 11;
   */
  periodStart = ''

  /**
   * @generated from field: string period_end = 12;
   */
  periodEnd = ''

  /**
   * @generated from field: string doc_type_code = 13;
   */
  docTypeCode = ''

  /**
   * @generated from field: double fiscal_year_end_year = 14;
   */
  fiscalYearEndYear = 0

  /**
   * @generated from field: double fiscal_year_end_month = 15;
   */
  fiscalYearEndMonth = 0

  /**
   * @generated from field: google.protobuf.DoubleValue unit = 16;
   */
  unit?: number

  /**
   * @generated from field: google.protobuf.StringValue unit_text = 17;
   */
  unitText?: string

  /**
   * @generated from field: google.protobuf.DoubleValue operating_cf_jpy = 18;
   */
  operatingCfJpy?: number

  /**
   * @generated from field: google.protobuf.DoubleValue investing_cf_jpy = 19;
   */
  investingCfJpy?: number

  /**
   * @generated from field: google.protobuf.DoubleValue financing_cf_jpy = 20;
   */
  financingCfJpy?: number

  /**
   * @generated from field: google.protobuf.DoubleValue cash_eoy_jpy = 21;
   */
  cashEoyJpy?: number

  /**
   * @generated from field: google.protobuf.Struct column_missing_reason = 22;
   */
  columnMissingReason?: Struct

  /**
   * @generated from field: google.protobuf.Struct calculation_dependency = 23;
   */
  calculationDependency?: Struct

  constructor(data?: PartialMessage<UsecaseTableCfHighlight>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.UsecaseTableCfHighlight'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'edinet_file_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'submission_date', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'edinet_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'filer_name', kind: 'message', T: StringValue },
    { no: 6, name: 'sec_code', kind: 'message', T: StringValue },
    { no: 7, name: 'doc_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 8, name: 'doc_description', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 9, name: 'securities_report_chunk_ids', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: 'original_filename', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 11, name: 'period_start', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 12, name: 'period_end', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 13, name: 'doc_type_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 14, name: 'fiscal_year_end_year', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 15, name: 'fiscal_year_end_month', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 16, name: 'unit', kind: 'message', T: DoubleValue },
    { no: 17, name: 'unit_text', kind: 'message', T: StringValue },
    { no: 18, name: 'operating_cf_jpy', kind: 'message', T: DoubleValue },
    { no: 19, name: 'investing_cf_jpy', kind: 'message', T: DoubleValue },
    { no: 20, name: 'financing_cf_jpy', kind: 'message', T: DoubleValue },
    { no: 21, name: 'cash_eoy_jpy', kind: 'message', T: DoubleValue },
    { no: 22, name: 'column_missing_reason', kind: 'message', T: Struct },
    { no: 23, name: 'calculation_dependency', kind: 'message', T: Struct },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UsecaseTableCfHighlight {
    return new UsecaseTableCfHighlight().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UsecaseTableCfHighlight {
    return new UsecaseTableCfHighlight().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UsecaseTableCfHighlight {
    return new UsecaseTableCfHighlight().fromJsonString(jsonString, options)
  }

  static equals(
    a: UsecaseTableCfHighlight | PlainMessage<UsecaseTableCfHighlight> | undefined,
    b: UsecaseTableCfHighlight | PlainMessage<UsecaseTableCfHighlight> | undefined,
  ): boolean {
    return proto3.util.equals(UsecaseTableCfHighlight, a, b)
  }
}

/**
 * @generated from message models.UsecaseTableFundamentalsBasic
 */
export class UsecaseTableFundamentalsBasic extends Message<UsecaseTableFundamentalsBasic> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string edinet_file_id = 2;
   */
  edinetFileId = ''

  /**
   * @generated from field: string submission_date = 3;
   */
  submissionDate = ''

  /**
   * @generated from field: string edinet_code = 4;
   */
  edinetCode = ''

  /**
   * @generated from field: google.protobuf.StringValue filer_name = 5;
   */
  filerName?: string

  /**
   * @generated from field: google.protobuf.StringValue sec_code = 6;
   */
  secCode?: string

  /**
   * @generated from field: string doc_id = 7;
   */
  docId = ''

  /**
   * @generated from field: string doc_description = 8;
   */
  docDescription = ''

  /**
   * @generated from field: repeated string securities_report_chunk_ids = 9;
   */
  securitiesReportChunkIds: string[] = []

  /**
   * @generated from field: string original_filename = 10;
   */
  originalFilename = ''

  /**
   * @generated from field: string period_start = 11;
   */
  periodStart = ''

  /**
   * @generated from field: string period_end = 12;
   */
  periodEnd = ''

  /**
   * @generated from field: string doc_type_code = 13;
   */
  docTypeCode = ''

  /**
   * @generated from field: double fiscal_year_end_year = 14;
   */
  fiscalYearEndYear = 0

  /**
   * @generated from field: double fiscal_year_end_month = 15;
   */
  fiscalYearEndMonth = 0

  /**
   * @generated from field: google.protobuf.DoubleValue total_capital_etc = 16;
   */
  totalCapitalEtc?: number

  /**
   * @generated from field: google.protobuf.DoubleValue capital_surplus = 17;
   */
  capitalSurplus?: number

  /**
   * @generated from field: google.protobuf.DoubleValue shareholders_equity = 18;
   */
  shareholdersEquity?: number

  /**
   * @generated from field: google.protobuf.DoubleValue owners_equity_old = 19;
   */
  ownersEquityOld?: number

  /**
   * @generated from field: google.protobuf.DoubleValue sales_growth_rate = 20;
   */
  salesGrowthRate?: number

  /**
   * @generated from field: google.protobuf.DoubleValue cash_and_cash_equivalents = 21;
   */
  cashAndCashEquivalents?: number

  /**
   * @generated from field: google.protobuf.DoubleValue interest_bearing_debt = 22;
   */
  interestBearingDebt?: number

  /**
   * @generated from field: google.protobuf.DoubleValue net_interest_bearing_debt = 23;
   */
  netInterestBearingDebt?: number

  /**
   * @generated from field: google.protobuf.DoubleValue net_interest_bearing_debt_excl_securities = 24;
   */
  netInterestBearingDebtExclSecurities?: number

  /**
   * @generated from field: google.protobuf.DoubleValue capex_cf_tangible = 25;
   */
  capexCfTangible?: number

  /**
   * @generated from field: google.protobuf.DoubleValue capex_cf_tangible_intangible = 26;
   */
  capexCfTangibleIntangible?: number

  /**
   * @generated from field: google.protobuf.DoubleValue invested_capital = 27;
   */
  investedCapital?: number

  /**
   * @generated from field: google.protobuf.DoubleValue business_assets = 28;
   */
  businessAssets?: number

  /**
   * @generated from field: google.protobuf.DoubleValue working_capital = 29;
   */
  workingCapital?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ebit = 30;
   */
  ebit?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ebitda = 31;
   */
  ebitda?: number

  /**
   * @generated from field: google.protobuf.DoubleValue nopat = 32;
   */
  nopat?: number

  /**
   * @generated from field: google.protobuf.DoubleValue free_cash_flow = 33;
   */
  freeCashFlow?: number

  /**
   * @generated from field: google.protobuf.DoubleValue personnel_expenses_total = 34;
   */
  personnelExpensesTotal?: number

  /**
   * @generated from field: google.protobuf.DoubleValue personnel_expenses = 35;
   */
  personnelExpenses?: number

  /**
   * @generated from field: google.protobuf.DoubleValue labor_cost = 36;
   */
  laborCost?: number

  /**
   * @generated from field: google.protobuf.Struct column_missing_reason = 37;
   */
  columnMissingReason?: Struct

  /**
   * @generated from field: google.protobuf.Struct calculation_dependency = 38;
   */
  calculationDependency?: Struct

  constructor(data?: PartialMessage<UsecaseTableFundamentalsBasic>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.UsecaseTableFundamentalsBasic'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'edinet_file_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'submission_date', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'edinet_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'filer_name', kind: 'message', T: StringValue },
    { no: 6, name: 'sec_code', kind: 'message', T: StringValue },
    { no: 7, name: 'doc_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 8, name: 'doc_description', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 9, name: 'securities_report_chunk_ids', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: 'original_filename', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 11, name: 'period_start', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 12, name: 'period_end', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 13, name: 'doc_type_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 14, name: 'fiscal_year_end_year', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 15, name: 'fiscal_year_end_month', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 16, name: 'total_capital_etc', kind: 'message', T: DoubleValue },
    { no: 17, name: 'capital_surplus', kind: 'message', T: DoubleValue },
    { no: 18, name: 'shareholders_equity', kind: 'message', T: DoubleValue },
    { no: 19, name: 'owners_equity_old', kind: 'message', T: DoubleValue },
    { no: 20, name: 'sales_growth_rate', kind: 'message', T: DoubleValue },
    { no: 21, name: 'cash_and_cash_equivalents', kind: 'message', T: DoubleValue },
    { no: 22, name: 'interest_bearing_debt', kind: 'message', T: DoubleValue },
    { no: 23, name: 'net_interest_bearing_debt', kind: 'message', T: DoubleValue },
    { no: 24, name: 'net_interest_bearing_debt_excl_securities', kind: 'message', T: DoubleValue },
    { no: 25, name: 'capex_cf_tangible', kind: 'message', T: DoubleValue },
    { no: 26, name: 'capex_cf_tangible_intangible', kind: 'message', T: DoubleValue },
    { no: 27, name: 'invested_capital', kind: 'message', T: DoubleValue },
    { no: 28, name: 'business_assets', kind: 'message', T: DoubleValue },
    { no: 29, name: 'working_capital', kind: 'message', T: DoubleValue },
    { no: 30, name: 'ebit', kind: 'message', T: DoubleValue },
    { no: 31, name: 'ebitda', kind: 'message', T: DoubleValue },
    { no: 32, name: 'nopat', kind: 'message', T: DoubleValue },
    { no: 33, name: 'free_cash_flow', kind: 'message', T: DoubleValue },
    { no: 34, name: 'personnel_expenses_total', kind: 'message', T: DoubleValue },
    { no: 35, name: 'personnel_expenses', kind: 'message', T: DoubleValue },
    { no: 36, name: 'labor_cost', kind: 'message', T: DoubleValue },
    { no: 37, name: 'column_missing_reason', kind: 'message', T: Struct },
    { no: 38, name: 'calculation_dependency', kind: 'message', T: Struct },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UsecaseTableFundamentalsBasic {
    return new UsecaseTableFundamentalsBasic().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UsecaseTableFundamentalsBasic {
    return new UsecaseTableFundamentalsBasic().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UsecaseTableFundamentalsBasic {
    return new UsecaseTableFundamentalsBasic().fromJsonString(jsonString, options)
  }

  static equals(
    a: UsecaseTableFundamentalsBasic | PlainMessage<UsecaseTableFundamentalsBasic> | undefined,
    b: UsecaseTableFundamentalsBasic | PlainMessage<UsecaseTableFundamentalsBasic> | undefined,
  ): boolean {
    return proto3.util.equals(UsecaseTableFundamentalsBasic, a, b)
  }
}

/**
 * @generated from message models.UsecaseTableFundamentalsGrowth
 */
export class UsecaseTableFundamentalsGrowth extends Message<UsecaseTableFundamentalsGrowth> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string edinet_file_id = 2;
   */
  edinetFileId = ''

  /**
   * @generated from field: string submission_date = 3;
   */
  submissionDate = ''

  /**
   * @generated from field: string edinet_code = 4;
   */
  edinetCode = ''

  /**
   * @generated from field: google.protobuf.StringValue filer_name = 5;
   */
  filerName?: string

  /**
   * @generated from field: google.protobuf.StringValue sec_code = 6;
   */
  secCode?: string

  /**
   * @generated from field: string doc_id = 7;
   */
  docId = ''

  /**
   * @generated from field: string doc_description = 8;
   */
  docDescription = ''

  /**
   * @generated from field: repeated string securities_report_chunk_ids = 9;
   */
  securitiesReportChunkIds: string[] = []

  /**
   * @generated from field: string original_filename = 10;
   */
  originalFilename = ''

  /**
   * @generated from field: string period_start = 11;
   */
  periodStart = ''

  /**
   * @generated from field: string period_end = 12;
   */
  periodEnd = ''

  /**
   * @generated from field: string doc_type_code = 13;
   */
  docTypeCode = ''

  /**
   * @generated from field: double fiscal_year_end_year = 14;
   */
  fiscalYearEndYear = 0

  /**
   * @generated from field: double fiscal_year_end_month = 15;
   */
  fiscalYearEndMonth = 0

  /**
   * @generated from field: google.protobuf.DoubleValue sales_growth_rate = 16;
   */
  salesGrowthRate?: number

  /**
   * @generated from field: google.protobuf.DoubleValue operating_profit_growth_rate = 17;
   */
  operatingProfitGrowthRate?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ordinary_profit_growth_rate = 18;
   */
  ordinaryProfitGrowthRate?: number

  /**
   * @generated from field: google.protobuf.DoubleValue net_profit_growth_rate = 19;
   */
  netProfitGrowthRate?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ebitda_growth_rate = 20;
   */
  ebitdaGrowthRate?: number

  /**
   * @generated from field: google.protobuf.DoubleValue eps_growth_rate = 21;
   */
  epsGrowthRate?: number

  /**
   * @generated from field: google.protobuf.DoubleValue diluted_eps_growth_rate = 22;
   */
  dilutedEpsGrowthRate?: number

  /**
   * @generated from field: google.protobuf.DoubleValue total_assets_growth_rate = 23;
   */
  totalAssetsGrowthRate?: number

  /**
   * @generated from field: google.protobuf.DoubleValue employees_growth_rate = 24;
   */
  employeesGrowthRate?: number

  /**
   * @generated from field: google.protobuf.DoubleValue sga_growth_rate = 25;
   */
  sgaGrowthRate?: number

  /**
   * @generated from field: google.protobuf.DoubleValue personnel_expenses_growth_rate = 26;
   */
  personnelExpensesGrowthRate?: number

  /**
   * @generated from field: google.protobuf.DoubleValue advertising_expenses_growth_rate = 27;
   */
  advertisingExpensesGrowthRate?: number

  /**
   * @generated from field: google.protobuf.DoubleValue rd_expenses_growth_rate = 28;
   */
  rdExpensesGrowthRate?: number

  /**
   * @generated from field: google.protobuf.DoubleValue capex_growth_rate = 29;
   */
  capexGrowthRate?: number

  /**
   * @generated from field: google.protobuf.Struct column_missing_reason = 30;
   */
  columnMissingReason?: Struct

  /**
   * @generated from field: google.protobuf.Struct calculation_dependency = 31;
   */
  calculationDependency?: Struct

  constructor(data?: PartialMessage<UsecaseTableFundamentalsGrowth>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.UsecaseTableFundamentalsGrowth'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'edinet_file_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'submission_date', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'edinet_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'filer_name', kind: 'message', T: StringValue },
    { no: 6, name: 'sec_code', kind: 'message', T: StringValue },
    { no: 7, name: 'doc_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 8, name: 'doc_description', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 9, name: 'securities_report_chunk_ids', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: 'original_filename', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 11, name: 'period_start', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 12, name: 'period_end', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 13, name: 'doc_type_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 14, name: 'fiscal_year_end_year', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 15, name: 'fiscal_year_end_month', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 16, name: 'sales_growth_rate', kind: 'message', T: DoubleValue },
    { no: 17, name: 'operating_profit_growth_rate', kind: 'message', T: DoubleValue },
    { no: 18, name: 'ordinary_profit_growth_rate', kind: 'message', T: DoubleValue },
    { no: 19, name: 'net_profit_growth_rate', kind: 'message', T: DoubleValue },
    { no: 20, name: 'ebitda_growth_rate', kind: 'message', T: DoubleValue },
    { no: 21, name: 'eps_growth_rate', kind: 'message', T: DoubleValue },
    { no: 22, name: 'diluted_eps_growth_rate', kind: 'message', T: DoubleValue },
    { no: 23, name: 'total_assets_growth_rate', kind: 'message', T: DoubleValue },
    { no: 24, name: 'employees_growth_rate', kind: 'message', T: DoubleValue },
    { no: 25, name: 'sga_growth_rate', kind: 'message', T: DoubleValue },
    { no: 26, name: 'personnel_expenses_growth_rate', kind: 'message', T: DoubleValue },
    { no: 27, name: 'advertising_expenses_growth_rate', kind: 'message', T: DoubleValue },
    { no: 28, name: 'rd_expenses_growth_rate', kind: 'message', T: DoubleValue },
    { no: 29, name: 'capex_growth_rate', kind: 'message', T: DoubleValue },
    { no: 30, name: 'column_missing_reason', kind: 'message', T: Struct },
    { no: 31, name: 'calculation_dependency', kind: 'message', T: Struct },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UsecaseTableFundamentalsGrowth {
    return new UsecaseTableFundamentalsGrowth().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UsecaseTableFundamentalsGrowth {
    return new UsecaseTableFundamentalsGrowth().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UsecaseTableFundamentalsGrowth {
    return new UsecaseTableFundamentalsGrowth().fromJsonString(jsonString, options)
  }

  static equals(
    a: UsecaseTableFundamentalsGrowth | PlainMessage<UsecaseTableFundamentalsGrowth> | undefined,
    b: UsecaseTableFundamentalsGrowth | PlainMessage<UsecaseTableFundamentalsGrowth> | undefined,
  ): boolean {
    return proto3.util.equals(UsecaseTableFundamentalsGrowth, a, b)
  }
}

/**
 * @generated from message models.UsecaseTableFundamentalsProfitability
 */
export class UsecaseTableFundamentalsProfitability extends Message<UsecaseTableFundamentalsProfitability> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string edinet_file_id = 2;
   */
  edinetFileId = ''

  /**
   * @generated from field: string submission_date = 3;
   */
  submissionDate = ''

  /**
   * @generated from field: string edinet_code = 4;
   */
  edinetCode = ''

  /**
   * @generated from field: google.protobuf.StringValue filer_name = 5;
   */
  filerName?: string

  /**
   * @generated from field: google.protobuf.StringValue sec_code = 6;
   */
  secCode?: string

  /**
   * @generated from field: string doc_id = 7;
   */
  docId = ''

  /**
   * @generated from field: string doc_description = 8;
   */
  docDescription = ''

  /**
   * @generated from field: repeated string securities_report_chunk_ids = 9;
   */
  securitiesReportChunkIds: string[] = []

  /**
   * @generated from field: string original_filename = 10;
   */
  originalFilename = ''

  /**
   * @generated from field: string period_start = 11;
   */
  periodStart = ''

  /**
   * @generated from field: string period_end = 12;
   */
  periodEnd = ''

  /**
   * @generated from field: string doc_type_code = 13;
   */
  docTypeCode = ''

  /**
   * @generated from field: double fiscal_year_end_year = 14;
   */
  fiscalYearEndYear = 0

  /**
   * @generated from field: double fiscal_year_end_month = 15;
   */
  fiscalYearEndMonth = 0

  /**
   * @generated from field: google.protobuf.DoubleValue gross_profit_margin = 16;
   */
  grossProfitMargin?: number

  /**
   * @generated from field: google.protobuf.DoubleValue sga_ratio = 17;
   */
  sgaRatio?: number

  /**
   * @generated from field: google.protobuf.DoubleValue operating_profit_margin = 18;
   */
  operatingProfitMargin?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ordinary_profit_margin = 19;
   */
  ordinaryProfitMargin?: number

  /**
   * @generated from field: google.protobuf.DoubleValue pretax_profit_margin = 20;
   */
  pretaxProfitMargin?: number

  /**
   * @generated from field: google.protobuf.DoubleValue net_profit_margin = 21;
   */
  netProfitMargin?: number

  /**
   * @generated from field: google.protobuf.DoubleValue parent_net_profit_margin = 22;
   */
  parentNetProfitMargin?: number

  /**
   * @generated from field: google.protobuf.DoubleValue comprehensive_income_margin = 23;
   */
  comprehensiveIncomeMargin?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ebitda_margin = 24;
   */
  ebitdaMargin?: number

  /**
   * @generated from field: google.protobuf.DoubleValue operating_cf_margin = 25;
   */
  operatingCfMargin?: number

  /**
   * @generated from field: google.protobuf.DoubleValue cost_of_sales_ratio = 26;
   */
  costOfSalesRatio?: number

  /**
   * @generated from field: google.protobuf.DoubleValue personnel_expenses_ratio = 27;
   */
  personnelExpensesRatio?: number

  /**
   * @generated from field: google.protobuf.DoubleValue personnel_expenses_sga_ratio = 28;
   */
  personnelExpensesSgaRatio?: number

  /**
   * @generated from field: google.protobuf.DoubleValue labor_cost_ratio = 29;
   */
  laborCostRatio?: number

  /**
   * @generated from field: google.protobuf.DoubleValue rd_ratio = 30;
   */
  rdRatio?: number

  /**
   * @generated from field: google.protobuf.DoubleValue rent_ratio = 31;
   */
  rentRatio?: number

  /**
   * @generated from field: google.protobuf.DoubleValue advertising_ratio = 32;
   */
  advertisingRatio?: number

  /**
   * @generated from field: google.protobuf.Struct column_missing_reason = 33;
   */
  columnMissingReason?: Struct

  /**
   * @generated from field: google.protobuf.Struct calculation_dependency = 34;
   */
  calculationDependency?: Struct

  constructor(data?: PartialMessage<UsecaseTableFundamentalsProfitability>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.UsecaseTableFundamentalsProfitability'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'edinet_file_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'submission_date', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'edinet_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'filer_name', kind: 'message', T: StringValue },
    { no: 6, name: 'sec_code', kind: 'message', T: StringValue },
    { no: 7, name: 'doc_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 8, name: 'doc_description', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 9, name: 'securities_report_chunk_ids', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: 'original_filename', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 11, name: 'period_start', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 12, name: 'period_end', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 13, name: 'doc_type_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 14, name: 'fiscal_year_end_year', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 15, name: 'fiscal_year_end_month', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 16, name: 'gross_profit_margin', kind: 'message', T: DoubleValue },
    { no: 17, name: 'sga_ratio', kind: 'message', T: DoubleValue },
    { no: 18, name: 'operating_profit_margin', kind: 'message', T: DoubleValue },
    { no: 19, name: 'ordinary_profit_margin', kind: 'message', T: DoubleValue },
    { no: 20, name: 'pretax_profit_margin', kind: 'message', T: DoubleValue },
    { no: 21, name: 'net_profit_margin', kind: 'message', T: DoubleValue },
    { no: 22, name: 'parent_net_profit_margin', kind: 'message', T: DoubleValue },
    { no: 23, name: 'comprehensive_income_margin', kind: 'message', T: DoubleValue },
    { no: 24, name: 'ebitda_margin', kind: 'message', T: DoubleValue },
    { no: 25, name: 'operating_cf_margin', kind: 'message', T: DoubleValue },
    { no: 26, name: 'cost_of_sales_ratio', kind: 'message', T: DoubleValue },
    { no: 27, name: 'personnel_expenses_ratio', kind: 'message', T: DoubleValue },
    { no: 28, name: 'personnel_expenses_sga_ratio', kind: 'message', T: DoubleValue },
    { no: 29, name: 'labor_cost_ratio', kind: 'message', T: DoubleValue },
    { no: 30, name: 'rd_ratio', kind: 'message', T: DoubleValue },
    { no: 31, name: 'rent_ratio', kind: 'message', T: DoubleValue },
    { no: 32, name: 'advertising_ratio', kind: 'message', T: DoubleValue },
    { no: 33, name: 'column_missing_reason', kind: 'message', T: Struct },
    { no: 34, name: 'calculation_dependency', kind: 'message', T: Struct },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UsecaseTableFundamentalsProfitability {
    return new UsecaseTableFundamentalsProfitability().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UsecaseTableFundamentalsProfitability {
    return new UsecaseTableFundamentalsProfitability().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UsecaseTableFundamentalsProfitability {
    return new UsecaseTableFundamentalsProfitability().fromJsonString(jsonString, options)
  }

  static equals(
    a: UsecaseTableFundamentalsProfitability | PlainMessage<UsecaseTableFundamentalsProfitability> | undefined,
    b: UsecaseTableFundamentalsProfitability | PlainMessage<UsecaseTableFundamentalsProfitability> | undefined,
  ): boolean {
    return proto3.util.equals(UsecaseTableFundamentalsProfitability, a, b)
  }
}

/**
 * @generated from message models.UsecaseTableFundamentalsProductivity
 */
export class UsecaseTableFundamentalsProductivity extends Message<UsecaseTableFundamentalsProductivity> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string edinet_file_id = 2;
   */
  edinetFileId = ''

  /**
   * @generated from field: string submission_date = 3;
   */
  submissionDate = ''

  /**
   * @generated from field: string edinet_code = 4;
   */
  edinetCode = ''

  /**
   * @generated from field: google.protobuf.StringValue filer_name = 5;
   */
  filerName?: string

  /**
   * @generated from field: google.protobuf.StringValue sec_code = 6;
   */
  secCode?: string

  /**
   * @generated from field: string doc_id = 7;
   */
  docId = ''

  /**
   * @generated from field: string doc_description = 8;
   */
  docDescription = ''

  /**
   * @generated from field: repeated string securities_report_chunk_ids = 9;
   */
  securitiesReportChunkIds: string[] = []

  /**
   * @generated from field: string original_filename = 10;
   */
  originalFilename = ''

  /**
   * @generated from field: string period_start = 11;
   */
  periodStart = ''

  /**
   * @generated from field: string period_end = 12;
   */
  periodEnd = ''

  /**
   * @generated from field: string doc_type_code = 13;
   */
  docTypeCode = ''

  /**
   * @generated from field: double fiscal_year_end_year = 14;
   */
  fiscalYearEndYear = 0

  /**
   * @generated from field: double fiscal_year_end_month = 15;
   */
  fiscalYearEndMonth = 0

  /**
   * @generated from field: google.protobuf.DoubleValue sales_per_employee = 16;
   */
  salesPerEmployee?: number

  /**
   * @generated from field: google.protobuf.DoubleValue operating_profit_per_employee = 17;
   */
  operatingProfitPerEmployee?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ordinary_profit_per_employee = 18;
   */
  ordinaryProfitPerEmployee?: number

  /**
   * @generated from field: google.protobuf.DoubleValue net_profit_per_employee = 19;
   */
  netProfitPerEmployee?: number

  /**
   * @generated from field: google.protobuf.DoubleValue operating_cf_per_employee = 20;
   */
  operatingCfPerEmployee?: number

  /**
   * @generated from field: google.protobuf.Struct column_missing_reason = 21;
   */
  columnMissingReason?: Struct

  /**
   * @generated from field: google.protobuf.Struct calculation_dependency = 22;
   */
  calculationDependency?: Struct

  constructor(data?: PartialMessage<UsecaseTableFundamentalsProductivity>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.UsecaseTableFundamentalsProductivity'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'edinet_file_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'submission_date', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'edinet_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'filer_name', kind: 'message', T: StringValue },
    { no: 6, name: 'sec_code', kind: 'message', T: StringValue },
    { no: 7, name: 'doc_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 8, name: 'doc_description', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 9, name: 'securities_report_chunk_ids', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: 'original_filename', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 11, name: 'period_start', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 12, name: 'period_end', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 13, name: 'doc_type_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 14, name: 'fiscal_year_end_year', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 15, name: 'fiscal_year_end_month', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 16, name: 'sales_per_employee', kind: 'message', T: DoubleValue },
    { no: 17, name: 'operating_profit_per_employee', kind: 'message', T: DoubleValue },
    { no: 18, name: 'ordinary_profit_per_employee', kind: 'message', T: DoubleValue },
    { no: 19, name: 'net_profit_per_employee', kind: 'message', T: DoubleValue },
    { no: 20, name: 'operating_cf_per_employee', kind: 'message', T: DoubleValue },
    { no: 21, name: 'column_missing_reason', kind: 'message', T: Struct },
    { no: 22, name: 'calculation_dependency', kind: 'message', T: Struct },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UsecaseTableFundamentalsProductivity {
    return new UsecaseTableFundamentalsProductivity().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UsecaseTableFundamentalsProductivity {
    return new UsecaseTableFundamentalsProductivity().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UsecaseTableFundamentalsProductivity {
    return new UsecaseTableFundamentalsProductivity().fromJsonString(jsonString, options)
  }

  static equals(
    a: UsecaseTableFundamentalsProductivity | PlainMessage<UsecaseTableFundamentalsProductivity> | undefined,
    b: UsecaseTableFundamentalsProductivity | PlainMessage<UsecaseTableFundamentalsProductivity> | undefined,
  ): boolean {
    return proto3.util.equals(UsecaseTableFundamentalsProductivity, a, b)
  }
}

/**
 * @generated from message models.UsecaseTableFundamentalsEfficiency
 */
export class UsecaseTableFundamentalsEfficiency extends Message<UsecaseTableFundamentalsEfficiency> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string edinet_file_id = 2;
   */
  edinetFileId = ''

  /**
   * @generated from field: string submission_date = 3;
   */
  submissionDate = ''

  /**
   * @generated from field: string edinet_code = 4;
   */
  edinetCode = ''

  /**
   * @generated from field: google.protobuf.StringValue filer_name = 5;
   */
  filerName?: string

  /**
   * @generated from field: google.protobuf.StringValue sec_code = 6;
   */
  secCode?: string

  /**
   * @generated from field: string doc_id = 7;
   */
  docId = ''

  /**
   * @generated from field: string doc_description = 8;
   */
  docDescription = ''

  /**
   * @generated from field: repeated string securities_report_chunk_ids = 9;
   */
  securitiesReportChunkIds: string[] = []

  /**
   * @generated from field: string original_filename = 10;
   */
  originalFilename = ''

  /**
   * @generated from field: string period_start = 11;
   */
  periodStart = ''

  /**
   * @generated from field: string period_end = 12;
   */
  periodEnd = ''

  /**
   * @generated from field: string doc_type_code = 13;
   */
  docTypeCode = ''

  /**
   * @generated from field: double fiscal_year_end_year = 14;
   */
  fiscalYearEndYear = 0

  /**
   * @generated from field: double fiscal_year_end_month = 15;
   */
  fiscalYearEndMonth = 0

  /**
   * @generated from field: google.protobuf.DoubleValue roe = 16;
   */
  roe?: number

  /**
   * @generated from field: google.protobuf.DoubleValue roa = 17;
   */
  roa?: number

  /**
   * @generated from field: google.protobuf.DoubleValue roic_invested_capital = 18;
   */
  roicInvestedCapital?: number

  /**
   * @generated from field: google.protobuf.DoubleValue roic_business_assets = 19;
   */
  roicBusinessAssets?: number

  /**
   * @generated from field: google.protobuf.DoubleValue total_assets_ordinary_profit_ratio = 20;
   */
  totalAssetsOrdinaryProfitRatio?: number

  /**
   * @generated from field: google.protobuf.DoubleValue total_assets_turnover = 21;
   */
  totalAssetsTurnover?: number

  /**
   * @generated from field: google.protobuf.DoubleValue receivables_turnover = 22;
   */
  receivablesTurnover?: number

  /**
   * @generated from field: google.protobuf.DoubleValue inventory_turnover = 23;
   */
  inventoryTurnover?: number

  /**
   * @generated from field: google.protobuf.DoubleValue payables_turnover = 24;
   */
  payablesTurnover?: number

  /**
   * @generated from field: google.protobuf.DoubleValue advance_payments_turnover = 25;
   */
  advancePaymentsTurnover?: number

  /**
   * @generated from field: google.protobuf.DoubleValue prepaid_expenses_turnover = 26;
   */
  prepaidExpensesTurnover?: number

  /**
   * @generated from field: google.protobuf.DoubleValue advances_received_turnover = 27;
   */
  advancesReceivedTurnover?: number

  /**
   * @generated from field: google.protobuf.DoubleValue deferred_revenue_turnover = 28;
   */
  deferredRevenueTurnover?: number

  /**
   * @generated from field: google.protobuf.DoubleValue receivables_turnover_period = 29;
   */
  receivablesTurnoverPeriod?: number

  /**
   * @generated from field: google.protobuf.DoubleValue inventory_turnover_period = 30;
   */
  inventoryTurnoverPeriod?: number

  /**
   * @generated from field: google.protobuf.DoubleValue payables_turnover_period = 31;
   */
  payablesTurnoverPeriod?: number

  /**
   * @generated from field: google.protobuf.DoubleValue advance_payments_turnover_period = 32;
   */
  advancePaymentsTurnoverPeriod?: number

  /**
   * @generated from field: google.protobuf.DoubleValue prepaid_expenses_turnover_period = 33;
   */
  prepaidExpensesTurnoverPeriod?: number

  /**
   * @generated from field: google.protobuf.DoubleValue advances_received_turnover_period = 34;
   */
  advancesReceivedTurnoverPeriod?: number

  /**
   * @generated from field: google.protobuf.DoubleValue deferred_revenue_turnover_period = 35;
   */
  deferredRevenueTurnoverPeriod?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ccc = 36;
   */
  ccc?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ccc_adjusted = 37;
   */
  cccAdjusted?: number

  /**
   * @generated from field: google.protobuf.Struct column_missing_reason = 38;
   */
  columnMissingReason?: Struct

  /**
   * @generated from field: google.protobuf.Struct calculation_dependency = 39;
   */
  calculationDependency?: Struct

  constructor(data?: PartialMessage<UsecaseTableFundamentalsEfficiency>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.UsecaseTableFundamentalsEfficiency'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'edinet_file_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'submission_date', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'edinet_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'filer_name', kind: 'message', T: StringValue },
    { no: 6, name: 'sec_code', kind: 'message', T: StringValue },
    { no: 7, name: 'doc_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 8, name: 'doc_description', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 9, name: 'securities_report_chunk_ids', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: 'original_filename', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 11, name: 'period_start', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 12, name: 'period_end', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 13, name: 'doc_type_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 14, name: 'fiscal_year_end_year', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 15, name: 'fiscal_year_end_month', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 16, name: 'roe', kind: 'message', T: DoubleValue },
    { no: 17, name: 'roa', kind: 'message', T: DoubleValue },
    { no: 18, name: 'roic_invested_capital', kind: 'message', T: DoubleValue },
    { no: 19, name: 'roic_business_assets', kind: 'message', T: DoubleValue },
    { no: 20, name: 'total_assets_ordinary_profit_ratio', kind: 'message', T: DoubleValue },
    { no: 21, name: 'total_assets_turnover', kind: 'message', T: DoubleValue },
    { no: 22, name: 'receivables_turnover', kind: 'message', T: DoubleValue },
    { no: 23, name: 'inventory_turnover', kind: 'message', T: DoubleValue },
    { no: 24, name: 'payables_turnover', kind: 'message', T: DoubleValue },
    { no: 25, name: 'advance_payments_turnover', kind: 'message', T: DoubleValue },
    { no: 26, name: 'prepaid_expenses_turnover', kind: 'message', T: DoubleValue },
    { no: 27, name: 'advances_received_turnover', kind: 'message', T: DoubleValue },
    { no: 28, name: 'deferred_revenue_turnover', kind: 'message', T: DoubleValue },
    { no: 29, name: 'receivables_turnover_period', kind: 'message', T: DoubleValue },
    { no: 30, name: 'inventory_turnover_period', kind: 'message', T: DoubleValue },
    { no: 31, name: 'payables_turnover_period', kind: 'message', T: DoubleValue },
    { no: 32, name: 'advance_payments_turnover_period', kind: 'message', T: DoubleValue },
    { no: 33, name: 'prepaid_expenses_turnover_period', kind: 'message', T: DoubleValue },
    { no: 34, name: 'advances_received_turnover_period', kind: 'message', T: DoubleValue },
    { no: 35, name: 'deferred_revenue_turnover_period', kind: 'message', T: DoubleValue },
    { no: 36, name: 'ccc', kind: 'message', T: DoubleValue },
    { no: 37, name: 'ccc_adjusted', kind: 'message', T: DoubleValue },
    { no: 38, name: 'column_missing_reason', kind: 'message', T: Struct },
    { no: 39, name: 'calculation_dependency', kind: 'message', T: Struct },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UsecaseTableFundamentalsEfficiency {
    return new UsecaseTableFundamentalsEfficiency().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UsecaseTableFundamentalsEfficiency {
    return new UsecaseTableFundamentalsEfficiency().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UsecaseTableFundamentalsEfficiency {
    return new UsecaseTableFundamentalsEfficiency().fromJsonString(jsonString, options)
  }

  static equals(
    a: UsecaseTableFundamentalsEfficiency | PlainMessage<UsecaseTableFundamentalsEfficiency> | undefined,
    b: UsecaseTableFundamentalsEfficiency | PlainMessage<UsecaseTableFundamentalsEfficiency> | undefined,
  ): boolean {
    return proto3.util.equals(UsecaseTableFundamentalsEfficiency, a, b)
  }
}

/**
 * @generated from message models.UsecaseTableFundamentalsSafetyLeverage
 */
export class UsecaseTableFundamentalsSafetyLeverage extends Message<UsecaseTableFundamentalsSafetyLeverage> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string edinet_file_id = 2;
   */
  edinetFileId = ''

  /**
   * @generated from field: string submission_date = 3;
   */
  submissionDate = ''

  /**
   * @generated from field: string edinet_code = 4;
   */
  edinetCode = ''

  /**
   * @generated from field: google.protobuf.StringValue filer_name = 5;
   */
  filerName?: string

  /**
   * @generated from field: google.protobuf.StringValue sec_code = 6;
   */
  secCode?: string

  /**
   * @generated from field: string doc_id = 7;
   */
  docId = ''

  /**
   * @generated from field: string doc_description = 8;
   */
  docDescription = ''

  /**
   * @generated from field: repeated string securities_report_chunk_ids = 9;
   */
  securitiesReportChunkIds: string[] = []

  /**
   * @generated from field: string original_filename = 10;
   */
  originalFilename = ''

  /**
   * @generated from field: string period_start = 11;
   */
  periodStart = ''

  /**
   * @generated from field: string period_end = 12;
   */
  periodEnd = ''

  /**
   * @generated from field: string doc_type_code = 13;
   */
  docTypeCode = ''

  /**
   * @generated from field: double fiscal_year_end_year = 14;
   */
  fiscalYearEndYear = 0

  /**
   * @generated from field: double fiscal_year_end_month = 15;
   */
  fiscalYearEndMonth = 0

  /**
   * @generated from field: google.protobuf.DoubleValue equity_ratio = 16;
   */
  equityRatio?: number

  /**
   * @generated from field: google.protobuf.DoubleValue financial_leverage = 17;
   */
  financialLeverage?: number

  /**
   * @generated from field: google.protobuf.DoubleValue de_ratio = 18;
   */
  deRatio?: number

  /**
   * @generated from field: google.protobuf.DoubleValue net_de_ratio = 19;
   */
  netDeRatio?: number

  /**
   * @generated from field: google.protobuf.DoubleValue debt_ebitda_ratio = 20;
   */
  debtEbitdaRatio?: number

  /**
   * @generated from field: google.protobuf.DoubleValue net_debt_ebitda_ratio = 21;
   */
  netDebtEbitdaRatio?: number

  /**
   * @generated from field: google.protobuf.DoubleValue debt_operating_cf_ratio = 22;
   */
  debtOperatingCfRatio?: number

  /**
   * @generated from field: google.protobuf.DoubleValue net_debt_operating_cf_ratio = 23;
   */
  netDebtOperatingCfRatio?: number

  /**
   * @generated from field: google.protobuf.DoubleValue debt_fcf_ratio = 24;
   */
  debtFcfRatio?: number

  /**
   * @generated from field: google.protobuf.DoubleValue net_debt_fcf_ratio = 25;
   */
  netDebtFcfRatio?: number

  /**
   * @generated from field: google.protobuf.DoubleValue interest_coverage_ratio = 26;
   */
  interestCoverageRatio?: number

  /**
   * @generated from field: google.protobuf.Struct column_missing_reason = 27;
   */
  columnMissingReason?: Struct

  /**
   * @generated from field: google.protobuf.Struct calculation_dependency = 28;
   */
  calculationDependency?: Struct

  constructor(data?: PartialMessage<UsecaseTableFundamentalsSafetyLeverage>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.UsecaseTableFundamentalsSafetyLeverage'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'edinet_file_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'submission_date', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'edinet_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'filer_name', kind: 'message', T: StringValue },
    { no: 6, name: 'sec_code', kind: 'message', T: StringValue },
    { no: 7, name: 'doc_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 8, name: 'doc_description', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 9, name: 'securities_report_chunk_ids', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: 'original_filename', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 11, name: 'period_start', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 12, name: 'period_end', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 13, name: 'doc_type_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 14, name: 'fiscal_year_end_year', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 15, name: 'fiscal_year_end_month', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 16, name: 'equity_ratio', kind: 'message', T: DoubleValue },
    { no: 17, name: 'financial_leverage', kind: 'message', T: DoubleValue },
    { no: 18, name: 'de_ratio', kind: 'message', T: DoubleValue },
    { no: 19, name: 'net_de_ratio', kind: 'message', T: DoubleValue },
    { no: 20, name: 'debt_ebitda_ratio', kind: 'message', T: DoubleValue },
    { no: 21, name: 'net_debt_ebitda_ratio', kind: 'message', T: DoubleValue },
    { no: 22, name: 'debt_operating_cf_ratio', kind: 'message', T: DoubleValue },
    { no: 23, name: 'net_debt_operating_cf_ratio', kind: 'message', T: DoubleValue },
    { no: 24, name: 'debt_fcf_ratio', kind: 'message', T: DoubleValue },
    { no: 25, name: 'net_debt_fcf_ratio', kind: 'message', T: DoubleValue },
    { no: 26, name: 'interest_coverage_ratio', kind: 'message', T: DoubleValue },
    { no: 27, name: 'column_missing_reason', kind: 'message', T: Struct },
    { no: 28, name: 'calculation_dependency', kind: 'message', T: Struct },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UsecaseTableFundamentalsSafetyLeverage {
    return new UsecaseTableFundamentalsSafetyLeverage().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UsecaseTableFundamentalsSafetyLeverage {
    return new UsecaseTableFundamentalsSafetyLeverage().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UsecaseTableFundamentalsSafetyLeverage {
    return new UsecaseTableFundamentalsSafetyLeverage().fromJsonString(jsonString, options)
  }

  static equals(
    a: UsecaseTableFundamentalsSafetyLeverage | PlainMessage<UsecaseTableFundamentalsSafetyLeverage> | undefined,
    b: UsecaseTableFundamentalsSafetyLeverage | PlainMessage<UsecaseTableFundamentalsSafetyLeverage> | undefined,
  ): boolean {
    return proto3.util.equals(UsecaseTableFundamentalsSafetyLeverage, a, b)
  }
}

/**
 * @generated from message models.UsecaseTableFundamentalsLiquidity
 */
export class UsecaseTableFundamentalsLiquidity extends Message<UsecaseTableFundamentalsLiquidity> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string edinet_file_id = 2;
   */
  edinetFileId = ''

  /**
   * @generated from field: string submission_date = 3;
   */
  submissionDate = ''

  /**
   * @generated from field: string edinet_code = 4;
   */
  edinetCode = ''

  /**
   * @generated from field: google.protobuf.StringValue filer_name = 5;
   */
  filerName?: string

  /**
   * @generated from field: google.protobuf.StringValue sec_code = 6;
   */
  secCode?: string

  /**
   * @generated from field: string doc_id = 7;
   */
  docId = ''

  /**
   * @generated from field: string doc_description = 8;
   */
  docDescription = ''

  /**
   * @generated from field: repeated string securities_report_chunk_ids = 9;
   */
  securitiesReportChunkIds: string[] = []

  /**
   * @generated from field: string original_filename = 10;
   */
  originalFilename = ''

  /**
   * @generated from field: string period_start = 11;
   */
  periodStart = ''

  /**
   * @generated from field: string period_end = 12;
   */
  periodEnd = ''

  /**
   * @generated from field: string doc_type_code = 13;
   */
  docTypeCode = ''

  /**
   * @generated from field: double fiscal_year_end_year = 14;
   */
  fiscalYearEndYear = 0

  /**
   * @generated from field: double fiscal_year_end_month = 15;
   */
  fiscalYearEndMonth = 0

  /**
   * @generated from field: google.protobuf.DoubleValue current_ratio = 16;
   */
  currentRatio?: number

  /**
   * @generated from field: google.protobuf.DoubleValue quick_ratio = 17;
   */
  quickRatio?: number

  /**
   * @generated from field: google.protobuf.DoubleValue fixed_ratio = 18;
   */
  fixedRatio?: number

  /**
   * @generated from field: google.protobuf.DoubleValue fixed_ratio_tangible = 19;
   */
  fixedRatioTangible?: number

  /**
   * @generated from field: google.protobuf.DoubleValue cash_to_assets_ratio = 20;
   */
  cashToAssetsRatio?: number

  /**
   * @generated from field: google.protobuf.DoubleValue asset_aging_ratio = 21;
   */
  assetAgingRatio?: number

  /**
   * @generated from field: google.protobuf.Struct column_missing_reason = 22;
   */
  columnMissingReason?: Struct

  /**
   * @generated from field: google.protobuf.Struct calculation_dependency = 23;
   */
  calculationDependency?: Struct

  constructor(data?: PartialMessage<UsecaseTableFundamentalsLiquidity>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.UsecaseTableFundamentalsLiquidity'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'edinet_file_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'submission_date', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'edinet_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'filer_name', kind: 'message', T: StringValue },
    { no: 6, name: 'sec_code', kind: 'message', T: StringValue },
    { no: 7, name: 'doc_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 8, name: 'doc_description', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 9, name: 'securities_report_chunk_ids', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: 'original_filename', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 11, name: 'period_start', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 12, name: 'period_end', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 13, name: 'doc_type_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 14, name: 'fiscal_year_end_year', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 15, name: 'fiscal_year_end_month', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 16, name: 'current_ratio', kind: 'message', T: DoubleValue },
    { no: 17, name: 'quick_ratio', kind: 'message', T: DoubleValue },
    { no: 18, name: 'fixed_ratio', kind: 'message', T: DoubleValue },
    { no: 19, name: 'fixed_ratio_tangible', kind: 'message', T: DoubleValue },
    { no: 20, name: 'cash_to_assets_ratio', kind: 'message', T: DoubleValue },
    { no: 21, name: 'asset_aging_ratio', kind: 'message', T: DoubleValue },
    { no: 22, name: 'column_missing_reason', kind: 'message', T: Struct },
    { no: 23, name: 'calculation_dependency', kind: 'message', T: Struct },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UsecaseTableFundamentalsLiquidity {
    return new UsecaseTableFundamentalsLiquidity().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UsecaseTableFundamentalsLiquidity {
    return new UsecaseTableFundamentalsLiquidity().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UsecaseTableFundamentalsLiquidity {
    return new UsecaseTableFundamentalsLiquidity().fromJsonString(jsonString, options)
  }

  static equals(
    a: UsecaseTableFundamentalsLiquidity | PlainMessage<UsecaseTableFundamentalsLiquidity> | undefined,
    b: UsecaseTableFundamentalsLiquidity | PlainMessage<UsecaseTableFundamentalsLiquidity> | undefined,
  ): boolean {
    return proto3.util.equals(UsecaseTableFundamentalsLiquidity, a, b)
  }
}

/**
 * @generated from message models.UsecaseTableFundamentalsShareholderReturn
 */
export class UsecaseTableFundamentalsShareholderReturn extends Message<UsecaseTableFundamentalsShareholderReturn> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string edinet_file_id = 2;
   */
  edinetFileId = ''

  /**
   * @generated from field: string submission_date = 3;
   */
  submissionDate = ''

  /**
   * @generated from field: string edinet_code = 4;
   */
  edinetCode = ''

  /**
   * @generated from field: google.protobuf.StringValue filer_name = 5;
   */
  filerName?: string

  /**
   * @generated from field: google.protobuf.StringValue sec_code = 6;
   */
  secCode?: string

  /**
   * @generated from field: string doc_id = 7;
   */
  docId = ''

  /**
   * @generated from field: string doc_description = 8;
   */
  docDescription = ''

  /**
   * @generated from field: repeated string securities_report_chunk_ids = 9;
   */
  securitiesReportChunkIds: string[] = []

  /**
   * @generated from field: string original_filename = 10;
   */
  originalFilename = ''

  /**
   * @generated from field: string period_start = 11;
   */
  periodStart = ''

  /**
   * @generated from field: string period_end = 12;
   */
  periodEnd = ''

  /**
   * @generated from field: string doc_type_code = 13;
   */
  docTypeCode = ''

  /**
   * @generated from field: double fiscal_year_end_year = 14;
   */
  fiscalYearEndYear = 0

  /**
   * @generated from field: double fiscal_year_end_month = 15;
   */
  fiscalYearEndMonth = 0

  /**
   * @generated from field: google.protobuf.DoubleValue payout_ratio = 16;
   */
  payoutRatio?: number

  /**
   * @generated from field: google.protobuf.Struct column_missing_reason = 17;
   */
  columnMissingReason?: Struct

  /**
   * @generated from field: google.protobuf.Struct calculation_dependency = 18;
   */
  calculationDependency?: Struct

  constructor(data?: PartialMessage<UsecaseTableFundamentalsShareholderReturn>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.UsecaseTableFundamentalsShareholderReturn'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'edinet_file_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'submission_date', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'edinet_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'filer_name', kind: 'message', T: StringValue },
    { no: 6, name: 'sec_code', kind: 'message', T: StringValue },
    { no: 7, name: 'doc_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 8, name: 'doc_description', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 9, name: 'securities_report_chunk_ids', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: 'original_filename', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 11, name: 'period_start', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 12, name: 'period_end', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 13, name: 'doc_type_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 14, name: 'fiscal_year_end_year', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 15, name: 'fiscal_year_end_month', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 16, name: 'payout_ratio', kind: 'message', T: DoubleValue },
    { no: 17, name: 'column_missing_reason', kind: 'message', T: Struct },
    { no: 18, name: 'calculation_dependency', kind: 'message', T: Struct },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UsecaseTableFundamentalsShareholderReturn {
    return new UsecaseTableFundamentalsShareholderReturn().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UsecaseTableFundamentalsShareholderReturn {
    return new UsecaseTableFundamentalsShareholderReturn().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UsecaseTableFundamentalsShareholderReturn {
    return new UsecaseTableFundamentalsShareholderReturn().fromJsonString(jsonString, options)
  }

  static equals(
    a: UsecaseTableFundamentalsShareholderReturn | PlainMessage<UsecaseTableFundamentalsShareholderReturn> | undefined,
    b: UsecaseTableFundamentalsShareholderReturn | PlainMessage<UsecaseTableFundamentalsShareholderReturn> | undefined,
  ): boolean {
    return proto3.util.equals(UsecaseTableFundamentalsShareholderReturn, a, b)
  }
}

/**
 * @generated from message models.UsecaseTableExecutiveOverview
 */
export class UsecaseTableExecutiveOverview extends Message<UsecaseTableExecutiveOverview> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string edinet_file_id = 2;
   */
  edinetFileId = ''

  /**
   * @generated from field: string submission_date = 3;
   */
  submissionDate = ''

  /**
   * @generated from field: string edinet_code = 4;
   */
  edinetCode = ''

  /**
   * @generated from field: google.protobuf.StringValue filer_name = 5;
   */
  filerName?: string

  /**
   * @generated from field: google.protobuf.StringValue sec_code = 6;
   */
  secCode?: string

  /**
   * @generated from field: string doc_id = 7;
   */
  docId = ''

  /**
   * @generated from field: string doc_description = 8;
   */
  docDescription = ''

  /**
   * @generated from field: repeated string securities_report_chunk_ids = 9;
   */
  securitiesReportChunkIds: string[] = []

  /**
   * @generated from field: string original_filename = 10;
   */
  originalFilename = ''

  /**
   * @generated from field: string period_start = 11;
   */
  periodStart = ''

  /**
   * @generated from field: string period_end = 12;
   */
  periodEnd = ''

  /**
   * @generated from field: string doc_type_code = 13;
   */
  docTypeCode = ''

  /**
   * @generated from field: double fiscal_year_end_year = 14;
   */
  fiscalYearEndYear = 0

  /**
   * @generated from field: double fiscal_year_end_month = 15;
   */
  fiscalYearEndMonth = 0

  /**
   * @generated from field: google.protobuf.DoubleValue total_number_of_executives = 16;
   */
  totalNumberOfExecutives?: number

  /**
   * @generated from field: google.protobuf.DoubleValue number_of_male_executives = 17;
   */
  numberOfMaleExecutives?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ratio_of_male_executives = 18;
   */
  ratioOfMaleExecutives?: number

  /**
   * @generated from field: google.protobuf.DoubleValue number_of_female_executives = 19;
   */
  numberOfFemaleExecutives?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ratio_of_female_executives = 20;
   */
  ratioOfFemaleExecutives?: number

  /**
   * @generated from field: google.protobuf.DoubleValue number_of_external_executives = 21;
   */
  numberOfExternalExecutives?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ratio_of_external_executives = 22;
   */
  ratioOfExternalExecutives?: number

  /**
   * @generated from field: google.protobuf.DoubleValue average_age_of_executives = 23;
   */
  averageAgeOfExecutives?: number

  /**
   * @generated from field: google.protobuf.Struct column_missing_reason = 24;
   */
  columnMissingReason?: Struct

  constructor(data?: PartialMessage<UsecaseTableExecutiveOverview>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.UsecaseTableExecutiveOverview'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'edinet_file_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'submission_date', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'edinet_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'filer_name', kind: 'message', T: StringValue },
    { no: 6, name: 'sec_code', kind: 'message', T: StringValue },
    { no: 7, name: 'doc_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 8, name: 'doc_description', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 9, name: 'securities_report_chunk_ids', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: 'original_filename', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 11, name: 'period_start', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 12, name: 'period_end', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 13, name: 'doc_type_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 14, name: 'fiscal_year_end_year', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 15, name: 'fiscal_year_end_month', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 16, name: 'total_number_of_executives', kind: 'message', T: DoubleValue },
    { no: 17, name: 'number_of_male_executives', kind: 'message', T: DoubleValue },
    { no: 18, name: 'ratio_of_male_executives', kind: 'message', T: DoubleValue },
    { no: 19, name: 'number_of_female_executives', kind: 'message', T: DoubleValue },
    { no: 20, name: 'ratio_of_female_executives', kind: 'message', T: DoubleValue },
    { no: 21, name: 'number_of_external_executives', kind: 'message', T: DoubleValue },
    { no: 22, name: 'ratio_of_external_executives', kind: 'message', T: DoubleValue },
    { no: 23, name: 'average_age_of_executives', kind: 'message', T: DoubleValue },
    { no: 24, name: 'column_missing_reason', kind: 'message', T: Struct },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UsecaseTableExecutiveOverview {
    return new UsecaseTableExecutiveOverview().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UsecaseTableExecutiveOverview {
    return new UsecaseTableExecutiveOverview().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UsecaseTableExecutiveOverview {
    return new UsecaseTableExecutiveOverview().fromJsonString(jsonString, options)
  }

  static equals(
    a: UsecaseTableExecutiveOverview | PlainMessage<UsecaseTableExecutiveOverview> | undefined,
    b: UsecaseTableExecutiveOverview | PlainMessage<UsecaseTableExecutiveOverview> | undefined,
  ): boolean {
    return proto3.util.equals(UsecaseTableExecutiveOverview, a, b)
  }
}

/**
 * @generated from message models.UsecaseTableExecutives
 */
export class UsecaseTableExecutives extends Message<UsecaseTableExecutives> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string edinet_file_id = 2;
   */
  edinetFileId = ''

  /**
   * @generated from field: string submission_date = 3;
   */
  submissionDate = ''

  /**
   * @generated from field: string edinet_code = 4;
   */
  edinetCode = ''

  /**
   * @generated from field: google.protobuf.StringValue filer_name = 5;
   */
  filerName?: string

  /**
   * @generated from field: google.protobuf.StringValue sec_code = 6;
   */
  secCode?: string

  /**
   * @generated from field: string doc_id = 7;
   */
  docId = ''

  /**
   * @generated from field: string doc_description = 8;
   */
  docDescription = ''

  /**
   * @generated from field: repeated string securities_report_chunk_ids = 9;
   */
  securitiesReportChunkIds: string[] = []

  /**
   * @generated from field: string original_filename = 10;
   */
  originalFilename = ''

  /**
   * @generated from field: string period_start = 11;
   */
  periodStart = ''

  /**
   * @generated from field: string period_end = 12;
   */
  periodEnd = ''

  /**
   * @generated from field: string doc_type_code = 13;
   */
  docTypeCode = ''

  /**
   * @generated from field: double fiscal_year_end_year = 14;
   */
  fiscalYearEndYear = 0

  /**
   * @generated from field: double fiscal_year_end_month = 15;
   */
  fiscalYearEndMonth = 0

  /**
   * @generated from field: google.protobuf.DoubleValue appearance_index = 16;
   */
  appearanceIndex?: number

  /**
   * @generated from field: google.protobuf.StringValue title = 17;
   */
  title?: string

  /**
   * @generated from field: google.protobuf.StringValue name = 18;
   */
  name?: string

  /**
   * @generated from field: google.protobuf.StringValue birth_day = 19;
   */
  birthDay?: string

  /**
   * @generated from field: repeated string career = 20;
   */
  career: string[] = []

  /**
   * @generated from field: google.protobuf.DoubleValue shares_owned = 21;
   */
  sharesOwned?: number

  /**
   * @generated from field: google.protobuf.Struct column_missing_reason = 22;
   */
  columnMissingReason?: Struct

  constructor(data?: PartialMessage<UsecaseTableExecutives>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.UsecaseTableExecutives'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'edinet_file_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'submission_date', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'edinet_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'filer_name', kind: 'message', T: StringValue },
    { no: 6, name: 'sec_code', kind: 'message', T: StringValue },
    { no: 7, name: 'doc_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 8, name: 'doc_description', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 9, name: 'securities_report_chunk_ids', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: 'original_filename', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 11, name: 'period_start', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 12, name: 'period_end', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 13, name: 'doc_type_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 14, name: 'fiscal_year_end_year', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 15, name: 'fiscal_year_end_month', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 16, name: 'appearance_index', kind: 'message', T: DoubleValue },
    { no: 17, name: 'title', kind: 'message', T: StringValue },
    { no: 18, name: 'name', kind: 'message', T: StringValue },
    { no: 19, name: 'birth_day', kind: 'message', T: StringValue },
    { no: 20, name: 'career', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 21, name: 'shares_owned', kind: 'message', T: DoubleValue },
    { no: 22, name: 'column_missing_reason', kind: 'message', T: Struct },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UsecaseTableExecutives {
    return new UsecaseTableExecutives().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UsecaseTableExecutives {
    return new UsecaseTableExecutives().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UsecaseTableExecutives {
    return new UsecaseTableExecutives().fromJsonString(jsonString, options)
  }

  static equals(
    a: UsecaseTableExecutives | PlainMessage<UsecaseTableExecutives> | undefined,
    b: UsecaseTableExecutives | PlainMessage<UsecaseTableExecutives> | undefined,
  ): boolean {
    return proto3.util.equals(UsecaseTableExecutives, a, b)
  }
}

/**
 * @generated from message models.UsecaseTableExecutiveCompensation
 */
export class UsecaseTableExecutiveCompensation extends Message<UsecaseTableExecutiveCompensation> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string edinet_file_id = 2;
   */
  edinetFileId = ''

  /**
   * @generated from field: string submission_date = 3;
   */
  submissionDate = ''

  /**
   * @generated from field: string edinet_code = 4;
   */
  edinetCode = ''

  /**
   * @generated from field: google.protobuf.StringValue filer_name = 5;
   */
  filerName?: string

  /**
   * @generated from field: google.protobuf.StringValue sec_code = 6;
   */
  secCode?: string

  /**
   * @generated from field: string doc_id = 7;
   */
  docId = ''

  /**
   * @generated from field: string doc_description = 8;
   */
  docDescription = ''

  /**
   * @generated from field: repeated string securities_report_chunk_ids = 9;
   */
  securitiesReportChunkIds: string[] = []

  /**
   * @generated from field: string original_filename = 10;
   */
  originalFilename = ''

  /**
   * @generated from field: string period_start = 11;
   */
  periodStart = ''

  /**
   * @generated from field: string period_end = 12;
   */
  periodEnd = ''

  /**
   * @generated from field: string doc_type_code = 13;
   */
  docTypeCode = ''

  /**
   * @generated from field: double fiscal_year_end_year = 14;
   */
  fiscalYearEndYear = 0

  /**
   * @generated from field: double fiscal_year_end_month = 15;
   */
  fiscalYearEndMonth = 0

  /**
   * @generated from field: google.protobuf.DoubleValue appearance_index = 16;
   */
  appearanceIndex?: number

  /**
   * @generated from field: google.protobuf.DoubleValue unit = 17;
   */
  unit?: number

  /**
   * @generated from field: google.protobuf.StringValue unit_text = 18;
   */
  unitText?: string

  /**
   * @generated from field: google.protobuf.StringValue title_segment = 19;
   */
  titleSegment?: string

  /**
   * @generated from field: google.protobuf.StringValue name = 20;
   */
  name?: string

  /**
   * @generated from field: repeated string company_name = 21;
   */
  companyName: string[] = []

  /**
   * @generated from field: google.protobuf.DoubleValue total_compensation = 22;
   */
  totalCompensation?: number

  /**
   * @generated from field: google.protobuf.DoubleValue number_of_officers = 23;
   */
  numberOfOfficers?: number

  /**
   * @generated from field: google.protobuf.Struct column_missing_reason = 24;
   */
  columnMissingReason?: Struct

  constructor(data?: PartialMessage<UsecaseTableExecutiveCompensation>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.UsecaseTableExecutiveCompensation'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'edinet_file_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'submission_date', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'edinet_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'filer_name', kind: 'message', T: StringValue },
    { no: 6, name: 'sec_code', kind: 'message', T: StringValue },
    { no: 7, name: 'doc_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 8, name: 'doc_description', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 9, name: 'securities_report_chunk_ids', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: 'original_filename', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 11, name: 'period_start', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 12, name: 'period_end', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 13, name: 'doc_type_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 14, name: 'fiscal_year_end_year', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 15, name: 'fiscal_year_end_month', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 16, name: 'appearance_index', kind: 'message', T: DoubleValue },
    { no: 17, name: 'unit', kind: 'message', T: DoubleValue },
    { no: 18, name: 'unit_text', kind: 'message', T: StringValue },
    { no: 19, name: 'title_segment', kind: 'message', T: StringValue },
    { no: 20, name: 'name', kind: 'message', T: StringValue },
    { no: 21, name: 'company_name', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 22, name: 'total_compensation', kind: 'message', T: DoubleValue },
    { no: 23, name: 'number_of_officers', kind: 'message', T: DoubleValue },
    { no: 24, name: 'column_missing_reason', kind: 'message', T: Struct },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UsecaseTableExecutiveCompensation {
    return new UsecaseTableExecutiveCompensation().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UsecaseTableExecutiveCompensation {
    return new UsecaseTableExecutiveCompensation().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UsecaseTableExecutiveCompensation {
    return new UsecaseTableExecutiveCompensation().fromJsonString(jsonString, options)
  }

  static equals(
    a: UsecaseTableExecutiveCompensation | PlainMessage<UsecaseTableExecutiveCompensation> | undefined,
    b: UsecaseTableExecutiveCompensation | PlainMessage<UsecaseTableExecutiveCompensation> | undefined,
  ): boolean {
    return proto3.util.equals(UsecaseTableExecutiveCompensation, a, b)
  }
}

/**
 * @generated from message models.UsecaseTableBusinessDescription
 */
export class UsecaseTableBusinessDescription extends Message<UsecaseTableBusinessDescription> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string edinet_file_id = 2;
   */
  edinetFileId = ''

  /**
   * @generated from field: string submission_date = 3;
   */
  submissionDate = ''

  /**
   * @generated from field: string edinet_code = 4;
   */
  edinetCode = ''

  /**
   * @generated from field: google.protobuf.StringValue filer_name = 5;
   */
  filerName?: string

  /**
   * @generated from field: google.protobuf.StringValue sec_code = 6;
   */
  secCode?: string

  /**
   * @generated from field: string doc_id = 7;
   */
  docId = ''

  /**
   * @generated from field: string doc_description = 8;
   */
  docDescription = ''

  /**
   * @generated from field: repeated string securities_report_chunk_ids = 9;
   */
  securitiesReportChunkIds: string[] = []

  /**
   * @generated from field: string original_filename = 10;
   */
  originalFilename = ''

  /**
   * @generated from field: string period_start = 11;
   */
  periodStart = ''

  /**
   * @generated from field: string period_end = 12;
   */
  periodEnd = ''

  /**
   * @generated from field: string doc_type_code = 13;
   */
  docTypeCode = ''

  /**
   * @generated from field: double fiscal_year_end_year = 14;
   */
  fiscalYearEndYear = 0

  /**
   * @generated from field: double fiscal_year_end_month = 15;
   */
  fiscalYearEndMonth = 0

  /**
   * @generated from field: google.protobuf.StringValue summary = 16;
   */
  summary?: string

  /**
   * @generated from field: google.protobuf.Struct column_missing_reason = 17;
   */
  columnMissingReason?: Struct

  constructor(data?: PartialMessage<UsecaseTableBusinessDescription>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.UsecaseTableBusinessDescription'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'edinet_file_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'submission_date', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'edinet_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'filer_name', kind: 'message', T: StringValue },
    { no: 6, name: 'sec_code', kind: 'message', T: StringValue },
    { no: 7, name: 'doc_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 8, name: 'doc_description', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 9, name: 'securities_report_chunk_ids', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: 'original_filename', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 11, name: 'period_start', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 12, name: 'period_end', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 13, name: 'doc_type_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 14, name: 'fiscal_year_end_year', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 15, name: 'fiscal_year_end_month', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 16, name: 'summary', kind: 'message', T: StringValue },
    { no: 17, name: 'column_missing_reason', kind: 'message', T: Struct },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UsecaseTableBusinessDescription {
    return new UsecaseTableBusinessDescription().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UsecaseTableBusinessDescription {
    return new UsecaseTableBusinessDescription().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UsecaseTableBusinessDescription {
    return new UsecaseTableBusinessDescription().fromJsonString(jsonString, options)
  }

  static equals(
    a: UsecaseTableBusinessDescription | PlainMessage<UsecaseTableBusinessDescription> | undefined,
    b: UsecaseTableBusinessDescription | PlainMessage<UsecaseTableBusinessDescription> | undefined,
  ): boolean {
    return proto3.util.equals(UsecaseTableBusinessDescription, a, b)
  }
}

/**
 * @generated from message models.UsecaseTableBusinessRisks
 */
export class UsecaseTableBusinessRisks extends Message<UsecaseTableBusinessRisks> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string edinet_file_id = 2;
   */
  edinetFileId = ''

  /**
   * @generated from field: string submission_date = 3;
   */
  submissionDate = ''

  /**
   * @generated from field: string edinet_code = 4;
   */
  edinetCode = ''

  /**
   * @generated from field: google.protobuf.StringValue filer_name = 5;
   */
  filerName?: string

  /**
   * @generated from field: google.protobuf.StringValue sec_code = 6;
   */
  secCode?: string

  /**
   * @generated from field: string doc_id = 7;
   */
  docId = ''

  /**
   * @generated from field: string doc_description = 8;
   */
  docDescription = ''

  /**
   * @generated from field: repeated string securities_report_chunk_ids = 9;
   */
  securitiesReportChunkIds: string[] = []

  /**
   * @generated from field: string original_filename = 10;
   */
  originalFilename = ''

  /**
   * @generated from field: string period_start = 11;
   */
  periodStart = ''

  /**
   * @generated from field: string period_end = 12;
   */
  periodEnd = ''

  /**
   * @generated from field: string doc_type_code = 13;
   */
  docTypeCode = ''

  /**
   * @generated from field: double fiscal_year_end_year = 14;
   */
  fiscalYearEndYear = 0

  /**
   * @generated from field: double fiscal_year_end_month = 15;
   */
  fiscalYearEndMonth = 0

  /**
   * @generated from field: google.protobuf.DoubleValue appearance_index = 16;
   */
  appearanceIndex?: number

  /**
   * @generated from field: google.protobuf.StringValue category = 17;
   */
  category?: string

  /**
   * @generated from field: google.protobuf.StringValue title = 18;
   */
  title?: string

  /**
   * @generated from field: google.protobuf.StringValue content_summary = 19;
   */
  contentSummary?: string

  /**
   * @generated from field: google.protobuf.Struct column_missing_reason = 20;
   */
  columnMissingReason?: Struct

  constructor(data?: PartialMessage<UsecaseTableBusinessRisks>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.UsecaseTableBusinessRisks'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'edinet_file_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'submission_date', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'edinet_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'filer_name', kind: 'message', T: StringValue },
    { no: 6, name: 'sec_code', kind: 'message', T: StringValue },
    { no: 7, name: 'doc_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 8, name: 'doc_description', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 9, name: 'securities_report_chunk_ids', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: 'original_filename', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 11, name: 'period_start', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 12, name: 'period_end', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 13, name: 'doc_type_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 14, name: 'fiscal_year_end_year', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 15, name: 'fiscal_year_end_month', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 16, name: 'appearance_index', kind: 'message', T: DoubleValue },
    { no: 17, name: 'category', kind: 'message', T: StringValue },
    { no: 18, name: 'title', kind: 'message', T: StringValue },
    { no: 19, name: 'content_summary', kind: 'message', T: StringValue },
    { no: 20, name: 'column_missing_reason', kind: 'message', T: Struct },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UsecaseTableBusinessRisks {
    return new UsecaseTableBusinessRisks().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UsecaseTableBusinessRisks {
    return new UsecaseTableBusinessRisks().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UsecaseTableBusinessRisks {
    return new UsecaseTableBusinessRisks().fromJsonString(jsonString, options)
  }

  static equals(
    a: UsecaseTableBusinessRisks | PlainMessage<UsecaseTableBusinessRisks> | undefined,
    b: UsecaseTableBusinessRisks | PlainMessage<UsecaseTableBusinessRisks> | undefined,
  ): boolean {
    return proto3.util.equals(UsecaseTableBusinessRisks, a, b)
  }
}

/**
 * @generated from message models.UsecaseTableHistory
 */
export class UsecaseTableHistory extends Message<UsecaseTableHistory> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string edinet_file_id = 2;
   */
  edinetFileId = ''

  /**
   * @generated from field: string submission_date = 3;
   */
  submissionDate = ''

  /**
   * @generated from field: string edinet_code = 4;
   */
  edinetCode = ''

  /**
   * @generated from field: google.protobuf.StringValue filer_name = 5;
   */
  filerName?: string

  /**
   * @generated from field: google.protobuf.StringValue sec_code = 6;
   */
  secCode?: string

  /**
   * @generated from field: string doc_id = 7;
   */
  docId = ''

  /**
   * @generated from field: string doc_description = 8;
   */
  docDescription = ''

  /**
   * @generated from field: repeated string securities_report_chunk_ids = 9;
   */
  securitiesReportChunkIds: string[] = []

  /**
   * @generated from field: string original_filename = 10;
   */
  originalFilename = ''

  /**
   * @generated from field: string period_start = 11;
   */
  periodStart = ''

  /**
   * @generated from field: string period_end = 12;
   */
  periodEnd = ''

  /**
   * @generated from field: string doc_type_code = 13;
   */
  docTypeCode = ''

  /**
   * @generated from field: double fiscal_year_end_year = 14;
   */
  fiscalYearEndYear = 0

  /**
   * @generated from field: double fiscal_year_end_month = 15;
   */
  fiscalYearEndMonth = 0

  /**
   * @generated from field: google.protobuf.DoubleValue appearance_index = 16;
   */
  appearanceIndex?: number

  /**
   * @generated from field: google.protobuf.DoubleValue year = 17;
   */
  year?: number

  /**
   * @generated from field: google.protobuf.DoubleValue month = 18;
   */
  month?: number

  /**
   * @generated from field: google.protobuf.StringValue event = 19;
   */
  event?: string

  /**
   * @generated from field: google.protobuf.Struct column_missing_reason = 20;
   */
  columnMissingReason?: Struct

  constructor(data?: PartialMessage<UsecaseTableHistory>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.UsecaseTableHistory'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'edinet_file_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'submission_date', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'edinet_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'filer_name', kind: 'message', T: StringValue },
    { no: 6, name: 'sec_code', kind: 'message', T: StringValue },
    { no: 7, name: 'doc_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 8, name: 'doc_description', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 9, name: 'securities_report_chunk_ids', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: 'original_filename', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 11, name: 'period_start', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 12, name: 'period_end', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 13, name: 'doc_type_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 14, name: 'fiscal_year_end_year', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 15, name: 'fiscal_year_end_month', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 16, name: 'appearance_index', kind: 'message', T: DoubleValue },
    { no: 17, name: 'year', kind: 'message', T: DoubleValue },
    { no: 18, name: 'month', kind: 'message', T: DoubleValue },
    { no: 19, name: 'event', kind: 'message', T: StringValue },
    { no: 20, name: 'column_missing_reason', kind: 'message', T: Struct },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UsecaseTableHistory {
    return new UsecaseTableHistory().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UsecaseTableHistory {
    return new UsecaseTableHistory().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UsecaseTableHistory {
    return new UsecaseTableHistory().fromJsonString(jsonString, options)
  }

  static equals(
    a: UsecaseTableHistory | PlainMessage<UsecaseTableHistory> | undefined,
    b: UsecaseTableHistory | PlainMessage<UsecaseTableHistory> | undefined,
  ): boolean {
    return proto3.util.equals(UsecaseTableHistory, a, b)
  }
}

/**
 * @generated from message models.UsecaseTableMajorSubsidiaries
 */
export class UsecaseTableMajorSubsidiaries extends Message<UsecaseTableMajorSubsidiaries> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string edinet_file_id = 2;
   */
  edinetFileId = ''

  /**
   * @generated from field: string submission_date = 3;
   */
  submissionDate = ''

  /**
   * @generated from field: string edinet_code = 4;
   */
  edinetCode = ''

  /**
   * @generated from field: google.protobuf.StringValue filer_name = 5;
   */
  filerName?: string

  /**
   * @generated from field: google.protobuf.StringValue sec_code = 6;
   */
  secCode?: string

  /**
   * @generated from field: string doc_id = 7;
   */
  docId = ''

  /**
   * @generated from field: string doc_description = 8;
   */
  docDescription = ''

  /**
   * @generated from field: repeated string securities_report_chunk_ids = 9;
   */
  securitiesReportChunkIds: string[] = []

  /**
   * @generated from field: string original_filename = 10;
   */
  originalFilename = ''

  /**
   * @generated from field: string period_start = 11;
   */
  periodStart = ''

  /**
   * @generated from field: string period_end = 12;
   */
  periodEnd = ''

  /**
   * @generated from field: string doc_type_code = 13;
   */
  docTypeCode = ''

  /**
   * @generated from field: double fiscal_year_end_year = 14;
   */
  fiscalYearEndYear = 0

  /**
   * @generated from field: double fiscal_year_end_month = 15;
   */
  fiscalYearEndMonth = 0

  /**
   * @generated from field: google.protobuf.DoubleValue appearance_index = 16;
   */
  appearanceIndex?: number

  /**
   * @generated from field: google.protobuf.StringValue company_name = 17;
   */
  companyName?: string

  /**
   * @generated from field: google.protobuf.StringValue relationship = 18;
   */
  relationship?: string

  /**
   * @generated from field: google.protobuf.StringValue address = 19;
   */
  address?: string

  /**
   * @generated from field: google.protobuf.DoubleValue capital_jpy = 20;
   */
  capitalJpy?: number

  /**
   * @generated from field: google.protobuf.StringValue business_description = 21;
   */
  businessDescription?: string

  /**
   * @generated from field: google.protobuf.DoubleValue percentage_owned = 22;
   */
  percentageOwned?: number

  /**
   * @generated from field: google.protobuf.StringValue relationship_details = 23;
   */
  relationshipDetails?: string

  /**
   * @generated from field: google.protobuf.Struct column_missing_reason = 24;
   */
  columnMissingReason?: Struct

  constructor(data?: PartialMessage<UsecaseTableMajorSubsidiaries>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.UsecaseTableMajorSubsidiaries'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'edinet_file_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'submission_date', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'edinet_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'filer_name', kind: 'message', T: StringValue },
    { no: 6, name: 'sec_code', kind: 'message', T: StringValue },
    { no: 7, name: 'doc_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 8, name: 'doc_description', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 9, name: 'securities_report_chunk_ids', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: 'original_filename', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 11, name: 'period_start', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 12, name: 'period_end', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 13, name: 'doc_type_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 14, name: 'fiscal_year_end_year', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 15, name: 'fiscal_year_end_month', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 16, name: 'appearance_index', kind: 'message', T: DoubleValue },
    { no: 17, name: 'company_name', kind: 'message', T: StringValue },
    { no: 18, name: 'relationship', kind: 'message', T: StringValue },
    { no: 19, name: 'address', kind: 'message', T: StringValue },
    { no: 20, name: 'capital_jpy', kind: 'message', T: DoubleValue },
    { no: 21, name: 'business_description', kind: 'message', T: StringValue },
    { no: 22, name: 'percentage_owned', kind: 'message', T: DoubleValue },
    { no: 23, name: 'relationship_details', kind: 'message', T: StringValue },
    { no: 24, name: 'column_missing_reason', kind: 'message', T: Struct },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UsecaseTableMajorSubsidiaries {
    return new UsecaseTableMajorSubsidiaries().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UsecaseTableMajorSubsidiaries {
    return new UsecaseTableMajorSubsidiaries().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UsecaseTableMajorSubsidiaries {
    return new UsecaseTableMajorSubsidiaries().fromJsonString(jsonString, options)
  }

  static equals(
    a: UsecaseTableMajorSubsidiaries | PlainMessage<UsecaseTableMajorSubsidiaries> | undefined,
    b: UsecaseTableMajorSubsidiaries | PlainMessage<UsecaseTableMajorSubsidiaries> | undefined,
  ): boolean {
    return proto3.util.equals(UsecaseTableMajorSubsidiaries, a, b)
  }
}

/**
 * @generated from message models.UsecaseTableOffices
 */
export class UsecaseTableOffices extends Message<UsecaseTableOffices> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string edinet_file_id = 2;
   */
  edinetFileId = ''

  /**
   * @generated from field: string submission_date = 3;
   */
  submissionDate = ''

  /**
   * @generated from field: string edinet_code = 4;
   */
  edinetCode = ''

  /**
   * @generated from field: google.protobuf.StringValue filer_name = 5;
   */
  filerName?: string

  /**
   * @generated from field: google.protobuf.StringValue sec_code = 6;
   */
  secCode?: string

  /**
   * @generated from field: string doc_id = 7;
   */
  docId = ''

  /**
   * @generated from field: string doc_description = 8;
   */
  docDescription = ''

  /**
   * @generated from field: repeated string securities_report_chunk_ids = 9;
   */
  securitiesReportChunkIds: string[] = []

  /**
   * @generated from field: string original_filename = 10;
   */
  originalFilename = ''

  /**
   * @generated from field: string period_start = 11;
   */
  periodStart = ''

  /**
   * @generated from field: string period_end = 12;
   */
  periodEnd = ''

  /**
   * @generated from field: string doc_type_code = 13;
   */
  docTypeCode = ''

  /**
   * @generated from field: double fiscal_year_end_year = 14;
   */
  fiscalYearEndYear = 0

  /**
   * @generated from field: double fiscal_year_end_month = 15;
   */
  fiscalYearEndMonth = 0

  /**
   * @generated from field: google.protobuf.DoubleValue appearance_index = 16;
   */
  appearanceIndex?: number

  /**
   * @generated from field: google.protobuf.StringValue office_name = 17;
   */
  officeName?: string

  /**
   * @generated from field: google.protobuf.StringValue address = 18;
   */
  address?: string

  /**
   * @generated from field: google.protobuf.StringValue business_segment_name = 19;
   */
  businessSegmentName?: string

  /**
   * @generated from field: google.protobuf.StringValue facilities_summary = 20;
   */
  facilitiesSummary?: string

  /**
   * @generated from field: google.protobuf.StringValue book_value_unit = 21;
   */
  bookValueUnit?: string

  /**
   * @generated from field: google.protobuf.DoubleValue book_value_land_jpy = 22;
   */
  bookValueLandJpy?: number

  /**
   * @generated from field: google.protobuf.DoubleValue land_area = 23;
   */
  landArea?: number

  /**
   * @generated from field: google.protobuf.StringValue land_area_unit = 24;
   */
  landAreaUnit?: string

  /**
   * @generated from field: google.protobuf.DoubleValue book_value_building_jpy = 25;
   */
  bookValueBuildingJpy?: number

  /**
   * @generated from field: google.protobuf.DoubleValue book_value_machinery_vehicles_equipment_jpy = 26;
   */
  bookValueMachineryVehiclesEquipmentJpy?: number

  /**
   * @generated from field: google.protobuf.DoubleValue book_value_total_jpy = 27;
   */
  bookValueTotalJpy?: number

  /**
   * @generated from field: google.protobuf.DoubleValue number_of_employees = 28;
   */
  numberOfEmployees?: number

  /**
   * @generated from field: google.protobuf.Struct column_missing_reason = 29;
   */
  columnMissingReason?: Struct

  constructor(data?: PartialMessage<UsecaseTableOffices>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.UsecaseTableOffices'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'edinet_file_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'submission_date', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'edinet_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'filer_name', kind: 'message', T: StringValue },
    { no: 6, name: 'sec_code', kind: 'message', T: StringValue },
    { no: 7, name: 'doc_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 8, name: 'doc_description', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 9, name: 'securities_report_chunk_ids', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: 'original_filename', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 11, name: 'period_start', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 12, name: 'period_end', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 13, name: 'doc_type_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 14, name: 'fiscal_year_end_year', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 15, name: 'fiscal_year_end_month', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 16, name: 'appearance_index', kind: 'message', T: DoubleValue },
    { no: 17, name: 'office_name', kind: 'message', T: StringValue },
    { no: 18, name: 'address', kind: 'message', T: StringValue },
    { no: 19, name: 'business_segment_name', kind: 'message', T: StringValue },
    { no: 20, name: 'facilities_summary', kind: 'message', T: StringValue },
    { no: 21, name: 'book_value_unit', kind: 'message', T: StringValue },
    { no: 22, name: 'book_value_land_jpy', kind: 'message', T: DoubleValue },
    { no: 23, name: 'land_area', kind: 'message', T: DoubleValue },
    { no: 24, name: 'land_area_unit', kind: 'message', T: StringValue },
    { no: 25, name: 'book_value_building_jpy', kind: 'message', T: DoubleValue },
    { no: 26, name: 'book_value_machinery_vehicles_equipment_jpy', kind: 'message', T: DoubleValue },
    { no: 27, name: 'book_value_total_jpy', kind: 'message', T: DoubleValue },
    { no: 28, name: 'number_of_employees', kind: 'message', T: DoubleValue },
    { no: 29, name: 'column_missing_reason', kind: 'message', T: Struct },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UsecaseTableOffices {
    return new UsecaseTableOffices().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UsecaseTableOffices {
    return new UsecaseTableOffices().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UsecaseTableOffices {
    return new UsecaseTableOffices().fromJsonString(jsonString, options)
  }

  static equals(
    a: UsecaseTableOffices | PlainMessage<UsecaseTableOffices> | undefined,
    b: UsecaseTableOffices | PlainMessage<UsecaseTableOffices> | undefined,
  ): boolean {
    return proto3.util.equals(UsecaseTableOffices, a, b)
  }
}

/**
 * @generated from message models.UsecaseTableMajorShareholders
 */
export class UsecaseTableMajorShareholders extends Message<UsecaseTableMajorShareholders> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string edinet_file_id = 2;
   */
  edinetFileId = ''

  /**
   * @generated from field: string submission_date = 3;
   */
  submissionDate = ''

  /**
   * @generated from field: string edinet_code = 4;
   */
  edinetCode = ''

  /**
   * @generated from field: google.protobuf.StringValue filer_name = 5;
   */
  filerName?: string

  /**
   * @generated from field: google.protobuf.StringValue sec_code = 6;
   */
  secCode?: string

  /**
   * @generated from field: string doc_id = 7;
   */
  docId = ''

  /**
   * @generated from field: string doc_description = 8;
   */
  docDescription = ''

  /**
   * @generated from field: repeated string securities_report_chunk_ids = 9;
   */
  securitiesReportChunkIds: string[] = []

  /**
   * @generated from field: string original_filename = 10;
   */
  originalFilename = ''

  /**
   * @generated from field: string period_start = 11;
   */
  periodStart = ''

  /**
   * @generated from field: string period_end = 12;
   */
  periodEnd = ''

  /**
   * @generated from field: string doc_type_code = 13;
   */
  docTypeCode = ''

  /**
   * @generated from field: double fiscal_year_end_year = 14;
   */
  fiscalYearEndYear = 0

  /**
   * @generated from field: double fiscal_year_end_month = 15;
   */
  fiscalYearEndMonth = 0

  /**
   * @generated from field: google.protobuf.DoubleValue appearance_index = 16;
   */
  appearanceIndex?: number

  /**
   * @generated from field: google.protobuf.StringValue name = 17;
   */
  name?: string

  /**
   * @generated from field: google.protobuf.StringValue address = 18;
   */
  address?: string

  /**
   * @generated from field: google.protobuf.DoubleValue shares_owned = 19;
   */
  sharesOwned?: number

  /**
   * @generated from field: google.protobuf.StringValue shares_owned_unit = 20;
   */
  sharesOwnedUnit?: string

  /**
   * @generated from field: google.protobuf.DoubleValue percentage_of_total_shares = 21;
   */
  percentageOfTotalShares?: number

  /**
   * @generated from field: google.protobuf.Struct column_missing_reason = 22;
   */
  columnMissingReason?: Struct

  constructor(data?: PartialMessage<UsecaseTableMajorShareholders>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.UsecaseTableMajorShareholders'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'edinet_file_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'submission_date', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'edinet_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'filer_name', kind: 'message', T: StringValue },
    { no: 6, name: 'sec_code', kind: 'message', T: StringValue },
    { no: 7, name: 'doc_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 8, name: 'doc_description', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 9, name: 'securities_report_chunk_ids', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: 'original_filename', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 11, name: 'period_start', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 12, name: 'period_end', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 13, name: 'doc_type_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 14, name: 'fiscal_year_end_year', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 15, name: 'fiscal_year_end_month', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 16, name: 'appearance_index', kind: 'message', T: DoubleValue },
    { no: 17, name: 'name', kind: 'message', T: StringValue },
    { no: 18, name: 'address', kind: 'message', T: StringValue },
    { no: 19, name: 'shares_owned', kind: 'message', T: DoubleValue },
    { no: 20, name: 'shares_owned_unit', kind: 'message', T: StringValue },
    { no: 21, name: 'percentage_of_total_shares', kind: 'message', T: DoubleValue },
    { no: 22, name: 'column_missing_reason', kind: 'message', T: Struct },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UsecaseTableMajorShareholders {
    return new UsecaseTableMajorShareholders().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UsecaseTableMajorShareholders {
    return new UsecaseTableMajorShareholders().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UsecaseTableMajorShareholders {
    return new UsecaseTableMajorShareholders().fromJsonString(jsonString, options)
  }

  static equals(
    a: UsecaseTableMajorShareholders | PlainMessage<UsecaseTableMajorShareholders> | undefined,
    b: UsecaseTableMajorShareholders | PlainMessage<UsecaseTableMajorShareholders> | undefined,
  ): boolean {
    return proto3.util.equals(UsecaseTableMajorShareholders, a, b)
  }
}

/**
 * @generated from message models.UsecaseTableKeyManagementIndicatorsConsolidated
 */
export class UsecaseTableKeyManagementIndicatorsConsolidated extends Message<UsecaseTableKeyManagementIndicatorsConsolidated> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string edinet_file_id = 2;
   */
  edinetFileId = ''

  /**
   * @generated from field: string submission_date = 3;
   */
  submissionDate = ''

  /**
   * @generated from field: string edinet_code = 4;
   */
  edinetCode = ''

  /**
   * @generated from field: google.protobuf.StringValue filer_name = 5;
   */
  filerName?: string

  /**
   * @generated from field: google.protobuf.StringValue sec_code = 6;
   */
  secCode?: string

  /**
   * @generated from field: string doc_id = 7;
   */
  docId = ''

  /**
   * @generated from field: string doc_description = 8;
   */
  docDescription = ''

  /**
   * @generated from field: repeated string securities_report_chunk_ids = 9;
   */
  securitiesReportChunkIds: string[] = []

  /**
   * @generated from field: string original_filename = 10;
   */
  originalFilename = ''

  /**
   * @generated from field: string period_start = 11;
   */
  periodStart = ''

  /**
   * @generated from field: string period_end = 12;
   */
  periodEnd = ''

  /**
   * @generated from field: string doc_type_code = 13;
   */
  docTypeCode = ''

  /**
   * @generated from field: double fiscal_year_end_year = 14;
   */
  fiscalYearEndYear = 0

  /**
   * @generated from field: double fiscal_year_end_month = 15;
   */
  fiscalYearEndMonth = 0

  /**
   * @generated from field: google.protobuf.StringValue fiscal_year = 16;
   */
  fiscalYear?: string

  /**
   * @generated from field: google.protobuf.DoubleValue revenue = 17;
   */
  revenue?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ordinary_income_loss = 18;
   */
  ordinaryIncomeLoss?: number

  /**
   * @generated from field: google.protobuf.DoubleValue net_income_loss_attributable_to_owners_of_parent = 19;
   */
  netIncomeLossAttributableToOwnersOfParent?: number

  /**
   * @generated from field: google.protobuf.DoubleValue comprehensive_income = 20;
   */
  comprehensiveIncome?: number

  /**
   * @generated from field: google.protobuf.DoubleValue net_assets = 21;
   */
  netAssets?: number

  /**
   * @generated from field: google.protobuf.DoubleValue total_assets = 22;
   */
  totalAssets?: number

  /**
   * @generated from field: google.protobuf.DoubleValue net_assets_per_share = 23;
   */
  netAssetsPerShare?: number

  /**
   * @generated from field: google.protobuf.DoubleValue net_income_loss_per_share = 24;
   */
  netIncomeLossPerShare?: number

  /**
   * @generated from field: google.protobuf.DoubleValue diluted_net_income_per_share = 25;
   */
  dilutedNetIncomePerShare?: number

  /**
   * @generated from field: google.protobuf.DoubleValue equity_ratio = 26;
   */
  equityRatio?: number

  /**
   * @generated from field: google.protobuf.DoubleValue return_on_equity = 27;
   */
  returnOnEquity?: number

  /**
   * @generated from field: google.protobuf.DoubleValue price_earnings_ratio = 28;
   */
  priceEarningsRatio?: number

  /**
   * @generated from field: google.protobuf.DoubleValue cash_flows_from_operating_activities = 29;
   */
  cashFlowsFromOperatingActivities?: number

  /**
   * @generated from field: google.protobuf.DoubleValue cash_flows_from_investing_activities = 30;
   */
  cashFlowsFromInvestingActivities?: number

  /**
   * @generated from field: google.protobuf.DoubleValue cash_flows_from_financing_activities = 31;
   */
  cashFlowsFromFinancingActivities?: number

  /**
   * @generated from field: google.protobuf.DoubleValue cash_and_cash_equivalents_end_of_period = 32;
   */
  cashAndCashEquivalentsEndOfPeriod?: number

  /**
   * @generated from field: google.protobuf.StringValue number_of_employees = 33;
   */
  numberOfEmployees?: string

  /**
   * @generated from field: google.protobuf.Struct column_missing_reason = 34;
   */
  columnMissingReason?: Struct

  constructor(data?: PartialMessage<UsecaseTableKeyManagementIndicatorsConsolidated>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.UsecaseTableKeyManagementIndicatorsConsolidated'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'edinet_file_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'submission_date', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'edinet_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'filer_name', kind: 'message', T: StringValue },
    { no: 6, name: 'sec_code', kind: 'message', T: StringValue },
    { no: 7, name: 'doc_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 8, name: 'doc_description', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 9, name: 'securities_report_chunk_ids', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: 'original_filename', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 11, name: 'period_start', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 12, name: 'period_end', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 13, name: 'doc_type_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 14, name: 'fiscal_year_end_year', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 15, name: 'fiscal_year_end_month', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 16, name: 'fiscal_year', kind: 'message', T: StringValue },
    { no: 17, name: 'revenue', kind: 'message', T: DoubleValue },
    { no: 18, name: 'ordinary_income_loss', kind: 'message', T: DoubleValue },
    { no: 19, name: 'net_income_loss_attributable_to_owners_of_parent', kind: 'message', T: DoubleValue },
    { no: 20, name: 'comprehensive_income', kind: 'message', T: DoubleValue },
    { no: 21, name: 'net_assets', kind: 'message', T: DoubleValue },
    { no: 22, name: 'total_assets', kind: 'message', T: DoubleValue },
    { no: 23, name: 'net_assets_per_share', kind: 'message', T: DoubleValue },
    { no: 24, name: 'net_income_loss_per_share', kind: 'message', T: DoubleValue },
    { no: 25, name: 'diluted_net_income_per_share', kind: 'message', T: DoubleValue },
    { no: 26, name: 'equity_ratio', kind: 'message', T: DoubleValue },
    { no: 27, name: 'return_on_equity', kind: 'message', T: DoubleValue },
    { no: 28, name: 'price_earnings_ratio', kind: 'message', T: DoubleValue },
    { no: 29, name: 'cash_flows_from_operating_activities', kind: 'message', T: DoubleValue },
    { no: 30, name: 'cash_flows_from_investing_activities', kind: 'message', T: DoubleValue },
    { no: 31, name: 'cash_flows_from_financing_activities', kind: 'message', T: DoubleValue },
    { no: 32, name: 'cash_and_cash_equivalents_end_of_period', kind: 'message', T: DoubleValue },
    { no: 33, name: 'number_of_employees', kind: 'message', T: StringValue },
    { no: 34, name: 'column_missing_reason', kind: 'message', T: Struct },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UsecaseTableKeyManagementIndicatorsConsolidated {
    return new UsecaseTableKeyManagementIndicatorsConsolidated().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UsecaseTableKeyManagementIndicatorsConsolidated {
    return new UsecaseTableKeyManagementIndicatorsConsolidated().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UsecaseTableKeyManagementIndicatorsConsolidated {
    return new UsecaseTableKeyManagementIndicatorsConsolidated().fromJsonString(jsonString, options)
  }

  static equals(
    a: UsecaseTableKeyManagementIndicatorsConsolidated | PlainMessage<UsecaseTableKeyManagementIndicatorsConsolidated> | undefined,
    b: UsecaseTableKeyManagementIndicatorsConsolidated | PlainMessage<UsecaseTableKeyManagementIndicatorsConsolidated> | undefined,
  ): boolean {
    return proto3.util.equals(UsecaseTableKeyManagementIndicatorsConsolidated, a, b)
  }
}

/**
 * @generated from message models.UsecaseTableKeyManagementIndicatorsNonConsolidated
 */
export class UsecaseTableKeyManagementIndicatorsNonConsolidated extends Message<UsecaseTableKeyManagementIndicatorsNonConsolidated> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string edinet_file_id = 2;
   */
  edinetFileId = ''

  /**
   * @generated from field: string submission_date = 3;
   */
  submissionDate = ''

  /**
   * @generated from field: string edinet_code = 4;
   */
  edinetCode = ''

  /**
   * @generated from field: google.protobuf.StringValue filer_name = 5;
   */
  filerName?: string

  /**
   * @generated from field: google.protobuf.StringValue sec_code = 6;
   */
  secCode?: string

  /**
   * @generated from field: string doc_id = 7;
   */
  docId = ''

  /**
   * @generated from field: string doc_description = 8;
   */
  docDescription = ''

  /**
   * @generated from field: repeated string securities_report_chunk_ids = 9;
   */
  securitiesReportChunkIds: string[] = []

  /**
   * @generated from field: string original_filename = 10;
   */
  originalFilename = ''

  /**
   * @generated from field: string period_start = 11;
   */
  periodStart = ''

  /**
   * @generated from field: string period_end = 12;
   */
  periodEnd = ''

  /**
   * @generated from field: string doc_type_code = 13;
   */
  docTypeCode = ''

  /**
   * @generated from field: double fiscal_year_end_year = 14;
   */
  fiscalYearEndYear = 0

  /**
   * @generated from field: double fiscal_year_end_month = 15;
   */
  fiscalYearEndMonth = 0

  /**
   * @generated from field: google.protobuf.StringValue fiscal_year = 16;
   */
  fiscalYear?: string

  /**
   * @generated from field: google.protobuf.DoubleValue revenue = 17;
   */
  revenue?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ordinary_income_loss = 18;
   */
  ordinaryIncomeLoss?: number

  /**
   * @generated from field: google.protobuf.DoubleValue net_income_loss_attributable_to_owners_of_parent = 19;
   */
  netIncomeLossAttributableToOwnersOfParent?: number

  /**
   * @generated from field: google.protobuf.DoubleValue comprehensive_income = 20;
   */
  comprehensiveIncome?: number

  /**
   * @generated from field: google.protobuf.DoubleValue net_assets = 21;
   */
  netAssets?: number

  /**
   * @generated from field: google.protobuf.DoubleValue total_assets = 22;
   */
  totalAssets?: number

  /**
   * @generated from field: google.protobuf.DoubleValue net_assets_per_share = 23;
   */
  netAssetsPerShare?: number

  /**
   * @generated from field: google.protobuf.DoubleValue net_income_loss_per_share = 24;
   */
  netIncomeLossPerShare?: number

  /**
   * @generated from field: google.protobuf.DoubleValue diluted_net_income_per_share = 25;
   */
  dilutedNetIncomePerShare?: number

  /**
   * @generated from field: google.protobuf.DoubleValue equity_ratio = 26;
   */
  equityRatio?: number

  /**
   * @generated from field: google.protobuf.DoubleValue return_on_equity = 27;
   */
  returnOnEquity?: number

  /**
   * @generated from field: google.protobuf.DoubleValue price_earnings_ratio = 28;
   */
  priceEarningsRatio?: number

  /**
   * @generated from field: google.protobuf.DoubleValue cash_flows_from_operating_activities = 29;
   */
  cashFlowsFromOperatingActivities?: number

  /**
   * @generated from field: google.protobuf.DoubleValue cash_flows_from_investing_activities = 30;
   */
  cashFlowsFromInvestingActivities?: number

  /**
   * @generated from field: google.protobuf.DoubleValue cash_flows_from_financing_activities = 31;
   */
  cashFlowsFromFinancingActivities?: number

  /**
   * @generated from field: google.protobuf.DoubleValue cash_and_cash_equivalents_end_of_period = 32;
   */
  cashAndCashEquivalentsEndOfPeriod?: number

  /**
   * @generated from field: google.protobuf.StringValue number_of_employees = 33;
   */
  numberOfEmployees?: string

  /**
   * @generated from field: google.protobuf.Struct column_missing_reason = 34;
   */
  columnMissingReason?: Struct

  constructor(data?: PartialMessage<UsecaseTableKeyManagementIndicatorsNonConsolidated>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.UsecaseTableKeyManagementIndicatorsNonConsolidated'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'edinet_file_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'submission_date', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'edinet_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'filer_name', kind: 'message', T: StringValue },
    { no: 6, name: 'sec_code', kind: 'message', T: StringValue },
    { no: 7, name: 'doc_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 8, name: 'doc_description', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 9, name: 'securities_report_chunk_ids', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: 'original_filename', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 11, name: 'period_start', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 12, name: 'period_end', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 13, name: 'doc_type_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 14, name: 'fiscal_year_end_year', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 15, name: 'fiscal_year_end_month', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 16, name: 'fiscal_year', kind: 'message', T: StringValue },
    { no: 17, name: 'revenue', kind: 'message', T: DoubleValue },
    { no: 18, name: 'ordinary_income_loss', kind: 'message', T: DoubleValue },
    { no: 19, name: 'net_income_loss_attributable_to_owners_of_parent', kind: 'message', T: DoubleValue },
    { no: 20, name: 'comprehensive_income', kind: 'message', T: DoubleValue },
    { no: 21, name: 'net_assets', kind: 'message', T: DoubleValue },
    { no: 22, name: 'total_assets', kind: 'message', T: DoubleValue },
    { no: 23, name: 'net_assets_per_share', kind: 'message', T: DoubleValue },
    { no: 24, name: 'net_income_loss_per_share', kind: 'message', T: DoubleValue },
    { no: 25, name: 'diluted_net_income_per_share', kind: 'message', T: DoubleValue },
    { no: 26, name: 'equity_ratio', kind: 'message', T: DoubleValue },
    { no: 27, name: 'return_on_equity', kind: 'message', T: DoubleValue },
    { no: 28, name: 'price_earnings_ratio', kind: 'message', T: DoubleValue },
    { no: 29, name: 'cash_flows_from_operating_activities', kind: 'message', T: DoubleValue },
    { no: 30, name: 'cash_flows_from_investing_activities', kind: 'message', T: DoubleValue },
    { no: 31, name: 'cash_flows_from_financing_activities', kind: 'message', T: DoubleValue },
    { no: 32, name: 'cash_and_cash_equivalents_end_of_period', kind: 'message', T: DoubleValue },
    { no: 33, name: 'number_of_employees', kind: 'message', T: StringValue },
    { no: 34, name: 'column_missing_reason', kind: 'message', T: Struct },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UsecaseTableKeyManagementIndicatorsNonConsolidated {
    return new UsecaseTableKeyManagementIndicatorsNonConsolidated().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UsecaseTableKeyManagementIndicatorsNonConsolidated {
    return new UsecaseTableKeyManagementIndicatorsNonConsolidated().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UsecaseTableKeyManagementIndicatorsNonConsolidated {
    return new UsecaseTableKeyManagementIndicatorsNonConsolidated().fromJsonString(jsonString, options)
  }

  static equals(
    a: UsecaseTableKeyManagementIndicatorsNonConsolidated | PlainMessage<UsecaseTableKeyManagementIndicatorsNonConsolidated> | undefined,
    b: UsecaseTableKeyManagementIndicatorsNonConsolidated | PlainMessage<UsecaseTableKeyManagementIndicatorsNonConsolidated> | undefined,
  ): boolean {
    return proto3.util.equals(UsecaseTableKeyManagementIndicatorsNonConsolidated, a, b)
  }
}

/**
 * @generated from message models.UsecaseTablePlFull
 */
export class UsecaseTablePlFull extends Message<UsecaseTablePlFull> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string edinet_file_id = 2;
   */
  edinetFileId = ''

  /**
   * @generated from field: string submission_date = 3;
   */
  submissionDate = ''

  /**
   * @generated from field: string edinet_code = 4;
   */
  edinetCode = ''

  /**
   * @generated from field: google.protobuf.StringValue filer_name = 5;
   */
  filerName?: string

  /**
   * @generated from field: google.protobuf.StringValue sec_code = 6;
   */
  secCode?: string

  /**
   * @generated from field: string doc_id = 7;
   */
  docId = ''

  /**
   * @generated from field: string doc_description = 8;
   */
  docDescription = ''

  /**
   * @generated from field: repeated string securities_report_chunk_ids = 9;
   */
  securitiesReportChunkIds: string[] = []

  /**
   * @generated from field: string original_filename = 10;
   */
  originalFilename = ''

  /**
   * @generated from field: string period_start = 11;
   */
  periodStart = ''

  /**
   * @generated from field: string period_end = 12;
   */
  periodEnd = ''

  /**
   * @generated from field: string doc_type_code = 13;
   */
  docTypeCode = ''

  /**
   * @generated from field: double fiscal_year_end_year = 14;
   */
  fiscalYearEndYear = 0

  /**
   * @generated from field: double fiscal_year_end_month = 15;
   */
  fiscalYearEndMonth = 0

  /**
   * @generated from field: google.protobuf.StringValue accounting_standard = 16;
   */
  accountingStandard?: string

  /**
   * @generated from field: google.protobuf.DoubleValue unit = 17;
   */
  unit?: number

  /**
   * @generated from field: google.protobuf.StringValue unit_text = 18;
   */
  unitText?: string

  /**
   * @generated from field: google.protobuf.DoubleValue highlight_revenue_jpy = 19;
   */
  highlightRevenueJpy?: number

  /**
   * @generated from field: google.protobuf.DoubleValue highlight_cost_of_sales_jpy = 20;
   */
  highlightCostOfSalesJpy?: number

  /**
   * @generated from field: google.protobuf.DoubleValue highlight_gross_profit_jpy = 21;
   */
  highlightGrossProfitJpy?: number

  /**
   * @generated from field: google.protobuf.DoubleValue highlight_selling_general_admin_expenses_jpy = 22;
   */
  highlightSellingGeneralAdminExpensesJpy?: number

  /**
   * @generated from field: google.protobuf.DoubleValue highlight_operating_profit_jpy = 23;
   */
  highlightOperatingProfitJpy?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_revenue = 24;
   */
  ifrsGeneralRevenue?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_gains_and_losses_from_derec_of_fa_at_ac = 25;
   */
  ifrsGeneralGainsAndLossesFromDerecOfFaAtAc?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_finance_costs = 26;
   */
  ifrsGeneralFinanceCosts?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_share_of_pol_of_ajv_using_equity_method = 27;
   */
  ifrsGeneralShareOfPolOfAjvUsingEquityMethod?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_gains_and_losses_from_diff_between_prev_ac_and_fv = 28;
   */
  ifrsGeneralGainsAndLossesFromDiffBetweenPrevAcAndFv?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_tax_expense = 29;
   */
  ifrsGeneralTaxExpense?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_discontinued_operations = 30;
   */
  ifrsGeneralDiscontinuedOperations?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_profit_or_loss = 31;
   */
  ifrsGeneralProfitOrLoss?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_pol_attr_to_owners_of_parent = 32;
   */
  ifrsGeneralPolAttrToOwnersOfParent?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_pol_attr_to_nci = 33;
   */
  ifrsGeneralPolAttrToNci?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_items_not_reclassified_subsequently_to_pol = 34;
   */
  ifrsGeneralItemsNotReclassifiedSubsequentlyToPol?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_items_reclassified_subsequently_to_pol = 35;
   */
  ifrsGeneralItemsReclassifiedSubsequentlyToPol?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_share_of_oci_of_ajv = 36;
   */
  ifrsGeneralShareOfOciOfAjv?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_total_other_comprehensive_income = 37;
   */
  ifrsGeneralTotalOtherComprehensiveIncome?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_total_comprehensive_income_for_the_period = 38;
   */
  ifrsGeneralTotalComprehensiveIncomeForThePeriod?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_fi_interest_income_calc_using_eim = 39;
   */
  ifrsFiInterestIncomeCalcUsingEim?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_financial_institutions_other_interest_income = 40;
   */
  ifrsFinancialInstitutionsOtherInterestIncome?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_financial_institutions_interest_expense = 41;
   */
  ifrsFinancialInstitutionsInterestExpense?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_financial_institutions_net_interest_income = 42;
   */
  ifrsFinancialInstitutionsNetInterestIncome?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_financial_institutions_fee_and_commission_income = 43;
   */
  ifrsFinancialInstitutionsFeeAndCommissionIncome?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_financial_institutions_fee_and_commission_expense = 44;
   */
  ifrsFinancialInstitutionsFeeAndCommissionExpense?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_financial_institutions_net_fee_and_commission_income = 45;
   */
  ifrsFinancialInstitutionsNetFeeAndCommissionIncome?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_financial_institutions_net_trading_income = 46;
   */
  ifrsFinancialInstitutionsNetTradingIncome?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_fi_net_income_from_other_fi_at_fvtpl = 47;
   */
  ifrsFiNetIncomeFromOtherFiAtFvtpl?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_financial_institutions_credit_impairment_losses = 48;
   */
  ifrsFinancialInstitutionsCreditImpairmentLosses?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_insurance_industry_insurance_revenue = 49;
   */
  ifrsInsuranceIndustryInsuranceRevenue?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_insurance_industry_insurance_service_expenses = 50;
   */
  ifrsInsuranceIndustryInsuranceServiceExpenses?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_insurance_industry_insurance_service_result = 51;
   */
  ifrsInsuranceIndustryInsuranceServiceResult?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_insurance_industry_allocation_of_reinsurance_premiums = 52;
   */
  ifrsInsuranceIndustryAllocationOfReinsurancePremiums?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_insurance_amounts_recoverable_from_reinsurers_for_claims = 53;
   */
  ifrsInsuranceAmountsRecoverableFromReinsurersForClaims?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_insurance_net_income_expenses_from_reinsurance_held = 54;
   */
  ifrsInsuranceNetIncomeExpensesFromReinsuranceHeld?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_insurance_industry_insurance_finance_income_or_expenses = 55;
   */
  ifrsInsuranceIndustryInsuranceFinanceIncomeOrExpenses?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_insurance_industry_reinsurance_finance_income_or_expenses = 56;
   */
  ifrsInsuranceIndustryReinsuranceFinanceIncomeOrExpenses?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_insurance_industry_net_insurance_finance_result = 57;
   */
  ifrsInsuranceIndustryNetInsuranceFinanceResult?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_agriculture_gains_and_losses_from_fv_changes_of_bio_assets = 58;
   */
  ifrsAgricultureGainsAndLossesFromFvChangesOfBioAssets?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_efaeomr_exploration_and_evaluation_expenses = 59;
   */
  ifrsEfaeomrExplorationAndEvaluationExpenses?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_efaeomr_impairment_losses_on_eae_assets = 60;
   */
  ifrsEfaeomrImpairmentLossesOnEaeAssets?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_rra_net_movement_in_rdab_related_to_pol = 61;
   */
  ifrsRraNetMovementInRdabRelatedToPol?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_rra_net_movement_in_rdab_related_to_oci = 62;
   */
  ifrsRraNetMovementInRdabRelatedToOci?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_ie_net_gain_or_loss_on_fa_at_fvtpl = 63;
   */
  ifrsIeNetGainOrLossOnFaAtFvtpl?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_ie_dividend_income_from_investments_at_fvtpl = 64;
   */
  ifrsIeDividendIncomeFromInvestmentsAtFvtpl?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_net_sales = 65;
   */
  jgaapGeneralNetSales?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_cost_of_sales = 66;
   */
  jgaapGeneralCostOfSales?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_gross_profit = 67;
   */
  jgaapGeneralGrossProfit?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_selling_general_and_administrative_expenses = 68;
   */
  jgaapGeneralSellingGeneralAndAdministrativeExpenses?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_operating_profit_or_operating_loss = 69;
   */
  jgaapGeneralOperatingProfitOrOperatingLoss?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_non_operating_income = 70;
   */
  jgaapGeneralNonOperatingIncome?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_non_operating_expenses = 71;
   */
  jgaapGeneralNonOperatingExpenses?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_ordinary_profit_or_ordinary_loss = 72;
   */
  jgaapGeneralOrdinaryProfitOrOrdinaryLoss?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_extraordinary_income = 73;
   */
  jgaapGeneralExtraordinaryIncome?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_extraordinary_losses = 74;
   */
  jgaapGeneralExtraordinaryLosses?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_profit_before_income_taxes = 75;
   */
  jgaapGeneralProfitBeforeIncomeTaxes?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_income_taxes_current = 76;
   */
  jgaapGeneralIncomeTaxesCurrent?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_income_taxes_deferred = 77;
   */
  jgaapGeneralIncomeTaxesDeferred?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_profit = 78;
   */
  jgaapGeneralProfit?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_profit_attributable_to_non_controlling_interests = 79;
   */
  jgaapGeneralProfitAttributableToNonControllingInterests?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_profit_attributable_to_owners_of_parent = 80;
   */
  jgaapGeneralProfitAttributableToOwnersOfParent?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_other_comprehensive_income = 81;
   */
  jgaapGeneralOtherComprehensiveIncome?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_comprehensive_income = 82;
   */
  jgaapGeneralComprehensiveIncome?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_depreciation_amortization = 83;
   */
  jgaapGeneralDepreciationAmortization?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_interest_income = 84;
   */
  jgaapGeneralInterestIncome?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_interest_expenses = 85;
   */
  jgaapGeneralInterestExpenses?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_personnel_expenses = 86;
   */
  jgaapGeneralPersonnelExpenses?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_labor_cost = 87;
   */
  jgaapGeneralLaborCost?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_advertising_expenses = 88;
   */
  jgaapGeneralAdvertisingExpenses?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_research_development_expenses = 89;
   */
  jgaapGeneralResearchDevelopmentExpenses?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_rent_expenses = 90;
   */
  jgaapGeneralRentExpenses?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_eps_basic = 91;
   */
  jgaapGeneralEpsBasic?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_eps_diluted = 92;
   */
  jgaapGeneralEpsDiluted?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_construction_net_sales_of_completed_cc = 93;
   */
  jgaapConstructionNetSalesOfCompletedCc?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_construction_cos_of_completed_cc = 94;
   */
  jgaapConstructionCosOfCompletedCc?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_construction_gross_profit_on_completed_cc = 95;
   */
  jgaapConstructionGrossProfitOnCompletedCc?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_banking_ordinary_income = 96;
   */
  jgaapBankingOrdinaryIncome?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_banking_interest_income = 97;
   */
  jgaapBankingInterestIncome?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_banking_interest_on_loans_and_discounts = 98;
   */
  jgaapBankingInterestOnLoansAndDiscounts?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_banking_interest_and_dividends_on_securities = 99;
   */
  jgaapBankingInterestAndDividendsOnSecurities?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_banking_fees_and_commissions = 100;
   */
  jgaapBankingFeesAndCommissions?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_banking_trading_income = 101;
   */
  jgaapBankingTradingIncome?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_banking_other_operating_income = 102;
   */
  jgaapBankingOtherOperatingIncome?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_banking_other_ordinary_income = 103;
   */
  jgaapBankingOtherOrdinaryIncome?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_banking_ordinary_expenses = 104;
   */
  jgaapBankingOrdinaryExpenses?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_banking_interest_expenses = 105;
   */
  jgaapBankingInterestExpenses?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_banking_interest_on_deposits = 106;
   */
  jgaapBankingInterestOnDeposits?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_banking_fees_and_commissions_payments = 107;
   */
  jgaapBankingFeesAndCommissionsPayments?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_banking_trading_expenses = 108;
   */
  jgaapBankingTradingExpenses?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_banking_other_operating_expenses = 109;
   */
  jgaapBankingOtherOperatingExpenses?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_banking_general_and_administrative_expenses = 110;
   */
  jgaapBankingGeneralAndAdministrativeExpenses?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_banking_other_ordinary_expenses = 111;
   */
  jgaapBankingOtherOrdinaryExpenses?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_banking_ordinary_profit = 112;
   */
  jgaapBankingOrdinaryProfit?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_securities_operating_revenue = 113;
   */
  jgaapSecuritiesOperatingRevenue?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_securities_commissions_received = 114;
   */
  jgaapSecuritiesCommissionsReceived?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_securities_brokerage_commissions = 115;
   */
  jgaapSecuritiesBrokerageCommissions?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_securities_underwriting_and_selling_commissions = 116;
   */
  jgaapSecuritiesUnderwritingAndSellingCommissions?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_securities_subscription_and_distribution_commissions = 117;
   */
  jgaapSecuritiesSubscriptionAndDistributionCommissions?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_securities_net_trading_income = 118;
   */
  jgaapSecuritiesNetTradingIncome?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_securities_financial_revenue = 119;
   */
  jgaapSecuritiesFinancialRevenue?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_securities_financial_expenses = 120;
   */
  jgaapSecuritiesFinancialExpenses?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_securities_selling_general_and_administrative_expenses = 121;
   */
  jgaapSecuritiesSellingGeneralAndAdministrativeExpenses?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_securities_transaction_expenses = 122;
   */
  jgaapSecuritiesTransactionExpenses?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_securities_operating_profit = 123;
   */
  jgaapSecuritiesOperatingProfit?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_insurance_ordinary_income = 124;
   */
  jgaapInsuranceOrdinaryIncome?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_insurance_underwriting_income = 125;
   */
  jgaapInsuranceUnderwritingIncome?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_insurance_premium_income = 126;
   */
  jgaapInsurancePremiumIncome?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_insurance_net_premiums_written = 127;
   */
  jgaapInsuranceNetPremiumsWritten?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_insurance_investment_income = 128;
   */
  jgaapInsuranceInvestmentIncome?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_insurance_investment_income_on_separate_accounts = 129;
   */
  jgaapInsuranceInvestmentIncomeOnSeparateAccounts?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_insurance_interest_and_dividends_income = 130;
   */
  jgaapInsuranceInterestAndDividendsIncome?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_insurance_other_ordinary_income = 131;
   */
  jgaapInsuranceOtherOrdinaryIncome?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_insurance_ordinary_expenses = 132;
   */
  jgaapInsuranceOrdinaryExpenses?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_insurance_underwriting_expenses = 133;
   */
  jgaapInsuranceUnderwritingExpenses?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_insurance_claims_and_other_payments = 134;
   */
  jgaapInsuranceClaimsAndOtherPayments?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_insurance_claims_paid = 135;
   */
  jgaapInsuranceClaimsPaid?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_insurance_insurance_claims = 136;
   */
  jgaapInsuranceInsuranceClaims?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_insurance_annuity_payments = 137;
   */
  jgaapInsuranceAnnuityPayments?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_insurance_benefits = 138;
   */
  jgaapInsuranceBenefits?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_insurance_surrender_values = 139;
   */
  jgaapInsuranceSurrenderValues?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_insurance_other_refunds = 140;
   */
  jgaapInsuranceOtherRefunds?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_insurance_reinsurance_premiums = 141;
   */
  jgaapInsuranceReinsurancePremiums?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_insurance_provision_for_policy_reserves = 142;
   */
  jgaapInsuranceProvisionForPolicyReserves?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_insurance_investment_expenses = 143;
   */
  jgaapInsuranceInvestmentExpenses?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_insurance_investment_losses_on_separate_accounts = 144;
   */
  jgaapInsuranceInvestmentLossesOnSeparateAccounts?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_insurance_operating_expenses = 145;
   */
  jgaapInsuranceOperatingExpenses?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_insurance_loss_adjustment_expenses = 146;
   */
  jgaapInsuranceLossAdjustmentExpenses?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_real_estate_revenue_from_real_estate_business = 147;
   */
  jgaapRealEstateRevenueFromRealEstateBusiness?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_real_estate_revenue_from_real_estate_leasing = 148;
   */
  jgaapRealEstateRevenueFromRealEstateLeasing?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_real_estate_cost_of_real_estate_business = 149;
   */
  jgaapRealEstateCostOfRealEstateBusiness?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_real_estate_cost_of_real_estate_sales = 150;
   */
  jgaapRealEstateCostOfRealEstateSales?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_real_estate_cost_of_real_estate_leasing = 151;
   */
  jgaapRealEstateCostOfRealEstateLeasing?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_railway_operating_revenues_from_railway_business = 152;
   */
  jgaapRailwayOperatingRevenuesFromRailwayBusiness?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_railway_operating_expenses_from_railway_business = 153;
   */
  jgaapRailwayOperatingExpensesFromRailwayBusiness?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_shipping_shipping_revenues = 154;
   */
  jgaapShippingShippingRevenues?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_shipping_shipping_expenses = 155;
   */
  jgaapShippingShippingExpenses?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_shipping_operating_expenses = 156;
   */
  jgaapShippingOperatingExpenses?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_epag_operating_revenues_from_eub = 157;
   */
  jgaapEpagOperatingRevenuesFromEub?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_epag_operating_expenses_from_eub = 158;
   */
  jgaapEpagOperatingExpensesFromEub?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_electric_power_and_gas_non_operating_income = 159;
   */
  jgaapElectricPowerAndGasNonOperatingIncome?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_electric_power_and_gas_non_operating_expenses = 160;
   */
  jgaapElectricPowerAndGasNonOperatingExpenses?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_leasing_lease_revenue = 161;
   */
  jgaapLeasingLeaseRevenue?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_leasing_lease_cost = 162;
   */
  jgaapLeasingLeaseCost?: number

  /**
   * @generated from field: google.protobuf.Struct column_missing_reason = 163;
   */
  columnMissingReason?: Struct

  constructor(data?: PartialMessage<UsecaseTablePlFull>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.UsecaseTablePlFull'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'edinet_file_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'submission_date', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'edinet_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'filer_name', kind: 'message', T: StringValue },
    { no: 6, name: 'sec_code', kind: 'message', T: StringValue },
    { no: 7, name: 'doc_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 8, name: 'doc_description', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 9, name: 'securities_report_chunk_ids', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: 'original_filename', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 11, name: 'period_start', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 12, name: 'period_end', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 13, name: 'doc_type_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 14, name: 'fiscal_year_end_year', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 15, name: 'fiscal_year_end_month', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 16, name: 'accounting_standard', kind: 'message', T: StringValue },
    { no: 17, name: 'unit', kind: 'message', T: DoubleValue },
    { no: 18, name: 'unit_text', kind: 'message', T: StringValue },
    { no: 19, name: 'highlight_revenue_jpy', kind: 'message', T: DoubleValue },
    { no: 20, name: 'highlight_cost_of_sales_jpy', kind: 'message', T: DoubleValue },
    { no: 21, name: 'highlight_gross_profit_jpy', kind: 'message', T: DoubleValue },
    { no: 22, name: 'highlight_selling_general_admin_expenses_jpy', kind: 'message', T: DoubleValue },
    { no: 23, name: 'highlight_operating_profit_jpy', kind: 'message', T: DoubleValue },
    { no: 24, name: 'ifrs_general_revenue', kind: 'message', T: DoubleValue },
    { no: 25, name: 'ifrs_general_gains_and_losses_from_derec_of_fa_at_ac', kind: 'message', T: DoubleValue },
    { no: 26, name: 'ifrs_general_finance_costs', kind: 'message', T: DoubleValue },
    { no: 27, name: 'ifrs_general_share_of_pol_of_ajv_using_equity_method', kind: 'message', T: DoubleValue },
    { no: 28, name: 'ifrs_general_gains_and_losses_from_diff_between_prev_ac_and_fv', kind: 'message', T: DoubleValue },
    { no: 29, name: 'ifrs_general_tax_expense', kind: 'message', T: DoubleValue },
    { no: 30, name: 'ifrs_general_discontinued_operations', kind: 'message', T: DoubleValue },
    { no: 31, name: 'ifrs_general_profit_or_loss', kind: 'message', T: DoubleValue },
    { no: 32, name: 'ifrs_general_pol_attr_to_owners_of_parent', kind: 'message', T: DoubleValue },
    { no: 33, name: 'ifrs_general_pol_attr_to_nci', kind: 'message', T: DoubleValue },
    { no: 34, name: 'ifrs_general_items_not_reclassified_subsequently_to_pol', kind: 'message', T: DoubleValue },
    { no: 35, name: 'ifrs_general_items_reclassified_subsequently_to_pol', kind: 'message', T: DoubleValue },
    { no: 36, name: 'ifrs_general_share_of_oci_of_ajv', kind: 'message', T: DoubleValue },
    { no: 37, name: 'ifrs_general_total_other_comprehensive_income', kind: 'message', T: DoubleValue },
    { no: 38, name: 'ifrs_general_total_comprehensive_income_for_the_period', kind: 'message', T: DoubleValue },
    { no: 39, name: 'ifrs_fi_interest_income_calc_using_eim', kind: 'message', T: DoubleValue },
    { no: 40, name: 'ifrs_financial_institutions_other_interest_income', kind: 'message', T: DoubleValue },
    { no: 41, name: 'ifrs_financial_institutions_interest_expense', kind: 'message', T: DoubleValue },
    { no: 42, name: 'ifrs_financial_institutions_net_interest_income', kind: 'message', T: DoubleValue },
    { no: 43, name: 'ifrs_financial_institutions_fee_and_commission_income', kind: 'message', T: DoubleValue },
    { no: 44, name: 'ifrs_financial_institutions_fee_and_commission_expense', kind: 'message', T: DoubleValue },
    { no: 45, name: 'ifrs_financial_institutions_net_fee_and_commission_income', kind: 'message', T: DoubleValue },
    { no: 46, name: 'ifrs_financial_institutions_net_trading_income', kind: 'message', T: DoubleValue },
    { no: 47, name: 'ifrs_fi_net_income_from_other_fi_at_fvtpl', kind: 'message', T: DoubleValue },
    { no: 48, name: 'ifrs_financial_institutions_credit_impairment_losses', kind: 'message', T: DoubleValue },
    { no: 49, name: 'ifrs_insurance_industry_insurance_revenue', kind: 'message', T: DoubleValue },
    { no: 50, name: 'ifrs_insurance_industry_insurance_service_expenses', kind: 'message', T: DoubleValue },
    { no: 51, name: 'ifrs_insurance_industry_insurance_service_result', kind: 'message', T: DoubleValue },
    { no: 52, name: 'ifrs_insurance_industry_allocation_of_reinsurance_premiums', kind: 'message', T: DoubleValue },
    { no: 53, name: 'ifrs_insurance_amounts_recoverable_from_reinsurers_for_claims', kind: 'message', T: DoubleValue },
    { no: 54, name: 'ifrs_insurance_net_income_expenses_from_reinsurance_held', kind: 'message', T: DoubleValue },
    { no: 55, name: 'ifrs_insurance_industry_insurance_finance_income_or_expenses', kind: 'message', T: DoubleValue },
    { no: 56, name: 'ifrs_insurance_industry_reinsurance_finance_income_or_expenses', kind: 'message', T: DoubleValue },
    { no: 57, name: 'ifrs_insurance_industry_net_insurance_finance_result', kind: 'message', T: DoubleValue },
    { no: 58, name: 'ifrs_agriculture_gains_and_losses_from_fv_changes_of_bio_assets', kind: 'message', T: DoubleValue },
    { no: 59, name: 'ifrs_efaeomr_exploration_and_evaluation_expenses', kind: 'message', T: DoubleValue },
    { no: 60, name: 'ifrs_efaeomr_impairment_losses_on_eae_assets', kind: 'message', T: DoubleValue },
    { no: 61, name: 'ifrs_rra_net_movement_in_rdab_related_to_pol', kind: 'message', T: DoubleValue },
    { no: 62, name: 'ifrs_rra_net_movement_in_rdab_related_to_oci', kind: 'message', T: DoubleValue },
    { no: 63, name: 'ifrs_ie_net_gain_or_loss_on_fa_at_fvtpl', kind: 'message', T: DoubleValue },
    { no: 64, name: 'ifrs_ie_dividend_income_from_investments_at_fvtpl', kind: 'message', T: DoubleValue },
    { no: 65, name: 'jgaap_general_net_sales', kind: 'message', T: DoubleValue },
    { no: 66, name: 'jgaap_general_cost_of_sales', kind: 'message', T: DoubleValue },
    { no: 67, name: 'jgaap_general_gross_profit', kind: 'message', T: DoubleValue },
    { no: 68, name: 'jgaap_general_selling_general_and_administrative_expenses', kind: 'message', T: DoubleValue },
    { no: 69, name: 'jgaap_general_operating_profit_or_operating_loss', kind: 'message', T: DoubleValue },
    { no: 70, name: 'jgaap_general_non_operating_income', kind: 'message', T: DoubleValue },
    { no: 71, name: 'jgaap_general_non_operating_expenses', kind: 'message', T: DoubleValue },
    { no: 72, name: 'jgaap_general_ordinary_profit_or_ordinary_loss', kind: 'message', T: DoubleValue },
    { no: 73, name: 'jgaap_general_extraordinary_income', kind: 'message', T: DoubleValue },
    { no: 74, name: 'jgaap_general_extraordinary_losses', kind: 'message', T: DoubleValue },
    { no: 75, name: 'jgaap_general_profit_before_income_taxes', kind: 'message', T: DoubleValue },
    { no: 76, name: 'jgaap_general_income_taxes_current', kind: 'message', T: DoubleValue },
    { no: 77, name: 'jgaap_general_income_taxes_deferred', kind: 'message', T: DoubleValue },
    { no: 78, name: 'jgaap_general_profit', kind: 'message', T: DoubleValue },
    { no: 79, name: 'jgaap_general_profit_attributable_to_non_controlling_interests', kind: 'message', T: DoubleValue },
    { no: 80, name: 'jgaap_general_profit_attributable_to_owners_of_parent', kind: 'message', T: DoubleValue },
    { no: 81, name: 'jgaap_general_other_comprehensive_income', kind: 'message', T: DoubleValue },
    { no: 82, name: 'jgaap_general_comprehensive_income', kind: 'message', T: DoubleValue },
    { no: 83, name: 'jgaap_general_depreciation_amortization', kind: 'message', T: DoubleValue },
    { no: 84, name: 'jgaap_general_interest_income', kind: 'message', T: DoubleValue },
    { no: 85, name: 'jgaap_general_interest_expenses', kind: 'message', T: DoubleValue },
    { no: 86, name: 'jgaap_general_personnel_expenses', kind: 'message', T: DoubleValue },
    { no: 87, name: 'jgaap_general_labor_cost', kind: 'message', T: DoubleValue },
    { no: 88, name: 'jgaap_general_advertising_expenses', kind: 'message', T: DoubleValue },
    { no: 89, name: 'jgaap_general_research_development_expenses', kind: 'message', T: DoubleValue },
    { no: 90, name: 'jgaap_general_rent_expenses', kind: 'message', T: DoubleValue },
    { no: 91, name: 'jgaap_general_eps_basic', kind: 'message', T: DoubleValue },
    { no: 92, name: 'jgaap_general_eps_diluted', kind: 'message', T: DoubleValue },
    { no: 93, name: 'jgaap_construction_net_sales_of_completed_cc', kind: 'message', T: DoubleValue },
    { no: 94, name: 'jgaap_construction_cos_of_completed_cc', kind: 'message', T: DoubleValue },
    { no: 95, name: 'jgaap_construction_gross_profit_on_completed_cc', kind: 'message', T: DoubleValue },
    { no: 96, name: 'jgaap_banking_ordinary_income', kind: 'message', T: DoubleValue },
    { no: 97, name: 'jgaap_banking_interest_income', kind: 'message', T: DoubleValue },
    { no: 98, name: 'jgaap_banking_interest_on_loans_and_discounts', kind: 'message', T: DoubleValue },
    { no: 99, name: 'jgaap_banking_interest_and_dividends_on_securities', kind: 'message', T: DoubleValue },
    { no: 100, name: 'jgaap_banking_fees_and_commissions', kind: 'message', T: DoubleValue },
    { no: 101, name: 'jgaap_banking_trading_income', kind: 'message', T: DoubleValue },
    { no: 102, name: 'jgaap_banking_other_operating_income', kind: 'message', T: DoubleValue },
    { no: 103, name: 'jgaap_banking_other_ordinary_income', kind: 'message', T: DoubleValue },
    { no: 104, name: 'jgaap_banking_ordinary_expenses', kind: 'message', T: DoubleValue },
    { no: 105, name: 'jgaap_banking_interest_expenses', kind: 'message', T: DoubleValue },
    { no: 106, name: 'jgaap_banking_interest_on_deposits', kind: 'message', T: DoubleValue },
    { no: 107, name: 'jgaap_banking_fees_and_commissions_payments', kind: 'message', T: DoubleValue },
    { no: 108, name: 'jgaap_banking_trading_expenses', kind: 'message', T: DoubleValue },
    { no: 109, name: 'jgaap_banking_other_operating_expenses', kind: 'message', T: DoubleValue },
    { no: 110, name: 'jgaap_banking_general_and_administrative_expenses', kind: 'message', T: DoubleValue },
    { no: 111, name: 'jgaap_banking_other_ordinary_expenses', kind: 'message', T: DoubleValue },
    { no: 112, name: 'jgaap_banking_ordinary_profit', kind: 'message', T: DoubleValue },
    { no: 113, name: 'jgaap_securities_operating_revenue', kind: 'message', T: DoubleValue },
    { no: 114, name: 'jgaap_securities_commissions_received', kind: 'message', T: DoubleValue },
    { no: 115, name: 'jgaap_securities_brokerage_commissions', kind: 'message', T: DoubleValue },
    { no: 116, name: 'jgaap_securities_underwriting_and_selling_commissions', kind: 'message', T: DoubleValue },
    { no: 117, name: 'jgaap_securities_subscription_and_distribution_commissions', kind: 'message', T: DoubleValue },
    { no: 118, name: 'jgaap_securities_net_trading_income', kind: 'message', T: DoubleValue },
    { no: 119, name: 'jgaap_securities_financial_revenue', kind: 'message', T: DoubleValue },
    { no: 120, name: 'jgaap_securities_financial_expenses', kind: 'message', T: DoubleValue },
    { no: 121, name: 'jgaap_securities_selling_general_and_administrative_expenses', kind: 'message', T: DoubleValue },
    { no: 122, name: 'jgaap_securities_transaction_expenses', kind: 'message', T: DoubleValue },
    { no: 123, name: 'jgaap_securities_operating_profit', kind: 'message', T: DoubleValue },
    { no: 124, name: 'jgaap_insurance_ordinary_income', kind: 'message', T: DoubleValue },
    { no: 125, name: 'jgaap_insurance_underwriting_income', kind: 'message', T: DoubleValue },
    { no: 126, name: 'jgaap_insurance_premium_income', kind: 'message', T: DoubleValue },
    { no: 127, name: 'jgaap_insurance_net_premiums_written', kind: 'message', T: DoubleValue },
    { no: 128, name: 'jgaap_insurance_investment_income', kind: 'message', T: DoubleValue },
    { no: 129, name: 'jgaap_insurance_investment_income_on_separate_accounts', kind: 'message', T: DoubleValue },
    { no: 130, name: 'jgaap_insurance_interest_and_dividends_income', kind: 'message', T: DoubleValue },
    { no: 131, name: 'jgaap_insurance_other_ordinary_income', kind: 'message', T: DoubleValue },
    { no: 132, name: 'jgaap_insurance_ordinary_expenses', kind: 'message', T: DoubleValue },
    { no: 133, name: 'jgaap_insurance_underwriting_expenses', kind: 'message', T: DoubleValue },
    { no: 134, name: 'jgaap_insurance_claims_and_other_payments', kind: 'message', T: DoubleValue },
    { no: 135, name: 'jgaap_insurance_claims_paid', kind: 'message', T: DoubleValue },
    { no: 136, name: 'jgaap_insurance_insurance_claims', kind: 'message', T: DoubleValue },
    { no: 137, name: 'jgaap_insurance_annuity_payments', kind: 'message', T: DoubleValue },
    { no: 138, name: 'jgaap_insurance_benefits', kind: 'message', T: DoubleValue },
    { no: 139, name: 'jgaap_insurance_surrender_values', kind: 'message', T: DoubleValue },
    { no: 140, name: 'jgaap_insurance_other_refunds', kind: 'message', T: DoubleValue },
    { no: 141, name: 'jgaap_insurance_reinsurance_premiums', kind: 'message', T: DoubleValue },
    { no: 142, name: 'jgaap_insurance_provision_for_policy_reserves', kind: 'message', T: DoubleValue },
    { no: 143, name: 'jgaap_insurance_investment_expenses', kind: 'message', T: DoubleValue },
    { no: 144, name: 'jgaap_insurance_investment_losses_on_separate_accounts', kind: 'message', T: DoubleValue },
    { no: 145, name: 'jgaap_insurance_operating_expenses', kind: 'message', T: DoubleValue },
    { no: 146, name: 'jgaap_insurance_loss_adjustment_expenses', kind: 'message', T: DoubleValue },
    { no: 147, name: 'jgaap_real_estate_revenue_from_real_estate_business', kind: 'message', T: DoubleValue },
    { no: 148, name: 'jgaap_real_estate_revenue_from_real_estate_leasing', kind: 'message', T: DoubleValue },
    { no: 149, name: 'jgaap_real_estate_cost_of_real_estate_business', kind: 'message', T: DoubleValue },
    { no: 150, name: 'jgaap_real_estate_cost_of_real_estate_sales', kind: 'message', T: DoubleValue },
    { no: 151, name: 'jgaap_real_estate_cost_of_real_estate_leasing', kind: 'message', T: DoubleValue },
    { no: 152, name: 'jgaap_railway_operating_revenues_from_railway_business', kind: 'message', T: DoubleValue },
    { no: 153, name: 'jgaap_railway_operating_expenses_from_railway_business', kind: 'message', T: DoubleValue },
    { no: 154, name: 'jgaap_shipping_shipping_revenues', kind: 'message', T: DoubleValue },
    { no: 155, name: 'jgaap_shipping_shipping_expenses', kind: 'message', T: DoubleValue },
    { no: 156, name: 'jgaap_shipping_operating_expenses', kind: 'message', T: DoubleValue },
    { no: 157, name: 'jgaap_epag_operating_revenues_from_eub', kind: 'message', T: DoubleValue },
    { no: 158, name: 'jgaap_epag_operating_expenses_from_eub', kind: 'message', T: DoubleValue },
    { no: 159, name: 'jgaap_electric_power_and_gas_non_operating_income', kind: 'message', T: DoubleValue },
    { no: 160, name: 'jgaap_electric_power_and_gas_non_operating_expenses', kind: 'message', T: DoubleValue },
    { no: 161, name: 'jgaap_leasing_lease_revenue', kind: 'message', T: DoubleValue },
    { no: 162, name: 'jgaap_leasing_lease_cost', kind: 'message', T: DoubleValue },
    { no: 163, name: 'column_missing_reason', kind: 'message', T: Struct },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UsecaseTablePlFull {
    return new UsecaseTablePlFull().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UsecaseTablePlFull {
    return new UsecaseTablePlFull().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UsecaseTablePlFull {
    return new UsecaseTablePlFull().fromJsonString(jsonString, options)
  }

  static equals(
    a: UsecaseTablePlFull | PlainMessage<UsecaseTablePlFull> | undefined,
    b: UsecaseTablePlFull | PlainMessage<UsecaseTablePlFull> | undefined,
  ): boolean {
    return proto3.util.equals(UsecaseTablePlFull, a, b)
  }
}

/**
 * @generated from message models.UsecaseTableBsFull
 */
export class UsecaseTableBsFull extends Message<UsecaseTableBsFull> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string edinet_file_id = 2;
   */
  edinetFileId = ''

  /**
   * @generated from field: string submission_date = 3;
   */
  submissionDate = ''

  /**
   * @generated from field: string edinet_code = 4;
   */
  edinetCode = ''

  /**
   * @generated from field: google.protobuf.StringValue filer_name = 5;
   */
  filerName?: string

  /**
   * @generated from field: google.protobuf.StringValue sec_code = 6;
   */
  secCode?: string

  /**
   * @generated from field: string doc_id = 7;
   */
  docId = ''

  /**
   * @generated from field: string doc_description = 8;
   */
  docDescription = ''

  /**
   * @generated from field: repeated string securities_report_chunk_ids = 9;
   */
  securitiesReportChunkIds: string[] = []

  /**
   * @generated from field: string original_filename = 10;
   */
  originalFilename = ''

  /**
   * @generated from field: string period_start = 11;
   */
  periodStart = ''

  /**
   * @generated from field: string period_end = 12;
   */
  periodEnd = ''

  /**
   * @generated from field: string doc_type_code = 13;
   */
  docTypeCode = ''

  /**
   * @generated from field: double fiscal_year_end_year = 14;
   */
  fiscalYearEndYear = 0

  /**
   * @generated from field: double fiscal_year_end_month = 15;
   */
  fiscalYearEndMonth = 0

  /**
   * @generated from field: google.protobuf.StringValue accounting_standard = 16;
   */
  accountingStandard?: string

  /**
   * @generated from field: google.protobuf.DoubleValue unit = 17;
   */
  unit?: number

  /**
   * @generated from field: google.protobuf.StringValue unit_text = 18;
   */
  unitText?: string

  /**
   * @generated from field: google.protobuf.DoubleValue highlight_cash_and_deposits_jpy = 19;
   */
  highlightCashAndDepositsJpy?: number

  /**
   * @generated from field: google.protobuf.DoubleValue highlight_accounts_receivable_jpy = 20;
   */
  highlightAccountsReceivableJpy?: number

  /**
   * @generated from field: google.protobuf.DoubleValue highlight_inventories_jpy = 21;
   */
  highlightInventoriesJpy?: number

  /**
   * @generated from field: google.protobuf.DoubleValue highlight_property_plant_equipment_jpy = 22;
   */
  highlightPropertyPlantEquipmentJpy?: number

  /**
   * @generated from field: google.protobuf.DoubleValue highlight_total_assets_jpy = 23;
   */
  highlightTotalAssetsJpy?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_property_plant_and_equipment = 24;
   */
  ifrsGeneralPropertyPlantAndEquipment?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_investment_property = 25;
   */
  ifrsGeneralInvestmentProperty?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_intangible_assets = 26;
   */
  ifrsGeneralIntangibleAssets?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_financial_assets_excluding_cash_equivalents = 27;
   */
  ifrsGeneralFinancialAssetsExcludingCashEquivalents?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_investments_accounted_for_using_the_equity_method = 28;
   */
  ifrsGeneralInvestmentsAccountedForUsingTheEquityMethod?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_deferred_tax_assets = 29;
   */
  ifrsGeneralDeferredTaxAssets?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_total_non_current_assets = 30;
   */
  ifrsGeneralTotalNonCurrentAssets?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_inventories = 31;
   */
  ifrsGeneralInventories?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_trade_and_other_receivables = 32;
   */
  ifrsGeneralTradeAndOtherReceivables?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_cash_and_cash_equivalents = 33;
   */
  ifrsGeneralCashAndCashEquivalents?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_assets_held_for_sale = 34;
   */
  ifrsGeneralAssetsHeldForSale?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_total_current_assets = 35;
   */
  ifrsGeneralTotalCurrentAssets?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_total_assets = 36;
   */
  ifrsGeneralTotalAssets?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_total_fixed_assets = 37;
   */
  ifrsGeneralTotalFixedAssets?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_total_current_liabilities = 38;
   */
  ifrsGeneralTotalCurrentLiabilities?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_total_fixed_liabilities = 39;
   */
  ifrsGeneralTotalFixedLiabilities?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_total_liabilities = 40;
   */
  ifrsGeneralTotalLiabilities?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_non_controlling_interests = 41;
   */
  ifrsGeneralNonControllingInterests?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_issued_capital_and_reserves_attr_to_ootp = 42;
   */
  ifrsGeneralIssuedCapitalAndReservesAttrToOotp?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_total_equity = 43;
   */
  ifrsGeneralTotalEquity?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_total_equity_and_liabilities = 44;
   */
  ifrsGeneralTotalEquityAndLiabilities?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_fi_cash_and_balances_with_central_banks = 45;
   */
  ifrsFiCashAndBalancesWithCentralBanks?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_financial_institutions_loans_and_advances_to_banks = 46;
   */
  ifrsFinancialInstitutionsLoansAndAdvancesToBanks?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_financial_institutions_loans_and_advances_to_customers = 47;
   */
  ifrsFinancialInstitutionsLoansAndAdvancesToCustomers?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_fi_derivative_fi_assets = 48;
   */
  ifrsFiDerivativeFiAssets?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_financial_institutions_investment_securities = 49;
   */
  ifrsFinancialInstitutionsInvestmentSecurities?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_financial_institutions_trading_assets = 50;
   */
  ifrsFinancialInstitutionsTradingAssets?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_financial_institutions_pledged_assets = 51;
   */
  ifrsFinancialInstitutionsPledgedAssets?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_financial_institutions_deposits_from_banks = 52;
   */
  ifrsFinancialInstitutionsDepositsFromBanks?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_financial_institutions_deposits_from_customers = 53;
   */
  ifrsFinancialInstitutionsDepositsFromCustomers?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_fi_derivative_fi_liabilities = 54;
   */
  ifrsFiDerivativeFiLiabilities?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_financial_institutions_debt_securities_in_issue = 55;
   */
  ifrsFinancialInstitutionsDebtSecuritiesInIssue?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_financial_institutions_subordinated_liabilities = 56;
   */
  ifrsFinancialInstitutionsSubordinatedLiabilities?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_financial_institutions_trading_liabilities = 57;
   */
  ifrsFinancialInstitutionsTradingLiabilities?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_insurance_industry_insurance_contract_assets = 58;
   */
  ifrsInsuranceIndustryInsuranceContractAssets?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_insurance_industry_reinsurance_contract_assets = 59;
   */
  ifrsInsuranceIndustryReinsuranceContractAssets?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_insurance_industry_insurance_contract_liabilities = 60;
   */
  ifrsInsuranceIndustryInsuranceContractLiabilities?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_insurance_industry_reinsurance_contract_liabilities = 61;
   */
  ifrsInsuranceIndustryReinsuranceContractLiabilities?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_insurance_industry_investment_contract_liabilities = 62;
   */
  ifrsInsuranceIndustryInvestmentContractLiabilities?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_agriculture_biological_assets = 63;
   */
  ifrsAgricultureBiologicalAssets?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_agriculture_bearer_plants = 64;
   */
  ifrsAgricultureBearerPlants?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_agriculture_agricultural_produce_inventory_at_harvest = 65;
   */
  ifrsAgricultureAgriculturalProduceInventoryAtHarvest?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_efaeomr_exploration_and_evaluation_assets = 66;
   */
  ifrsEfaeomrExplorationAndEvaluationAssets?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_efaeomr_eae_assets_tangible = 67;
   */
  ifrsEfaeomrEaeAssetsTangible?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_efaeomr_eae_assets_intangible = 68;
   */
  ifrsEfaeomrEaeAssetsIntangible?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_efaeomr_liabilities_related_to_eae_assets = 69;
   */
  ifrsEfaeomrLiabilitiesRelatedToEaeAssets?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_rra_total_assets_subject_to_rate_reg = 70;
   */
  ifrsRraTotalAssetsSubjectToRateReg?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_rra_regulatory_deferral_account_debit_bal = 71;
   */
  ifrsRraRegulatoryDeferralAccountDebitBal?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_rra_regulatory_deferral_account_credit_bal = 72;
   */
  ifrsRraRegulatoryDeferralAccountCreditBal?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_ie_fa_at_fvtpl_investments_in_subs = 73;
   */
  ifrsIeFaAtFvtplInvestmentsInSubs?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_cash_and_deposits = 74;
   */
  jgaapGeneralCashAndDeposits?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_notes_and_ar_trade_and_contract_assets = 75;
   */
  jgaapGeneralNotesAndArTradeAndContractAssets?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_securities = 76;
   */
  jgaapGeneralSecurities?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_inventories = 77;
   */
  jgaapGeneralInventories?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_property_plant_and_equipment = 78;
   */
  jgaapGeneralPropertyPlantAndEquipment?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_intangible_assets = 79;
   */
  jgaapGeneralIntangibleAssets?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_investment_securities = 80;
   */
  jgaapGeneralInvestmentSecurities?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_deferred_tax_assets = 81;
   */
  jgaapGeneralDeferredTaxAssets?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_notes_and_accounts_payable_trade = 82;
   */
  jgaapGeneralNotesAndAccountsPayableTrade?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_short_term_borrowings = 83;
   */
  jgaapGeneralShortTermBorrowings?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_provisions = 84;
   */
  jgaapGeneralProvisions?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_bonds_payable = 85;
   */
  jgaapGeneralBondsPayable?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_long_term_borrowings = 86;
   */
  jgaapGeneralLongTermBorrowings?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_retirement_benefit_liability = 87;
   */
  jgaapGeneralRetirementBenefitLiability?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_share_capital = 88;
   */
  jgaapGeneralShareCapital?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_capital_surplus = 89;
   */
  jgaapGeneralCapitalSurplus?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_retained_earnings = 90;
   */
  jgaapGeneralRetainedEarnings?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_treasury_shares = 91;
   */
  jgaapGeneralTreasuryShares?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_accumulated_other_comprehensive_income = 92;
   */
  jgaapGeneralAccumulatedOtherComprehensiveIncome?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_non_controlling_interests = 93;
   */
  jgaapGeneralNonControllingInterests?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_total_current_assets = 94;
   */
  jgaapGeneralTotalCurrentAssets?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_total_fixed_assets = 95;
   */
  jgaapGeneralTotalFixedAssets?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_total_current_liabilities = 96;
   */
  jgaapGeneralTotalCurrentLiabilities?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_total_fixed_liabilities = 97;
   */
  jgaapGeneralTotalFixedLiabilities?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_total_liabilities = 98;
   */
  jgaapGeneralTotalLiabilities?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_total_net_assets = 99;
   */
  jgaapGeneralTotalNetAssets?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_total_assets = 100;
   */
  jgaapGeneralTotalAssets?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_accumulated_depreciation = 101;
   */
  jgaapGeneralAccumulatedDepreciation?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_subscription_rights_shares = 102;
   */
  jgaapGeneralSubscriptionRightsShares?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_advance_payments = 103;
   */
  jgaapGeneralAdvancePayments?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_prepaid_expenses = 104;
   */
  jgaapGeneralPrepaidExpenses?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_advances_received = 105;
   */
  jgaapGeneralAdvancesReceived?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_deferred_revenue = 106;
   */
  jgaapGeneralDeferredRevenue?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_construction_ar_from_completed_cc = 107;
   */
  jgaapConstructionArFromCompletedCc?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_construction_costs_on_uncompleted_construction_contracts = 108;
   */
  jgaapConstructionCostsOnUncompletedConstructionContracts?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_construction_advances_received_on_uncompleted_cc = 109;
   */
  jgaapConstructionAdvancesReceivedOnUncompletedCc?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_construction_materials_and_supplies = 110;
   */
  jgaapConstructionMaterialsAndSupplies?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_construction_accounts_payable_for_construction_contracts = 111;
   */
  jgaapConstructionAccountsPayableForConstructionContracts?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_construction_provision_for_loss_on_construction_contracts = 112;
   */
  jgaapConstructionProvisionForLossOnConstructionContracts?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_construction_provision_for_warranties_for_completed_c = 113;
   */
  jgaapConstructionProvisionForWarrantiesForCompletedC?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_banking_cash_and_due_from_banks = 114;
   */
  jgaapBankingCashAndDueFromBanks?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_banking_call_loans_and_bills_bought = 115;
   */
  jgaapBankingCallLoansAndBillsBought?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_banking_monetary_claims_bought = 116;
   */
  jgaapBankingMonetaryClaimsBought?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_banking_trading_assets = 117;
   */
  jgaapBankingTradingAssets?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_banking_money_held_in_trust = 118;
   */
  jgaapBankingMoneyHeldInTrust?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_banking_securities = 119;
   */
  jgaapBankingSecurities?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_banking_loans_and_bills_discounted = 120;
   */
  jgaapBankingLoansAndBillsDiscounted?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_banking_foreign_exchanges_assets = 121;
   */
  jgaapBankingForeignExchangesAssets?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_banking_derivatives_assets = 122;
   */
  jgaapBankingDerivativesAssets?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_banking_deposits = 123;
   */
  jgaapBankingDeposits?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_banking_negotiable_certificates_of_deposit = 124;
   */
  jgaapBankingNegotiableCertificatesOfDeposit?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_banking_call_money_and_bills_sold = 125;
   */
  jgaapBankingCallMoneyAndBillsSold?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_banking_payables_under_securities_lending_transactions = 126;
   */
  jgaapBankingPayablesUnderSecuritiesLendingTransactions?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_banking_trading_liabilities = 127;
   */
  jgaapBankingTradingLiabilities?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_banking_borrowed_money = 128;
   */
  jgaapBankingBorrowedMoney?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_banking_foreign_exchanges_liabilities = 129;
   */
  jgaapBankingForeignExchangesLiabilities?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_banking_bonds_payable = 130;
   */
  jgaapBankingBondsPayable?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_banking_derivatives_liabilities = 131;
   */
  jgaapBankingDerivativesLiabilities?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_banking_deferred_tax_liabilities_for_land_revaluation = 132;
   */
  jgaapBankingDeferredTaxLiabilitiesForLandRevaluation?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_banking_customers_liab_for_acceptances_and_guarantees = 133;
   */
  jgaapBankingCustomersLiabForAcceptancesAndGuarantees?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_banking_acceptances_and_guarantees = 134;
   */
  jgaapBankingAcceptancesAndGuarantees?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_securities_deposits_paid = 135;
   */
  jgaapSecuritiesDepositsPaid?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_securities_segregated_deposits_for_customers = 136;
   */
  jgaapSecuritiesSegregatedDepositsForCustomers?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_securities_trading_products = 137;
   */
  jgaapSecuritiesTradingProducts?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_securities_margin_transaction_assets = 138;
   */
  jgaapSecuritiesMarginTransactionAssets?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_securities_loans_on_margin_transactions = 139;
   */
  jgaapSecuritiesLoansOnMarginTransactions?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_securities_cash_collateral_for_sec_borrowed_on_mt = 140;
   */
  jgaapSecuritiesCashCollateralForSecBorrowedOnMt?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_securities_advances_paid = 141;
   */
  jgaapSecuritiesAdvancesPaid?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_securities_subscription_deposits = 142;
   */
  jgaapSecuritiesSubscriptionDeposits?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_securities_short_term_guarantee_deposits = 143;
   */
  jgaapSecuritiesShortTermGuaranteeDeposits?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_securities_loans_secured_by_securities = 144;
   */
  jgaapSecuritiesLoansSecuredBySecurities?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_securities_trading_products_liabilities = 145;
   */
  jgaapSecuritiesTradingProductsLiabilities?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_securities_margin_transaction_liabilities = 146;
   */
  jgaapSecuritiesMarginTransactionLiabilities?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_securities_borrowings_on_margin_transactions = 147;
   */
  jgaapSecuritiesBorrowingsOnMarginTransactions?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_securities_cash_received_for_sec_lent_on_mt = 148;
   */
  jgaapSecuritiesCashReceivedForSecLentOnMt?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_securities_guarantee_deposits_received = 149;
   */
  jgaapSecuritiesGuaranteeDepositsReceived?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_securities_deposits_received = 150;
   */
  jgaapSecuritiesDepositsReceived?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_securities_deposits_from_customers = 151;
   */
  jgaapSecuritiesDepositsFromCustomers?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_securities_short_term_guarantee_deposits_received = 152;
   */
  jgaapSecuritiesShortTermGuaranteeDepositsReceived?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_securities_short_term_borrowings = 153;
   */
  jgaapSecuritiesShortTermBorrowings?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_securities_borrowings_secured_by_securities = 154;
   */
  jgaapSecuritiesBorrowingsSecuredBySecurities?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_insurance_cash_and_deposits = 155;
   */
  jgaapInsuranceCashAndDeposits?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_insurance_call_loans = 156;
   */
  jgaapInsuranceCallLoans?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_insurance_monetary_claims_bought = 157;
   */
  jgaapInsuranceMonetaryClaimsBought?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_insurance_money_held_in_trust = 158;
   */
  jgaapInsuranceMoneyHeldInTrust?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_insurance_securities = 159;
   */
  jgaapInsuranceSecurities?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_insurance_loans = 160;
   */
  jgaapInsuranceLoans?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_insurance_agency_loans = 161;
   */
  jgaapInsuranceAgencyLoans?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_insurance_reinsurance_receivables = 162;
   */
  jgaapInsuranceReinsuranceReceivables?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_insurance_deferred_assets_under_article113 = 163;
   */
  jgaapInsuranceDeferredAssetsUnderArticle113?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_insurance_reserve_for_outstanding_claims = 164;
   */
  jgaapInsuranceReserveForOutstandingClaims?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_insurance_policy_reserves = 165;
   */
  jgaapInsurancePolicyReserves?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_insurance_reserve_for_policyholder_dividends = 166;
   */
  jgaapInsuranceReserveForPolicyholderDividends?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_insurance_reinsurance_payables = 167;
   */
  jgaapInsuranceReinsurancePayables?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_insurance_reserve_for_price_fluctuation = 168;
   */
  jgaapInsuranceReserveForPriceFluctuation?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_real_estate_real_estate_for_sale = 169;
   */
  jgaapRealEstateRealEstateForSale?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_real_estate_real_estate_for_sale_in_process = 170;
   */
  jgaapRealEstateRealEstateForSaleInProcess?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_shipping_vessels = 171;
   */
  jgaapShippingVessels?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_shipping_deferred_shipping_expenses = 172;
   */
  jgaapShippingDeferredShippingExpenses?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_shipping_deferred_shipping_revenue = 173;
   */
  jgaapShippingDeferredShippingRevenue?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_epag_fixed_assets_for_eub = 174;
   */
  jgaapEpagFixedAssetsForEub?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_electric_power_and_gas_construction_in_progress = 175;
   */
  jgaapElectricPowerAndGasConstructionInProgress?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_electric_power_and_gas_nuclear_fuel = 176;
   */
  jgaapElectricPowerAndGasNuclearFuel?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_epag_nf_in_reactor_of_specific_npf = 177;
   */
  jgaapEpagNfInReactorOfSpecificNpf?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_epag_reserve_for_special_depr_of_specific_equip = 178;
   */
  jgaapEpagReserveForSpecialDeprOfSpecificEquip?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_epag_reserve_for_fluctuation_in_water_levels = 179;
   */
  jgaapEpagReserveForFluctuationInWaterLevels?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_epag_reserve_for_decommissioning_of_npu = 180;
   */
  jgaapEpagReserveForDecommissioningOfNpu?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_epag_reserve_for_reprocessing_of_irradiated_nf = 181;
   */
  jgaapEpagReserveForReprocessingOfIrradiatedNf?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_epag_reserve_for_decommissioning_of_specific_npf = 182;
   */
  jgaapEpagReserveForDecommissioningOfSpecificNpf?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_leasing_lease_investment_assets = 183;
   */
  jgaapLeasingLeaseInvestmentAssets?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_leasing_lease_receivables = 184;
   */
  jgaapLeasingLeaseReceivables?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_leasing_assets_for_lease = 185;
   */
  jgaapLeasingAssetsForLease?: number

  /**
   * @generated from field: google.protobuf.Struct column_missing_reason = 186;
   */
  columnMissingReason?: Struct

  constructor(data?: PartialMessage<UsecaseTableBsFull>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.UsecaseTableBsFull'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'edinet_file_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'submission_date', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'edinet_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'filer_name', kind: 'message', T: StringValue },
    { no: 6, name: 'sec_code', kind: 'message', T: StringValue },
    { no: 7, name: 'doc_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 8, name: 'doc_description', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 9, name: 'securities_report_chunk_ids', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: 'original_filename', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 11, name: 'period_start', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 12, name: 'period_end', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 13, name: 'doc_type_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 14, name: 'fiscal_year_end_year', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 15, name: 'fiscal_year_end_month', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 16, name: 'accounting_standard', kind: 'message', T: StringValue },
    { no: 17, name: 'unit', kind: 'message', T: DoubleValue },
    { no: 18, name: 'unit_text', kind: 'message', T: StringValue },
    { no: 19, name: 'highlight_cash_and_deposits_jpy', kind: 'message', T: DoubleValue },
    { no: 20, name: 'highlight_accounts_receivable_jpy', kind: 'message', T: DoubleValue },
    { no: 21, name: 'highlight_inventories_jpy', kind: 'message', T: DoubleValue },
    { no: 22, name: 'highlight_property_plant_equipment_jpy', kind: 'message', T: DoubleValue },
    { no: 23, name: 'highlight_total_assets_jpy', kind: 'message', T: DoubleValue },
    { no: 24, name: 'ifrs_general_property_plant_and_equipment', kind: 'message', T: DoubleValue },
    { no: 25, name: 'ifrs_general_investment_property', kind: 'message', T: DoubleValue },
    { no: 26, name: 'ifrs_general_intangible_assets', kind: 'message', T: DoubleValue },
    { no: 27, name: 'ifrs_general_financial_assets_excluding_cash_equivalents', kind: 'message', T: DoubleValue },
    { no: 28, name: 'ifrs_general_investments_accounted_for_using_the_equity_method', kind: 'message', T: DoubleValue },
    { no: 29, name: 'ifrs_general_deferred_tax_assets', kind: 'message', T: DoubleValue },
    { no: 30, name: 'ifrs_general_total_non_current_assets', kind: 'message', T: DoubleValue },
    { no: 31, name: 'ifrs_general_inventories', kind: 'message', T: DoubleValue },
    { no: 32, name: 'ifrs_general_trade_and_other_receivables', kind: 'message', T: DoubleValue },
    { no: 33, name: 'ifrs_general_cash_and_cash_equivalents', kind: 'message', T: DoubleValue },
    { no: 34, name: 'ifrs_general_assets_held_for_sale', kind: 'message', T: DoubleValue },
    { no: 35, name: 'ifrs_general_total_current_assets', kind: 'message', T: DoubleValue },
    { no: 36, name: 'ifrs_general_total_assets', kind: 'message', T: DoubleValue },
    { no: 37, name: 'ifrs_general_total_fixed_assets', kind: 'message', T: DoubleValue },
    { no: 38, name: 'ifrs_general_total_current_liabilities', kind: 'message', T: DoubleValue },
    { no: 39, name: 'ifrs_general_total_fixed_liabilities', kind: 'message', T: DoubleValue },
    { no: 40, name: 'ifrs_general_total_liabilities', kind: 'message', T: DoubleValue },
    { no: 41, name: 'ifrs_general_non_controlling_interests', kind: 'message', T: DoubleValue },
    { no: 42, name: 'ifrs_general_issued_capital_and_reserves_attr_to_ootp', kind: 'message', T: DoubleValue },
    { no: 43, name: 'ifrs_general_total_equity', kind: 'message', T: DoubleValue },
    { no: 44, name: 'ifrs_general_total_equity_and_liabilities', kind: 'message', T: DoubleValue },
    { no: 45, name: 'ifrs_fi_cash_and_balances_with_central_banks', kind: 'message', T: DoubleValue },
    { no: 46, name: 'ifrs_financial_institutions_loans_and_advances_to_banks', kind: 'message', T: DoubleValue },
    { no: 47, name: 'ifrs_financial_institutions_loans_and_advances_to_customers', kind: 'message', T: DoubleValue },
    { no: 48, name: 'ifrs_fi_derivative_fi_assets', kind: 'message', T: DoubleValue },
    { no: 49, name: 'ifrs_financial_institutions_investment_securities', kind: 'message', T: DoubleValue },
    { no: 50, name: 'ifrs_financial_institutions_trading_assets', kind: 'message', T: DoubleValue },
    { no: 51, name: 'ifrs_financial_institutions_pledged_assets', kind: 'message', T: DoubleValue },
    { no: 52, name: 'ifrs_financial_institutions_deposits_from_banks', kind: 'message', T: DoubleValue },
    { no: 53, name: 'ifrs_financial_institutions_deposits_from_customers', kind: 'message', T: DoubleValue },
    { no: 54, name: 'ifrs_fi_derivative_fi_liabilities', kind: 'message', T: DoubleValue },
    { no: 55, name: 'ifrs_financial_institutions_debt_securities_in_issue', kind: 'message', T: DoubleValue },
    { no: 56, name: 'ifrs_financial_institutions_subordinated_liabilities', kind: 'message', T: DoubleValue },
    { no: 57, name: 'ifrs_financial_institutions_trading_liabilities', kind: 'message', T: DoubleValue },
    { no: 58, name: 'ifrs_insurance_industry_insurance_contract_assets', kind: 'message', T: DoubleValue },
    { no: 59, name: 'ifrs_insurance_industry_reinsurance_contract_assets', kind: 'message', T: DoubleValue },
    { no: 60, name: 'ifrs_insurance_industry_insurance_contract_liabilities', kind: 'message', T: DoubleValue },
    { no: 61, name: 'ifrs_insurance_industry_reinsurance_contract_liabilities', kind: 'message', T: DoubleValue },
    { no: 62, name: 'ifrs_insurance_industry_investment_contract_liabilities', kind: 'message', T: DoubleValue },
    { no: 63, name: 'ifrs_agriculture_biological_assets', kind: 'message', T: DoubleValue },
    { no: 64, name: 'ifrs_agriculture_bearer_plants', kind: 'message', T: DoubleValue },
    { no: 65, name: 'ifrs_agriculture_agricultural_produce_inventory_at_harvest', kind: 'message', T: DoubleValue },
    { no: 66, name: 'ifrs_efaeomr_exploration_and_evaluation_assets', kind: 'message', T: DoubleValue },
    { no: 67, name: 'ifrs_efaeomr_eae_assets_tangible', kind: 'message', T: DoubleValue },
    { no: 68, name: 'ifrs_efaeomr_eae_assets_intangible', kind: 'message', T: DoubleValue },
    { no: 69, name: 'ifrs_efaeomr_liabilities_related_to_eae_assets', kind: 'message', T: DoubleValue },
    { no: 70, name: 'ifrs_rra_total_assets_subject_to_rate_reg', kind: 'message', T: DoubleValue },
    { no: 71, name: 'ifrs_rra_regulatory_deferral_account_debit_bal', kind: 'message', T: DoubleValue },
    { no: 72, name: 'ifrs_rra_regulatory_deferral_account_credit_bal', kind: 'message', T: DoubleValue },
    { no: 73, name: 'ifrs_ie_fa_at_fvtpl_investments_in_subs', kind: 'message', T: DoubleValue },
    { no: 74, name: 'jgaap_general_cash_and_deposits', kind: 'message', T: DoubleValue },
    { no: 75, name: 'jgaap_general_notes_and_ar_trade_and_contract_assets', kind: 'message', T: DoubleValue },
    { no: 76, name: 'jgaap_general_securities', kind: 'message', T: DoubleValue },
    { no: 77, name: 'jgaap_general_inventories', kind: 'message', T: DoubleValue },
    { no: 78, name: 'jgaap_general_property_plant_and_equipment', kind: 'message', T: DoubleValue },
    { no: 79, name: 'jgaap_general_intangible_assets', kind: 'message', T: DoubleValue },
    { no: 80, name: 'jgaap_general_investment_securities', kind: 'message', T: DoubleValue },
    { no: 81, name: 'jgaap_general_deferred_tax_assets', kind: 'message', T: DoubleValue },
    { no: 82, name: 'jgaap_general_notes_and_accounts_payable_trade', kind: 'message', T: DoubleValue },
    { no: 83, name: 'jgaap_general_short_term_borrowings', kind: 'message', T: DoubleValue },
    { no: 84, name: 'jgaap_general_provisions', kind: 'message', T: DoubleValue },
    { no: 85, name: 'jgaap_general_bonds_payable', kind: 'message', T: DoubleValue },
    { no: 86, name: 'jgaap_general_long_term_borrowings', kind: 'message', T: DoubleValue },
    { no: 87, name: 'jgaap_general_retirement_benefit_liability', kind: 'message', T: DoubleValue },
    { no: 88, name: 'jgaap_general_share_capital', kind: 'message', T: DoubleValue },
    { no: 89, name: 'jgaap_general_capital_surplus', kind: 'message', T: DoubleValue },
    { no: 90, name: 'jgaap_general_retained_earnings', kind: 'message', T: DoubleValue },
    { no: 91, name: 'jgaap_general_treasury_shares', kind: 'message', T: DoubleValue },
    { no: 92, name: 'jgaap_general_accumulated_other_comprehensive_income', kind: 'message', T: DoubleValue },
    { no: 93, name: 'jgaap_general_non_controlling_interests', kind: 'message', T: DoubleValue },
    { no: 94, name: 'jgaap_general_total_current_assets', kind: 'message', T: DoubleValue },
    { no: 95, name: 'jgaap_general_total_fixed_assets', kind: 'message', T: DoubleValue },
    { no: 96, name: 'jgaap_general_total_current_liabilities', kind: 'message', T: DoubleValue },
    { no: 97, name: 'jgaap_general_total_fixed_liabilities', kind: 'message', T: DoubleValue },
    { no: 98, name: 'jgaap_general_total_liabilities', kind: 'message', T: DoubleValue },
    { no: 99, name: 'jgaap_general_total_net_assets', kind: 'message', T: DoubleValue },
    { no: 100, name: 'jgaap_general_total_assets', kind: 'message', T: DoubleValue },
    { no: 101, name: 'jgaap_general_accumulated_depreciation', kind: 'message', T: DoubleValue },
    { no: 102, name: 'jgaap_general_subscription_rights_shares', kind: 'message', T: DoubleValue },
    { no: 103, name: 'jgaap_general_advance_payments', kind: 'message', T: DoubleValue },
    { no: 104, name: 'jgaap_general_prepaid_expenses', kind: 'message', T: DoubleValue },
    { no: 105, name: 'jgaap_general_advances_received', kind: 'message', T: DoubleValue },
    { no: 106, name: 'jgaap_general_deferred_revenue', kind: 'message', T: DoubleValue },
    { no: 107, name: 'jgaap_construction_ar_from_completed_cc', kind: 'message', T: DoubleValue },
    { no: 108, name: 'jgaap_construction_costs_on_uncompleted_construction_contracts', kind: 'message', T: DoubleValue },
    { no: 109, name: 'jgaap_construction_advances_received_on_uncompleted_cc', kind: 'message', T: DoubleValue },
    { no: 110, name: 'jgaap_construction_materials_and_supplies', kind: 'message', T: DoubleValue },
    { no: 111, name: 'jgaap_construction_accounts_payable_for_construction_contracts', kind: 'message', T: DoubleValue },
    { no: 112, name: 'jgaap_construction_provision_for_loss_on_construction_contracts', kind: 'message', T: DoubleValue },
    { no: 113, name: 'jgaap_construction_provision_for_warranties_for_completed_c', kind: 'message', T: DoubleValue },
    { no: 114, name: 'jgaap_banking_cash_and_due_from_banks', kind: 'message', T: DoubleValue },
    { no: 115, name: 'jgaap_banking_call_loans_and_bills_bought', kind: 'message', T: DoubleValue },
    { no: 116, name: 'jgaap_banking_monetary_claims_bought', kind: 'message', T: DoubleValue },
    { no: 117, name: 'jgaap_banking_trading_assets', kind: 'message', T: DoubleValue },
    { no: 118, name: 'jgaap_banking_money_held_in_trust', kind: 'message', T: DoubleValue },
    { no: 119, name: 'jgaap_banking_securities', kind: 'message', T: DoubleValue },
    { no: 120, name: 'jgaap_banking_loans_and_bills_discounted', kind: 'message', T: DoubleValue },
    { no: 121, name: 'jgaap_banking_foreign_exchanges_assets', kind: 'message', T: DoubleValue },
    { no: 122, name: 'jgaap_banking_derivatives_assets', kind: 'message', T: DoubleValue },
    { no: 123, name: 'jgaap_banking_deposits', kind: 'message', T: DoubleValue },
    { no: 124, name: 'jgaap_banking_negotiable_certificates_of_deposit', kind: 'message', T: DoubleValue },
    { no: 125, name: 'jgaap_banking_call_money_and_bills_sold', kind: 'message', T: DoubleValue },
    { no: 126, name: 'jgaap_banking_payables_under_securities_lending_transactions', kind: 'message', T: DoubleValue },
    { no: 127, name: 'jgaap_banking_trading_liabilities', kind: 'message', T: DoubleValue },
    { no: 128, name: 'jgaap_banking_borrowed_money', kind: 'message', T: DoubleValue },
    { no: 129, name: 'jgaap_banking_foreign_exchanges_liabilities', kind: 'message', T: DoubleValue },
    { no: 130, name: 'jgaap_banking_bonds_payable', kind: 'message', T: DoubleValue },
    { no: 131, name: 'jgaap_banking_derivatives_liabilities', kind: 'message', T: DoubleValue },
    { no: 132, name: 'jgaap_banking_deferred_tax_liabilities_for_land_revaluation', kind: 'message', T: DoubleValue },
    { no: 133, name: 'jgaap_banking_customers_liab_for_acceptances_and_guarantees', kind: 'message', T: DoubleValue },
    { no: 134, name: 'jgaap_banking_acceptances_and_guarantees', kind: 'message', T: DoubleValue },
    { no: 135, name: 'jgaap_securities_deposits_paid', kind: 'message', T: DoubleValue },
    { no: 136, name: 'jgaap_securities_segregated_deposits_for_customers', kind: 'message', T: DoubleValue },
    { no: 137, name: 'jgaap_securities_trading_products', kind: 'message', T: DoubleValue },
    { no: 138, name: 'jgaap_securities_margin_transaction_assets', kind: 'message', T: DoubleValue },
    { no: 139, name: 'jgaap_securities_loans_on_margin_transactions', kind: 'message', T: DoubleValue },
    { no: 140, name: 'jgaap_securities_cash_collateral_for_sec_borrowed_on_mt', kind: 'message', T: DoubleValue },
    { no: 141, name: 'jgaap_securities_advances_paid', kind: 'message', T: DoubleValue },
    { no: 142, name: 'jgaap_securities_subscription_deposits', kind: 'message', T: DoubleValue },
    { no: 143, name: 'jgaap_securities_short_term_guarantee_deposits', kind: 'message', T: DoubleValue },
    { no: 144, name: 'jgaap_securities_loans_secured_by_securities', kind: 'message', T: DoubleValue },
    { no: 145, name: 'jgaap_securities_trading_products_liabilities', kind: 'message', T: DoubleValue },
    { no: 146, name: 'jgaap_securities_margin_transaction_liabilities', kind: 'message', T: DoubleValue },
    { no: 147, name: 'jgaap_securities_borrowings_on_margin_transactions', kind: 'message', T: DoubleValue },
    { no: 148, name: 'jgaap_securities_cash_received_for_sec_lent_on_mt', kind: 'message', T: DoubleValue },
    { no: 149, name: 'jgaap_securities_guarantee_deposits_received', kind: 'message', T: DoubleValue },
    { no: 150, name: 'jgaap_securities_deposits_received', kind: 'message', T: DoubleValue },
    { no: 151, name: 'jgaap_securities_deposits_from_customers', kind: 'message', T: DoubleValue },
    { no: 152, name: 'jgaap_securities_short_term_guarantee_deposits_received', kind: 'message', T: DoubleValue },
    { no: 153, name: 'jgaap_securities_short_term_borrowings', kind: 'message', T: DoubleValue },
    { no: 154, name: 'jgaap_securities_borrowings_secured_by_securities', kind: 'message', T: DoubleValue },
    { no: 155, name: 'jgaap_insurance_cash_and_deposits', kind: 'message', T: DoubleValue },
    { no: 156, name: 'jgaap_insurance_call_loans', kind: 'message', T: DoubleValue },
    { no: 157, name: 'jgaap_insurance_monetary_claims_bought', kind: 'message', T: DoubleValue },
    { no: 158, name: 'jgaap_insurance_money_held_in_trust', kind: 'message', T: DoubleValue },
    { no: 159, name: 'jgaap_insurance_securities', kind: 'message', T: DoubleValue },
    { no: 160, name: 'jgaap_insurance_loans', kind: 'message', T: DoubleValue },
    { no: 161, name: 'jgaap_insurance_agency_loans', kind: 'message', T: DoubleValue },
    { no: 162, name: 'jgaap_insurance_reinsurance_receivables', kind: 'message', T: DoubleValue },
    { no: 163, name: 'jgaap_insurance_deferred_assets_under_article113', kind: 'message', T: DoubleValue },
    { no: 164, name: 'jgaap_insurance_reserve_for_outstanding_claims', kind: 'message', T: DoubleValue },
    { no: 165, name: 'jgaap_insurance_policy_reserves', kind: 'message', T: DoubleValue },
    { no: 166, name: 'jgaap_insurance_reserve_for_policyholder_dividends', kind: 'message', T: DoubleValue },
    { no: 167, name: 'jgaap_insurance_reinsurance_payables', kind: 'message', T: DoubleValue },
    { no: 168, name: 'jgaap_insurance_reserve_for_price_fluctuation', kind: 'message', T: DoubleValue },
    { no: 169, name: 'jgaap_real_estate_real_estate_for_sale', kind: 'message', T: DoubleValue },
    { no: 170, name: 'jgaap_real_estate_real_estate_for_sale_in_process', kind: 'message', T: DoubleValue },
    { no: 171, name: 'jgaap_shipping_vessels', kind: 'message', T: DoubleValue },
    { no: 172, name: 'jgaap_shipping_deferred_shipping_expenses', kind: 'message', T: DoubleValue },
    { no: 173, name: 'jgaap_shipping_deferred_shipping_revenue', kind: 'message', T: DoubleValue },
    { no: 174, name: 'jgaap_epag_fixed_assets_for_eub', kind: 'message', T: DoubleValue },
    { no: 175, name: 'jgaap_electric_power_and_gas_construction_in_progress', kind: 'message', T: DoubleValue },
    { no: 176, name: 'jgaap_electric_power_and_gas_nuclear_fuel', kind: 'message', T: DoubleValue },
    { no: 177, name: 'jgaap_epag_nf_in_reactor_of_specific_npf', kind: 'message', T: DoubleValue },
    { no: 178, name: 'jgaap_epag_reserve_for_special_depr_of_specific_equip', kind: 'message', T: DoubleValue },
    { no: 179, name: 'jgaap_epag_reserve_for_fluctuation_in_water_levels', kind: 'message', T: DoubleValue },
    { no: 180, name: 'jgaap_epag_reserve_for_decommissioning_of_npu', kind: 'message', T: DoubleValue },
    { no: 181, name: 'jgaap_epag_reserve_for_reprocessing_of_irradiated_nf', kind: 'message', T: DoubleValue },
    { no: 182, name: 'jgaap_epag_reserve_for_decommissioning_of_specific_npf', kind: 'message', T: DoubleValue },
    { no: 183, name: 'jgaap_leasing_lease_investment_assets', kind: 'message', T: DoubleValue },
    { no: 184, name: 'jgaap_leasing_lease_receivables', kind: 'message', T: DoubleValue },
    { no: 185, name: 'jgaap_leasing_assets_for_lease', kind: 'message', T: DoubleValue },
    { no: 186, name: 'column_missing_reason', kind: 'message', T: Struct },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UsecaseTableBsFull {
    return new UsecaseTableBsFull().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UsecaseTableBsFull {
    return new UsecaseTableBsFull().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UsecaseTableBsFull {
    return new UsecaseTableBsFull().fromJsonString(jsonString, options)
  }

  static equals(
    a: UsecaseTableBsFull | PlainMessage<UsecaseTableBsFull> | undefined,
    b: UsecaseTableBsFull | PlainMessage<UsecaseTableBsFull> | undefined,
  ): boolean {
    return proto3.util.equals(UsecaseTableBsFull, a, b)
  }
}

/**
 * @generated from message models.UsecaseTableCfFull
 */
export class UsecaseTableCfFull extends Message<UsecaseTableCfFull> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string edinet_file_id = 2;
   */
  edinetFileId = ''

  /**
   * @generated from field: string submission_date = 3;
   */
  submissionDate = ''

  /**
   * @generated from field: string edinet_code = 4;
   */
  edinetCode = ''

  /**
   * @generated from field: google.protobuf.StringValue filer_name = 5;
   */
  filerName?: string

  /**
   * @generated from field: google.protobuf.StringValue sec_code = 6;
   */
  secCode?: string

  /**
   * @generated from field: string doc_id = 7;
   */
  docId = ''

  /**
   * @generated from field: string doc_description = 8;
   */
  docDescription = ''

  /**
   * @generated from field: repeated string securities_report_chunk_ids = 9;
   */
  securitiesReportChunkIds: string[] = []

  /**
   * @generated from field: string original_filename = 10;
   */
  originalFilename = ''

  /**
   * @generated from field: string period_start = 11;
   */
  periodStart = ''

  /**
   * @generated from field: string period_end = 12;
   */
  periodEnd = ''

  /**
   * @generated from field: string doc_type_code = 13;
   */
  docTypeCode = ''

  /**
   * @generated from field: double fiscal_year_end_year = 14;
   */
  fiscalYearEndYear = 0

  /**
   * @generated from field: double fiscal_year_end_month = 15;
   */
  fiscalYearEndMonth = 0

  /**
   * @generated from field: google.protobuf.StringValue accounting_standard = 16;
   */
  accountingStandard?: string

  /**
   * @generated from field: google.protobuf.DoubleValue unit = 17;
   */
  unit?: number

  /**
   * @generated from field: google.protobuf.StringValue unit_text = 18;
   */
  unitText?: string

  /**
   * @generated from field: google.protobuf.DoubleValue highlight_operating_cf_jpy = 19;
   */
  highlightOperatingCfJpy?: number

  /**
   * @generated from field: google.protobuf.DoubleValue highlight_investing_cf_jpy = 20;
   */
  highlightInvestingCfJpy?: number

  /**
   * @generated from field: google.protobuf.DoubleValue highlight_financing_cf_jpy = 21;
   */
  highlightFinancingCfJpy?: number

  /**
   * @generated from field: google.protobuf.DoubleValue highlight_cash_eoy_jpy = 22;
   */
  highlightCashEoyJpy?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_cash_flows_from_operating_activities = 23;
   */
  ifrsGeneralCashFlowsFromOperatingActivities?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_interest_paid = 24;
   */
  ifrsGeneralInterestPaid?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_interest_received = 25;
   */
  ifrsGeneralInterestReceived?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_dividends_received = 26;
   */
  ifrsGeneralDividendsReceived?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_income_taxes_paid = 27;
   */
  ifrsGeneralIncomeTaxesPaid?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_cash_flows_from_investing_activities = 28;
   */
  ifrsGeneralCashFlowsFromInvestingActivities?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_cash_flows_from_financing_activities = 29;
   */
  ifrsGeneralCashFlowsFromFinancingActivities?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_dividends_paid = 30;
   */
  ifrsGeneralDividendsPaid?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_cce_at_beginning_of_period = 31;
   */
  ifrsGeneralCceAtBeginningOfPeriod?: number

  /**
   * @generated from field: google.protobuf.DoubleValue ifrs_general_cash_and_cash_equivalents_at_the_end_of_the_period = 32;
   */
  ifrsGeneralCashAndCashEquivalentsAtTheEndOfThePeriod?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_cash_flows_from_operating_activities = 33;
   */
  jgaapGeneralCashFlowsFromOperatingActivities?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_cash_flows_from_investing_activities = 34;
   */
  jgaapGeneralCashFlowsFromInvestingActivities?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_cash_flows_from_financing_activities = 35;
   */
  jgaapGeneralCashFlowsFromFinancingActivities?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_effect_of_exch_rate_change_on_cce = 36;
   */
  jgaapGeneralEffectOfExchRateChangeOnCce?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_net_increase_decrease_in_cce = 37;
   */
  jgaapGeneralNetIncreaseDecreaseInCce?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_cash_and_cash_equivalents_at_beginning_of_period = 38;
   */
  jgaapGeneralCashAndCashEquivalentsAtBeginningOfPeriod?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_cash_and_cash_equivalents_at_end_of_period = 39;
   */
  jgaapGeneralCashAndCashEquivalentsAtEndOfPeriod?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_purchase_ppe = 40;
   */
  jgaapGeneralPurchasePpe?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_purchase_intangible = 41;
   */
  jgaapGeneralPurchaseIntangible?: number

  /**
   * @generated from field: google.protobuf.DoubleValue jgaap_general_dividends_paid = 42;
   */
  jgaapGeneralDividendsPaid?: number

  /**
   * @generated from field: google.protobuf.Struct column_missing_reason = 43;
   */
  columnMissingReason?: Struct

  constructor(data?: PartialMessage<UsecaseTableCfFull>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.UsecaseTableCfFull'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'edinet_file_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'submission_date', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'edinet_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'filer_name', kind: 'message', T: StringValue },
    { no: 6, name: 'sec_code', kind: 'message', T: StringValue },
    { no: 7, name: 'doc_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 8, name: 'doc_description', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 9, name: 'securities_report_chunk_ids', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: 'original_filename', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 11, name: 'period_start', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 12, name: 'period_end', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 13, name: 'doc_type_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 14, name: 'fiscal_year_end_year', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 15, name: 'fiscal_year_end_month', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 16, name: 'accounting_standard', kind: 'message', T: StringValue },
    { no: 17, name: 'unit', kind: 'message', T: DoubleValue },
    { no: 18, name: 'unit_text', kind: 'message', T: StringValue },
    { no: 19, name: 'highlight_operating_cf_jpy', kind: 'message', T: DoubleValue },
    { no: 20, name: 'highlight_investing_cf_jpy', kind: 'message', T: DoubleValue },
    { no: 21, name: 'highlight_financing_cf_jpy', kind: 'message', T: DoubleValue },
    { no: 22, name: 'highlight_cash_eoy_jpy', kind: 'message', T: DoubleValue },
    { no: 23, name: 'ifrs_general_cash_flows_from_operating_activities', kind: 'message', T: DoubleValue },
    { no: 24, name: 'ifrs_general_interest_paid', kind: 'message', T: DoubleValue },
    { no: 25, name: 'ifrs_general_interest_received', kind: 'message', T: DoubleValue },
    { no: 26, name: 'ifrs_general_dividends_received', kind: 'message', T: DoubleValue },
    { no: 27, name: 'ifrs_general_income_taxes_paid', kind: 'message', T: DoubleValue },
    { no: 28, name: 'ifrs_general_cash_flows_from_investing_activities', kind: 'message', T: DoubleValue },
    { no: 29, name: 'ifrs_general_cash_flows_from_financing_activities', kind: 'message', T: DoubleValue },
    { no: 30, name: 'ifrs_general_dividends_paid', kind: 'message', T: DoubleValue },
    { no: 31, name: 'ifrs_general_cce_at_beginning_of_period', kind: 'message', T: DoubleValue },
    { no: 32, name: 'ifrs_general_cash_and_cash_equivalents_at_the_end_of_the_period', kind: 'message', T: DoubleValue },
    { no: 33, name: 'jgaap_general_cash_flows_from_operating_activities', kind: 'message', T: DoubleValue },
    { no: 34, name: 'jgaap_general_cash_flows_from_investing_activities', kind: 'message', T: DoubleValue },
    { no: 35, name: 'jgaap_general_cash_flows_from_financing_activities', kind: 'message', T: DoubleValue },
    { no: 36, name: 'jgaap_general_effect_of_exch_rate_change_on_cce', kind: 'message', T: DoubleValue },
    { no: 37, name: 'jgaap_general_net_increase_decrease_in_cce', kind: 'message', T: DoubleValue },
    { no: 38, name: 'jgaap_general_cash_and_cash_equivalents_at_beginning_of_period', kind: 'message', T: DoubleValue },
    { no: 39, name: 'jgaap_general_cash_and_cash_equivalents_at_end_of_period', kind: 'message', T: DoubleValue },
    { no: 40, name: 'jgaap_general_purchase_ppe', kind: 'message', T: DoubleValue },
    { no: 41, name: 'jgaap_general_purchase_intangible', kind: 'message', T: DoubleValue },
    { no: 42, name: 'jgaap_general_dividends_paid', kind: 'message', T: DoubleValue },
    { no: 43, name: 'column_missing_reason', kind: 'message', T: Struct },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UsecaseTableCfFull {
    return new UsecaseTableCfFull().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UsecaseTableCfFull {
    return new UsecaseTableCfFull().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UsecaseTableCfFull {
    return new UsecaseTableCfFull().fromJsonString(jsonString, options)
  }

  static equals(
    a: UsecaseTableCfFull | PlainMessage<UsecaseTableCfFull> | undefined,
    b: UsecaseTableCfFull | PlainMessage<UsecaseTableCfFull> | undefined,
  ): boolean {
    return proto3.util.equals(UsecaseTableCfFull, a, b)
  }
}

/**
 * @generated from message models.User
 */
export class User extends Message<User> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string cognito_user_id = 2;
   */
  cognitoUserId = ''

  /**
   * @generated from field: string email = 3;
   */
  email = ''

  /**
   * @generated from field: string name = 4;
   */
  name = ''

  /**
   * @generated from field: string created_at = 5;
   */
  createdAt = ''

  constructor(data?: PartialMessage<User>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.User'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'cognito_user_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'email', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'name', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'created_at', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): User {
    return new User().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): User {
    return new User().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): User {
    return new User().fromJsonString(jsonString, options)
  }

  static equals(a: User | PlainMessage<User> | undefined, b: User | PlainMessage<User> | undefined): boolean {
    return proto3.util.equals(User, a, b)
  }
}

/**
 * @generated from message models.UserAnalysisThread
 */
export class UserAnalysisThread extends Message<UserAnalysisThread> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string user_id = 2;
   */
  userId = ''

  /**
   * @generated from field: string title = 3;
   */
  title = ''

  /**
   * @generated from field: google.protobuf.StringValue description = 4;
   */
  description?: string

  /**
   * @generated from field: string created_at = 5;
   */
  createdAt = ''

  /**
   * @generated from field: string updated_at = 6;
   */
  updatedAt = ''

  constructor(data?: PartialMessage<UserAnalysisThread>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.UserAnalysisThread'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'user_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'title', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'description', kind: 'message', T: StringValue },
    { no: 5, name: 'created_at', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 6, name: 'updated_at', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserAnalysisThread {
    return new UserAnalysisThread().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserAnalysisThread {
    return new UserAnalysisThread().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserAnalysisThread {
    return new UserAnalysisThread().fromJsonString(jsonString, options)
  }

  static equals(
    a: UserAnalysisThread | PlainMessage<UserAnalysisThread> | undefined,
    b: UserAnalysisThread | PlainMessage<UserAnalysisThread> | undefined,
  ): boolean {
    return proto3.util.equals(UserAnalysisThread, a, b)
  }
}

/**
 * @generated from message models.UserAnalysisThreadMessage
 */
export class UserAnalysisThreadMessage extends Message<UserAnalysisThreadMessage> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string user_id = 2;
   */
  userId = ''

  /**
   * @generated from field: string user_analysis_thread_id = 3;
   */
  userAnalysisThreadId = ''

  /**
   * @generated from field: double index = 4;
   */
  index = 0

  /**
   * @generated from field: models.UserAnalysisThreadMessage.Status status = 5;
   */
  status = UserAnalysisThreadMessage_Status._UNSPECIFIED_STATUS

  /**
   * @generated from field: google.protobuf.StringValue error_message = 6;
   */
  errorMessage?: string

  /**
   * @generated from field: models.UserAnalysisThreadMessage.ContentType content_type = 7;
   */
  contentType = UserAnalysisThreadMessage_ContentType._UNSPECIFIED_CONTENT_TYPE

  /**
   * @generated from field: google.protobuf.Struct content = 8;
   */
  content?: Struct

  /**
   * @generated from field: string created_at = 9;
   */
  createdAt = ''

  /**
   * @generated from field: string updated_at = 10;
   */
  updatedAt = ''

  constructor(data?: PartialMessage<UserAnalysisThreadMessage>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.UserAnalysisThreadMessage'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'user_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'user_analysis_thread_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'index', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: 'status', kind: 'enum', T: proto3.getEnumType(UserAnalysisThreadMessage_Status) },
    { no: 6, name: 'error_message', kind: 'message', T: StringValue },
    { no: 7, name: 'content_type', kind: 'enum', T: proto3.getEnumType(UserAnalysisThreadMessage_ContentType) },
    { no: 8, name: 'content', kind: 'message', T: Struct },
    { no: 9, name: 'created_at', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 10, name: 'updated_at', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserAnalysisThreadMessage {
    return new UserAnalysisThreadMessage().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserAnalysisThreadMessage {
    return new UserAnalysisThreadMessage().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserAnalysisThreadMessage {
    return new UserAnalysisThreadMessage().fromJsonString(jsonString, options)
  }

  static equals(
    a: UserAnalysisThreadMessage | PlainMessage<UserAnalysisThreadMessage> | undefined,
    b: UserAnalysisThreadMessage | PlainMessage<UserAnalysisThreadMessage> | undefined,
  ): boolean {
    return proto3.util.equals(UserAnalysisThreadMessage, a, b)
  }
}

/**
 * @generated from enum models.UserAnalysisThreadMessage.Status
 */
export enum UserAnalysisThreadMessage_Status {
  /**
   * @generated from enum value: _UNSPECIFIED_STATUS = 0;
   */
  _UNSPECIFIED_STATUS = 0,

  /**
   * @generated from enum value: PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: PROCESSING = 2;
   */
  PROCESSING = 2,

  /**
   * @generated from enum value: COMPLETED = 3;
   */
  COMPLETED = 3,

  /**
   * @generated from enum value: FAILED = 4;
   */
  FAILED = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(UserAnalysisThreadMessage_Status)
proto3.util.setEnumType(UserAnalysisThreadMessage_Status, 'models.UserAnalysisThreadMessage.Status', [
  { no: 0, name: '_UNSPECIFIED_STATUS' },
  { no: 1, name: 'PENDING' },
  { no: 2, name: 'PROCESSING' },
  { no: 3, name: 'COMPLETED' },
  { no: 4, name: 'FAILED' },
])

/**
 * @generated from enum models.UserAnalysisThreadMessage.ContentType
 */
export enum UserAnalysisThreadMessage_ContentType {
  /**
   * @generated from enum value: _UNSPECIFIED_CONTENT_TYPE = 0;
   */
  _UNSPECIFIED_CONTENT_TYPE = 0,

  /**
   * @generated from enum value: COMPANY_OVERVIEW = 1;
   */
  COMPANY_OVERVIEW = 1,

  /**
   * @generated from enum value: PL_HIGHLIGHT = 2;
   */
  PL_HIGHLIGHT = 2,

  /**
   * @generated from enum value: BS_HIGHLIGHT = 3;
   */
  BS_HIGHLIGHT = 3,

  /**
   * @generated from enum value: CF_HIGHLIGHT = 4;
   */
  CF_HIGHLIGHT = 4,

  /**
   * @generated from enum value: EXECUTIVES = 5;
   */
  EXECUTIVES = 5,

  /**
   * @generated from enum value: EXECUTIVE_COMPENSATION = 6;
   */
  EXECUTIVE_COMPENSATION = 6,

  /**
   * @generated from enum value: BUSINESS_DESCRIPTION = 7;
   */
  BUSINESS_DESCRIPTION = 7,

  /**
   * @generated from enum value: BUSINESS_RISKS = 8;
   */
  BUSINESS_RISKS = 8,

  /**
   * @generated from enum value: HISTORY = 9;
   */
  HISTORY = 9,

  /**
   * @generated from enum value: MAJOR_SUBSIDIARIES = 10;
   */
  MAJOR_SUBSIDIARIES = 10,

  /**
   * @generated from enum value: OFFICES = 11;
   */
  OFFICES = 11,

  /**
   * @generated from enum value: MAJOR_SHAREHOLDERS = 12;
   */
  MAJOR_SHAREHOLDERS = 12,

  /**
   * @generated from enum value: USER_PROMPT = 13;
   */
  USER_PROMPT = 13,

  /**
   * @generated from enum value: ASSISTANT = 14;
   */
  ASSISTANT = 14,

  /**
   * @generated from enum value: SUMMARY = 15;
   */
  SUMMARY = 15,

  /**
   * @generated from enum value: SECURITIES_REPORT_ANALYSIS = 16;
   */
  SECURITIES_REPORT_ANALYSIS = 16,
}
// Retrieve enum metadata with: proto3.getEnumType(UserAnalysisThreadMessage_ContentType)
proto3.util.setEnumType(UserAnalysisThreadMessage_ContentType, 'models.UserAnalysisThreadMessage.ContentType', [
  { no: 0, name: '_UNSPECIFIED_CONTENT_TYPE' },
  { no: 1, name: 'COMPANY_OVERVIEW' },
  { no: 2, name: 'PL_HIGHLIGHT' },
  { no: 3, name: 'BS_HIGHLIGHT' },
  { no: 4, name: 'CF_HIGHLIGHT' },
  { no: 5, name: 'EXECUTIVES' },
  { no: 6, name: 'EXECUTIVE_COMPENSATION' },
  { no: 7, name: 'BUSINESS_DESCRIPTION' },
  { no: 8, name: 'BUSINESS_RISKS' },
  { no: 9, name: 'HISTORY' },
  { no: 10, name: 'MAJOR_SUBSIDIARIES' },
  { no: 11, name: 'OFFICES' },
  { no: 12, name: 'MAJOR_SHAREHOLDERS' },
  { no: 13, name: 'USER_PROMPT' },
  { no: 14, name: 'ASSISTANT' },
  { no: 15, name: 'SUMMARY' },
  { no: 16, name: 'SECURITIES_REPORT_ANALYSIS' },
])

/**
 * @generated from message models.CompanyAvailability
 */
export class CompanyAvailability extends Message<CompanyAvailability> {
  /**
   * @generated from field: string edinet_code = 1;
   */
  edinetCode = ''

  /**
   * @generated from field: google.protobuf.StringValue sec_code = 2;
   */
  secCode?: string

  /**
   * @generated from field: string filer_name = 3;
   */
  filerName = ''

  /**
   * @generated from field: bool is_available = 4;
   */
  isAvailable = false

  constructor(data?: PartialMessage<CompanyAvailability>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.CompanyAvailability'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'edinet_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'sec_code', kind: 'message', T: StringValue },
    { no: 3, name: 'filer_name', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'is_available', kind: 'scalar', T: 8 /* ScalarType.BOOL */ },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CompanyAvailability {
    return new CompanyAvailability().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CompanyAvailability {
    return new CompanyAvailability().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CompanyAvailability {
    return new CompanyAvailability().fromJsonString(jsonString, options)
  }

  static equals(
    a: CompanyAvailability | PlainMessage<CompanyAvailability> | undefined,
    b: CompanyAvailability | PlainMessage<CompanyAvailability> | undefined,
  ): boolean {
    return proto3.util.equals(CompanyAvailability, a, b)
  }
}

/**
 * @generated from message models.SecuritiesReportChunk
 */
export class SecuritiesReportChunk extends Message<SecuritiesReportChunk> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string edinet_file_id = 2;
   */
  edinetFileId = ''

  /**
   * @generated from field: string submission_date = 3;
   */
  submissionDate = ''

  /**
   * @generated from field: string edinet_code = 4;
   */
  edinetCode = ''

  /**
   * @generated from field: google.protobuf.StringValue sec_code = 5;
   */
  secCode?: string

  /**
   * @generated from field: string doc_id = 6;
   */
  docId = ''

  /**
   * @generated from field: google.protobuf.StringValue doc_description = 7;
   */
  docDescription?: string

  /**
   * @generated from field: google.protobuf.StringValue period_start = 8;
   */
  periodStart?: string

  /**
   * @generated from field: google.protobuf.StringValue period_end = 9;
   */
  periodEnd?: string

  /**
   * @generated from field: google.protobuf.DoubleValue fiscal_period_end_year = 10;
   */
  fiscalPeriodEndYear?: number

  /**
   * @generated from field: google.protobuf.DoubleValue fiscal_period_end_month = 11;
   */
  fiscalPeriodEndMonth?: number

  /**
   * @generated from field: google.protobuf.StringValue doc_type_code = 12;
   */
  docTypeCode?: string

  /**
   * @generated from field: google.protobuf.StringValue filer_name = 13;
   */
  filerName?: string

  /**
   * @generated from field: google.protobuf.StringValue ordinance_code = 14;
   */
  ordinanceCode?: string

  /**
   * @generated from field: google.protobuf.StringValue form_code = 15;
   */
  formCode?: string

  /**
   * @generated from field: string original_filename = 16;
   */
  originalFilename = ''

  /**
   * @generated from field: string creation_time = 17;
   */
  creationTime = ''

  /**
   * @generated from field: google.protobuf.StringValue error_message = 18;
   */
  errorMessage?: string

  /**
   * @generated from field: google.protobuf.DoubleValue chunk_index = 19;
   */
  chunkIndex?: number

  /**
   * @generated from field: google.protobuf.StringValue layer = 20;
   */
  layer?: string

  /**
   * @generated from field: repeated string titles_stack = 21;
   */
  titlesStack: string[] = []

  /**
   * @generated from field: string title = 22;
   */
  title = ''

  /**
   * @generated from field: google.protobuf.StringValue parent_chunk_id = 23;
   */
  parentChunkId?: string

  /**
   * @generated from field: double start_pos_in_doc = 24;
   */
  startPosInDoc = 0

  /**
   * @generated from field: double end_pos_in_doc = 25;
   */
  endPosInDoc = 0

  /**
   * @generated from field: double start_pos_in_file = 26;
   */
  startPosInFile = 0

  /**
   * @generated from field: double end_pos_in_file = 27;
   */
  endPosInFile = 0

  /**
   * @generated from field: string trimmed_chunk_content = 28;
   */
  trimmedChunkContent = ''

  /**
   * @generated from field: double raw_chunk_length = 29;
   */
  rawChunkLength = 0

  /**
   * @generated from field: double trimmed_chunk_length = 30;
   */
  trimmedChunkLength = 0

  constructor(data?: PartialMessage<SecuritiesReportChunk>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.SecuritiesReportChunk'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'edinet_file_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'submission_date', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'edinet_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'sec_code', kind: 'message', T: StringValue },
    { no: 6, name: 'doc_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 7, name: 'doc_description', kind: 'message', T: StringValue },
    { no: 8, name: 'period_start', kind: 'message', T: StringValue },
    { no: 9, name: 'period_end', kind: 'message', T: StringValue },
    { no: 10, name: 'fiscal_period_end_year', kind: 'message', T: DoubleValue },
    { no: 11, name: 'fiscal_period_end_month', kind: 'message', T: DoubleValue },
    { no: 12, name: 'doc_type_code', kind: 'message', T: StringValue },
    { no: 13, name: 'filer_name', kind: 'message', T: StringValue },
    { no: 14, name: 'ordinance_code', kind: 'message', T: StringValue },
    { no: 15, name: 'form_code', kind: 'message', T: StringValue },
    { no: 16, name: 'original_filename', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 17, name: 'creation_time', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 18, name: 'error_message', kind: 'message', T: StringValue },
    { no: 19, name: 'chunk_index', kind: 'message', T: DoubleValue },
    { no: 20, name: 'layer', kind: 'message', T: StringValue },
    { no: 21, name: 'titles_stack', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 22, name: 'title', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 23, name: 'parent_chunk_id', kind: 'message', T: StringValue },
    { no: 24, name: 'start_pos_in_doc', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 25, name: 'end_pos_in_doc', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 26, name: 'start_pos_in_file', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 27, name: 'end_pos_in_file', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 28, name: 'trimmed_chunk_content', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 29, name: 'raw_chunk_length', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 30, name: 'trimmed_chunk_length', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SecuritiesReportChunk {
    return new SecuritiesReportChunk().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SecuritiesReportChunk {
    return new SecuritiesReportChunk().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SecuritiesReportChunk {
    return new SecuritiesReportChunk().fromJsonString(jsonString, options)
  }

  static equals(
    a: SecuritiesReportChunk | PlainMessage<SecuritiesReportChunk> | undefined,
    b: SecuritiesReportChunk | PlainMessage<SecuritiesReportChunk> | undefined,
  ): boolean {
    return proto3.util.equals(SecuritiesReportChunk, a, b)
  }
}

/**
 * @generated from message models.AiChatSession
 */
export class AiChatSession extends Message<AiChatSession> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string user_id = 2;
   */
  userId = ''

  /**
   * @generated from field: string title = 3;
   */
  title = ''

  /**
   * @generated from field: google.protobuf.StringValue description = 4;
   */
  description?: string

  /**
   * @generated from field: string created_at = 5;
   */
  createdAt = ''

  /**
   * @generated from field: string updated_at = 6;
   */
  updatedAt = ''

  constructor(data?: PartialMessage<AiChatSession>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.AiChatSession'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'user_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'title', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'description', kind: 'message', T: StringValue },
    { no: 5, name: 'created_at', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 6, name: 'updated_at', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AiChatSession {
    return new AiChatSession().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AiChatSession {
    return new AiChatSession().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AiChatSession {
    return new AiChatSession().fromJsonString(jsonString, options)
  }

  static equals(a: AiChatSession | PlainMessage<AiChatSession> | undefined, b: AiChatSession | PlainMessage<AiChatSession> | undefined): boolean {
    return proto3.util.equals(AiChatSession, a, b)
  }
}

/**
 * @generated from message models.AiChatEvent
 */
export class AiChatEvent extends Message<AiChatEvent> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string ai_chat_session_id = 2;
   */
  aiChatSessionId = ''

  /**
   * @generated from field: string user_id = 3;
   */
  userId = ''

  /**
   * @generated from field: double event_index = 4;
   */
  eventIndex = 0

  /**
   * @generated from field: models.AiChatEvent.EventType event_type = 5;
   */
  eventType = AiChatEvent_EventType._UNSPECIFIED_EVENT_TYPE

  /**
   * @generated from field: models.AiChatEvent.PayloadJsonStatus payload_json_status = 6;
   */
  payloadJsonStatus = AiChatEvent_PayloadJsonStatus._UNSPECIFIED_PAYLOAD_JSON_STATUS

  /**
   * @generated from field: google.protobuf.Struct payload = 7;
   */
  payload?: Struct

  /**
   * @generated from field: string created_at = 8;
   */
  createdAt = ''

  constructor(data?: PartialMessage<AiChatEvent>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.AiChatEvent'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'ai_chat_session_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'user_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'event_index', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: 'event_type', kind: 'enum', T: proto3.getEnumType(AiChatEvent_EventType) },
    { no: 6, name: 'payload_json_status', kind: 'enum', T: proto3.getEnumType(AiChatEvent_PayloadJsonStatus) },
    { no: 7, name: 'payload', kind: 'message', T: Struct },
    { no: 8, name: 'created_at', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AiChatEvent {
    return new AiChatEvent().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AiChatEvent {
    return new AiChatEvent().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AiChatEvent {
    return new AiChatEvent().fromJsonString(jsonString, options)
  }

  static equals(a: AiChatEvent | PlainMessage<AiChatEvent> | undefined, b: AiChatEvent | PlainMessage<AiChatEvent> | undefined): boolean {
    return proto3.util.equals(AiChatEvent, a, b)
  }
}

/**
 * @generated from enum models.AiChatEvent.EventType
 */
export enum AiChatEvent_EventType {
  /**
   * @generated from enum value: _UNSPECIFIED_EVENT_TYPE = 0;
   */
  _UNSPECIFIED_EVENT_TYPE = 0,

  /**
   * @generated from enum value: USER_MESSAGE = 1;
   */
  USER_MESSAGE = 1,

  /**
   * @generated from enum value: ASSISTANT_MESSAGE = 2;
   */
  ASSISTANT_MESSAGE = 2,

  /**
   * @generated from enum value: SERVER_SIDE_TOOL_CALL = 3;
   */
  SERVER_SIDE_TOOL_CALL = 3,

  /**
   * @generated from enum value: CLIENT_INFO = 4;
   */
  CLIENT_INFO = 4,

  /**
   * @generated from enum value: CLIENT_ACTION = 5;
   */
  CLIENT_ACTION = 5,

  /**
   * @generated from enum value: ERROR = 6;
   */
  ERROR = 6,
}
// Retrieve enum metadata with: proto3.getEnumType(AiChatEvent_EventType)
proto3.util.setEnumType(AiChatEvent_EventType, 'models.AiChatEvent.EventType', [
  { no: 0, name: '_UNSPECIFIED_EVENT_TYPE' },
  { no: 1, name: 'USER_MESSAGE' },
  { no: 2, name: 'ASSISTANT_MESSAGE' },
  { no: 3, name: 'SERVER_SIDE_TOOL_CALL' },
  { no: 4, name: 'CLIENT_INFO' },
  { no: 5, name: 'CLIENT_ACTION' },
  { no: 6, name: 'ERROR' },
])

/**
 * @generated from enum models.AiChatEvent.PayloadJsonStatus
 */
export enum AiChatEvent_PayloadJsonStatus {
  /**
   * @generated from enum value: _UNSPECIFIED_PAYLOAD_JSON_STATUS = 0;
   */
  _UNSPECIFIED_PAYLOAD_JSON_STATUS = 0,

  /**
   * @generated from enum value: GENERATING = 1;
   */
  GENERATING = 1,

  /**
   * @generated from enum value: COMPLETED = 2;
   */
  COMPLETED = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(AiChatEvent_PayloadJsonStatus)
proto3.util.setEnumType(AiChatEvent_PayloadJsonStatus, 'models.AiChatEvent.PayloadJsonStatus', [
  { no: 0, name: '_UNSPECIFIED_PAYLOAD_JSON_STATUS' },
  { no: 1, name: 'GENERATING' },
  { no: 2, name: 'COMPLETED' },
])

/**
 * @generated from message models.NikkeiNeedsIndustryLarge
 */
export class NikkeiNeedsIndustryLarge extends Message<NikkeiNeedsIndustryLarge> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string name = 2;
   */
  name = ''

  constructor(data?: PartialMessage<NikkeiNeedsIndustryLarge>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.NikkeiNeedsIndustryLarge'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'name', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NikkeiNeedsIndustryLarge {
    return new NikkeiNeedsIndustryLarge().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NikkeiNeedsIndustryLarge {
    return new NikkeiNeedsIndustryLarge().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NikkeiNeedsIndustryLarge {
    return new NikkeiNeedsIndustryLarge().fromJsonString(jsonString, options)
  }

  static equals(
    a: NikkeiNeedsIndustryLarge | PlainMessage<NikkeiNeedsIndustryLarge> | undefined,
    b: NikkeiNeedsIndustryLarge | PlainMessage<NikkeiNeedsIndustryLarge> | undefined,
  ): boolean {
    return proto3.util.equals(NikkeiNeedsIndustryLarge, a, b)
  }
}

/**
 * @generated from message models.NikkeiNeedsIndustryMedium
 */
export class NikkeiNeedsIndustryMedium extends Message<NikkeiNeedsIndustryMedium> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string name = 2;
   */
  name = ''

  /**
   * @generated from field: string url = 3;
   */
  url = ''

  /**
   * @generated from field: string nikkei_needs_industry_large_id = 4;
   */
  nikkeiNeedsIndustryLargeId = ''

  constructor(data?: PartialMessage<NikkeiNeedsIndustryMedium>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.NikkeiNeedsIndustryMedium'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'name', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'url', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'nikkei_needs_industry_large_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NikkeiNeedsIndustryMedium {
    return new NikkeiNeedsIndustryMedium().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NikkeiNeedsIndustryMedium {
    return new NikkeiNeedsIndustryMedium().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NikkeiNeedsIndustryMedium {
    return new NikkeiNeedsIndustryMedium().fromJsonString(jsonString, options)
  }

  static equals(
    a: NikkeiNeedsIndustryMedium | PlainMessage<NikkeiNeedsIndustryMedium> | undefined,
    b: NikkeiNeedsIndustryMedium | PlainMessage<NikkeiNeedsIndustryMedium> | undefined,
  ): boolean {
    return proto3.util.equals(NikkeiNeedsIndustryMedium, a, b)
  }
}

/**
 * @generated from message models.NikkeiNeedsIndustrySmall
 */
export class NikkeiNeedsIndustrySmall extends Message<NikkeiNeedsIndustrySmall> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string name = 2;
   */
  name = ''

  /**
   * @generated from field: string url = 3;
   */
  url = ''

  /**
   * @generated from field: string nikkei_needs_industry_medium_id = 4;
   */
  nikkeiNeedsIndustryMediumId = ''

  constructor(data?: PartialMessage<NikkeiNeedsIndustrySmall>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.NikkeiNeedsIndustrySmall'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'name', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'url', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'nikkei_needs_industry_medium_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NikkeiNeedsIndustrySmall {
    return new NikkeiNeedsIndustrySmall().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NikkeiNeedsIndustrySmall {
    return new NikkeiNeedsIndustrySmall().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NikkeiNeedsIndustrySmall {
    return new NikkeiNeedsIndustrySmall().fromJsonString(jsonString, options)
  }

  static equals(
    a: NikkeiNeedsIndustrySmall | PlainMessage<NikkeiNeedsIndustrySmall> | undefined,
    b: NikkeiNeedsIndustrySmall | PlainMessage<NikkeiNeedsIndustrySmall> | undefined,
  ): boolean {
    return proto3.util.equals(NikkeiNeedsIndustrySmall, a, b)
  }
}

/**
 * @generated from message models.Company
 */
export class Company extends Message<Company> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string sec_code = 2;
   */
  secCode = ''

  /**
   * @generated from field: google.protobuf.StringValue edinet_code = 3;
   */
  edinetCode?: string

  /**
   * @generated from field: string name = 4;
   */
  name = ''

  /**
   * @generated from field: google.protobuf.StringValue english_name = 5;
   */
  englishName?: string

  /**
   * @generated from field: string furigana_hiragana = 6;
   */
  furiganaHiragana = ''

  /**
   * @generated from field: string furigana_katakana = 7;
   */
  furiganaKatakana = ''

  /**
   * @generated from field: string cooperate_site_home_url = 8;
   */
  cooperateSiteHomeUrl = ''

  /**
   * @generated from field: google.protobuf.StringValue cooperate_site_news_page_url = 9;
   */
  cooperateSiteNewsPageUrl?: string

  /**
   * @generated from field: google.protobuf.StringValue industry33_name = 10;
   */
  industry33Name?: string

  /**
   * @generated from field: google.protobuf.StringValue industry17_name = 11;
   */
  industry17Name?: string

  /**
   * @generated from field: google.protobuf.StringValue description = 12;
   */
  description?: string

  /**
   * @generated from field: bool is_public_listed = 13;
   */
  isPublicListed = false

  constructor(data?: PartialMessage<Company>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.Company'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'sec_code', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'edinet_code', kind: 'message', T: StringValue },
    { no: 4, name: 'name', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'english_name', kind: 'message', T: StringValue },
    { no: 6, name: 'furigana_hiragana', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 7, name: 'furigana_katakana', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 8, name: 'cooperate_site_home_url', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 9, name: 'cooperate_site_news_page_url', kind: 'message', T: StringValue },
    { no: 10, name: 'industry33_name', kind: 'message', T: StringValue },
    { no: 11, name: 'industry17_name', kind: 'message', T: StringValue },
    { no: 12, name: 'description', kind: 'message', T: StringValue },
    { no: 13, name: 'is_public_listed', kind: 'scalar', T: 8 /* ScalarType.BOOL */ },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Company {
    return new Company().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Company {
    return new Company().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Company {
    return new Company().fromJsonString(jsonString, options)
  }

  static equals(a: Company | PlainMessage<Company> | undefined, b: Company | PlainMessage<Company> | undefined): boolean {
    return proto3.util.equals(Company, a, b)
  }
}

/**
 * @generated from message models.CompanyNikkeiNeedsIndustrySmallAssignment
 */
export class CompanyNikkeiNeedsIndustrySmallAssignment extends Message<CompanyNikkeiNeedsIndustrySmallAssignment> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string company_id = 2;
   */
  companyId = ''

  /**
   * @generated from field: string nikkei_needs_industry_small_id = 3;
   */
  nikkeiNeedsIndustrySmallId = ''

  constructor(data?: PartialMessage<CompanyNikkeiNeedsIndustrySmallAssignment>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.CompanyNikkeiNeedsIndustrySmallAssignment'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'company_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'nikkei_needs_industry_small_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CompanyNikkeiNeedsIndustrySmallAssignment {
    return new CompanyNikkeiNeedsIndustrySmallAssignment().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CompanyNikkeiNeedsIndustrySmallAssignment {
    return new CompanyNikkeiNeedsIndustrySmallAssignment().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CompanyNikkeiNeedsIndustrySmallAssignment {
    return new CompanyNikkeiNeedsIndustrySmallAssignment().fromJsonString(jsonString, options)
  }

  static equals(
    a: CompanyNikkeiNeedsIndustrySmallAssignment | PlainMessage<CompanyNikkeiNeedsIndustrySmallAssignment> | undefined,
    b: CompanyNikkeiNeedsIndustrySmallAssignment | PlainMessage<CompanyNikkeiNeedsIndustrySmallAssignment> | undefined,
  ): boolean {
    return proto3.util.equals(CompanyNikkeiNeedsIndustrySmallAssignment, a, b)
  }
}

/**
 * @generated from message models.CompanyFiscalPeriod
 */
export class CompanyFiscalPeriod extends Message<CompanyFiscalPeriod> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string company_id = 2;
   */
  companyId = ''

  /**
   * @generated from field: double fiscal_year = 3;
   */
  fiscalYear = 0

  /**
   * @generated from field: double fiscal_year_end_month = 4;
   */
  fiscalYearEndMonth = 0

  /**
   * @generated from field: double quarter = 5;
   */
  quarter = 0

  /**
   * @generated from field: string fiscal_year_number_text = 6;
   */
  fiscalYearNumberText = ''

  /**
   * @generated from field: string start_at = 7;
   */
  startAt = ''

  /**
   * @generated from field: string end_at = 8;
   */
  endAt = ''

  constructor(data?: PartialMessage<CompanyFiscalPeriod>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.CompanyFiscalPeriod'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'company_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'fiscal_year', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: 'fiscal_year_end_month', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: 'quarter', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: 'fiscal_year_number_text', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 7, name: 'start_at', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 8, name: 'end_at', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CompanyFiscalPeriod {
    return new CompanyFiscalPeriod().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CompanyFiscalPeriod {
    return new CompanyFiscalPeriod().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CompanyFiscalPeriod {
    return new CompanyFiscalPeriod().fromJsonString(jsonString, options)
  }

  static equals(
    a: CompanyFiscalPeriod | PlainMessage<CompanyFiscalPeriod> | undefined,
    b: CompanyFiscalPeriod | PlainMessage<CompanyFiscalPeriod> | undefined,
  ): boolean {
    return proto3.util.equals(CompanyFiscalPeriod, a, b)
  }
}

/**
 * @generated from message models.IrDataSource
 */
export class IrDataSource extends Message<IrDataSource> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string company_id = 2;
   */
  companyId = ''

  /**
   * @generated from field: string company_fiscal_period_id = 3;
   */
  companyFiscalPeriodId = ''

  /**
   * @generated from field: string title = 4;
   */
  title = ''

  /**
   * @generated from field: models.IrDataSource.DocumentType document_type = 5;
   */
  documentType = IrDataSource_DocumentType._UNSPECIFIED_DOCUMENT_TYPE

  /**
   * @generated from field: google.protobuf.StringValue edinet_document_id = 6;
   */
  edinetDocumentId?: string

  /**
   * @generated from field: google.protobuf.StringValue issued_at = 7;
   */
  issuedAt?: string

  /**
   * @generated from field: string public_url = 8;
   */
  publicUrl = ''

  constructor(data?: PartialMessage<IrDataSource>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.IrDataSource'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'company_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'company_fiscal_period_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'title', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'document_type', kind: 'enum', T: proto3.getEnumType(IrDataSource_DocumentType) },
    { no: 6, name: 'edinet_document_id', kind: 'message', T: StringValue },
    { no: 7, name: 'issued_at', kind: 'message', T: StringValue },
    { no: 8, name: 'public_url', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): IrDataSource {
    return new IrDataSource().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): IrDataSource {
    return new IrDataSource().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): IrDataSource {
    return new IrDataSource().fromJsonString(jsonString, options)
  }

  static equals(a: IrDataSource | PlainMessage<IrDataSource> | undefined, b: IrDataSource | PlainMessage<IrDataSource> | undefined): boolean {
    return proto3.util.equals(IrDataSource, a, b)
  }
}

/**
 * @generated from enum models.IrDataSource.DocumentType
 */
export enum IrDataSource_DocumentType {
  /**
   * @generated from enum value: _UNSPECIFIED_DOCUMENT_TYPE = 0;
   */
  _UNSPECIFIED_DOCUMENT_TYPE = 0,

  /**
   * @generated from enum value: SECURITIES_REPORT = 1;
   */
  SECURITIES_REPORT = 1,

  /**
   * @generated from enum value: FINANCIAL_RESULTS_PRESENTATION = 2;
   */
  FINANCIAL_RESULTS_PRESENTATION = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(IrDataSource_DocumentType)
proto3.util.setEnumType(IrDataSource_DocumentType, 'models.IrDataSource.DocumentType', [
  { no: 0, name: '_UNSPECIFIED_DOCUMENT_TYPE' },
  { no: 1, name: 'SECURITIES_REPORT' },
  { no: 2, name: 'FINANCIAL_RESULTS_PRESENTATION' },
])

/**
 * @generated from message models.IrDataSourceFragment
 */
export class IrDataSourceFragment extends Message<IrDataSourceFragment> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string ir_data_source_id = 2;
   */
  irDataSourceId = ''

  /**
   * @generated from field: double index = 3;
   */
  index = 0

  /**
   * @generated from field: string public_url = 4;
   */
  publicUrl = ''

  /**
   * @generated from field: google.protobuf.StringValue extracted_content = 5;
   */
  extractedContent?: string

  /**
   * @generated from field: repeated string category_names = 6;
   */
  categoryNames: string[] = []

  constructor(data?: PartialMessage<IrDataSourceFragment>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.IrDataSourceFragment'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'ir_data_source_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'index', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: 'public_url', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'extracted_content', kind: 'message', T: StringValue },
    { no: 6, name: 'category_names', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): IrDataSourceFragment {
    return new IrDataSourceFragment().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): IrDataSourceFragment {
    return new IrDataSourceFragment().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): IrDataSourceFragment {
    return new IrDataSourceFragment().fromJsonString(jsonString, options)
  }

  static equals(
    a: IrDataSourceFragment | PlainMessage<IrDataSourceFragment> | undefined,
    b: IrDataSourceFragment | PlainMessage<IrDataSourceFragment> | undefined,
  ): boolean {
    return proto3.util.equals(IrDataSourceFragment, a, b)
  }
}

/**
 * @generated from message models.ReportableSegment
 */
export class ReportableSegment extends Message<ReportableSegment> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string company_id = 2;
   */
  companyId = ''

  /**
   * @generated from field: google.protobuf.StringValue company_fiscal_period_id = 3;
   */
  companyFiscalPeriodId?: string

  /**
   * @generated from field: google.protobuf.StringValue extracted_ir_data_source_id = 4;
   */
  extractedIrDataSourceId?: string

  /**
   * @generated from field: google.protobuf.StringValue ir_data_source_fragment_extraction_id = 5;
   */
  irDataSourceFragmentExtractionId?: string

  /**
   * @generated from field: string name = 6;
   */
  name = ''

  constructor(data?: PartialMessage<ReportableSegment>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.ReportableSegment'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'company_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'company_fiscal_period_id', kind: 'message', T: StringValue },
    { no: 4, name: 'extracted_ir_data_source_id', kind: 'message', T: StringValue },
    { no: 5, name: 'ir_data_source_fragment_extraction_id', kind: 'message', T: StringValue },
    { no: 6, name: 'name', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReportableSegment {
    return new ReportableSegment().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReportableSegment {
    return new ReportableSegment().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReportableSegment {
    return new ReportableSegment().fromJsonString(jsonString, options)
  }

  static equals(
    a: ReportableSegment | PlainMessage<ReportableSegment> | undefined,
    b: ReportableSegment | PlainMessage<ReportableSegment> | undefined,
  ): boolean {
    return proto3.util.equals(ReportableSegment, a, b)
  }
}

/**
 * @generated from message models.FinancialIndicator
 */
export class FinancialIndicator extends Message<FinancialIndicator> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: models.FinancialIndicator.TargetType target_type = 2;
   */
  targetType = FinancialIndicator_TargetType._UNSPECIFIED_TARGET_TYPE

  /**
   * @generated from field: string company_id = 3;
   */
  companyId = ''

  /**
   * @generated from field: string company_fiscal_period_id = 4;
   */
  companyFiscalPeriodId = ''

  /**
   * @generated from field: google.protobuf.StringValue reportable_segment_id = 5;
   */
  reportableSegmentId?: string

  /**
   * @generated from field: google.protobuf.StringValue extracted_ir_data_source_id = 6;
   */
  extractedIrDataSourceId?: string

  /**
   * @generated from field: google.protobuf.StringValue ir_data_source_fragment_extraction_id = 7;
   */
  irDataSourceFragmentExtractionId?: string

  /**
   * @generated from field: string indicator_name = 8;
   */
  indicatorName = ''

  /**
   * @generated from field: models.FinancialIndicator.IndicatorType indicator_type = 9;
   */
  indicatorType = FinancialIndicator_IndicatorType._UNSPECIFIED_INDICATOR_TYPE

  /**
   * @generated from field: bool is_forecast = 10;
   */
  isForecast = false

  /**
   * @generated from field: bool is_cumulative = 11;
   */
  isCumulative = false

  /**
   * @generated from field: models.FinancialIndicator.Currency currency = 12;
   */
  currency = FinancialIndicator_Currency._UNSPECIFIED_CURRENCY

  /**
   * @generated from field: models.FinancialIndicator.Unit unit = 13;
   */
  unit = FinancialIndicator_Unit._UNSPECIFIED_UNIT

  /**
   * @generated from field: double value = 14;
   */
  value = 0

  /**
   * @generated from field: google.protobuf.DoubleValue yoy_change_percentage = 15;
   */
  yoyChangePercentage?: number

  constructor(data?: PartialMessage<FinancialIndicator>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.FinancialIndicator'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'target_type', kind: 'enum', T: proto3.getEnumType(FinancialIndicator_TargetType) },
    { no: 3, name: 'company_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'company_fiscal_period_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'reportable_segment_id', kind: 'message', T: StringValue },
    { no: 6, name: 'extracted_ir_data_source_id', kind: 'message', T: StringValue },
    { no: 7, name: 'ir_data_source_fragment_extraction_id', kind: 'message', T: StringValue },
    { no: 8, name: 'indicator_name', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 9, name: 'indicator_type', kind: 'enum', T: proto3.getEnumType(FinancialIndicator_IndicatorType) },
    { no: 10, name: 'is_forecast', kind: 'scalar', T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: 'is_cumulative', kind: 'scalar', T: 8 /* ScalarType.BOOL */ },
    { no: 12, name: 'currency', kind: 'enum', T: proto3.getEnumType(FinancialIndicator_Currency) },
    { no: 13, name: 'unit', kind: 'enum', T: proto3.getEnumType(FinancialIndicator_Unit) },
    { no: 14, name: 'value', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 15, name: 'yoy_change_percentage', kind: 'message', T: DoubleValue },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FinancialIndicator {
    return new FinancialIndicator().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FinancialIndicator {
    return new FinancialIndicator().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FinancialIndicator {
    return new FinancialIndicator().fromJsonString(jsonString, options)
  }

  static equals(
    a: FinancialIndicator | PlainMessage<FinancialIndicator> | undefined,
    b: FinancialIndicator | PlainMessage<FinancialIndicator> | undefined,
  ): boolean {
    return proto3.util.equals(FinancialIndicator, a, b)
  }
}

/**
 * @generated from enum models.FinancialIndicator.TargetType
 */
export enum FinancialIndicator_TargetType {
  /**
   * @generated from enum value: _UNSPECIFIED_TARGET_TYPE = 0;
   */
  _UNSPECIFIED_TARGET_TYPE = 0,

  /**
   * @generated from enum value: COMPANY = 1;
   */
  COMPANY = 1,

  /**
   * @generated from enum value: REPORTABLE_SEGMENT = 2;
   */
  REPORTABLE_SEGMENT = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(FinancialIndicator_TargetType)
proto3.util.setEnumType(FinancialIndicator_TargetType, 'models.FinancialIndicator.TargetType', [
  { no: 0, name: '_UNSPECIFIED_TARGET_TYPE' },
  { no: 1, name: 'COMPANY' },
  { no: 2, name: 'REPORTABLE_SEGMENT' },
])

/**
 * @generated from enum models.FinancialIndicator.IndicatorType
 */
export enum FinancialIndicator_IndicatorType {
  /**
   * @generated from enum value: _UNSPECIFIED_INDICATOR_TYPE = 0;
   */
  _UNSPECIFIED_INDICATOR_TYPE = 0,

  /**
   * @generated from enum value: GROSS_SALES = 1;
   */
  GROSS_SALES = 1,

  /**
   * @generated from enum value: GROSS_PROFIT = 2;
   */
  GROSS_PROFIT = 2,

  /**
   * @generated from enum value: OPERATING_PROFIT = 3;
   */
  OPERATING_PROFIT = 3,

  /**
   * @generated from enum value: MANAGEMENT_PROFIT = 4;
   */
  MANAGEMENT_PROFIT = 4,

  /**
   * @generated from enum value: PRE_TAX_PROFIT = 5;
   */
  PRE_TAX_PROFIT = 5,

  /**
   * @generated from enum value: NET_INCOME = 6;
   */
  NET_INCOME = 6,
}
// Retrieve enum metadata with: proto3.getEnumType(FinancialIndicator_IndicatorType)
proto3.util.setEnumType(FinancialIndicator_IndicatorType, 'models.FinancialIndicator.IndicatorType', [
  { no: 0, name: '_UNSPECIFIED_INDICATOR_TYPE' },
  { no: 1, name: 'GROSS_SALES' },
  { no: 2, name: 'GROSS_PROFIT' },
  { no: 3, name: 'OPERATING_PROFIT' },
  { no: 4, name: 'MANAGEMENT_PROFIT' },
  { no: 5, name: 'PRE_TAX_PROFIT' },
  { no: 6, name: 'NET_INCOME' },
])

/**
 * @generated from enum models.FinancialIndicator.Currency
 */
export enum FinancialIndicator_Currency {
  /**
   * @generated from enum value: _UNSPECIFIED_CURRENCY = 0;
   */
  _UNSPECIFIED_CURRENCY = 0,

  /**
   * @generated from enum value: JPY = 1;
   */
  JPY = 1,

  /**
   * @generated from enum value: USD = 2;
   */
  USD = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(FinancialIndicator_Currency)
proto3.util.setEnumType(FinancialIndicator_Currency, 'models.FinancialIndicator.Currency', [
  { no: 0, name: '_UNSPECIFIED_CURRENCY' },
  { no: 1, name: 'JPY' },
  { no: 2, name: 'USD' },
])

/**
 * @generated from enum models.FinancialIndicator.Unit
 */
export enum FinancialIndicator_Unit {
  /**
   * @generated from enum value: _UNSPECIFIED_UNIT = 0;
   */
  _UNSPECIFIED_UNIT = 0,

  /**
   * @generated from enum value: ONE = 1;
   */
  ONE = 1,

  /**
   * @generated from enum value: THOUSAND = 2;
   */
  THOUSAND = 2,

  /**
   * @generated from enum value: MILLION = 3;
   */
  MILLION = 3,

  /**
   * @generated from enum value: BILLION = 4;
   */
  BILLION = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(FinancialIndicator_Unit)
proto3.util.setEnumType(FinancialIndicator_Unit, 'models.FinancialIndicator.Unit', [
  { no: 0, name: '_UNSPECIFIED_UNIT' },
  { no: 1, name: 'ONE' },
  { no: 2, name: 'THOUSAND' },
  { no: 3, name: 'MILLION' },
  { no: 4, name: 'BILLION' },
])

/**
 * @generated from message models.UserAnalysisQuery
 */
export class UserAnalysisQuery extends Message<UserAnalysisQuery> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string user_id = 2;
   */
  userId = ''

  /**
   * @generated from field: string raw_query_text = 3;
   */
  rawQueryText = ''

  /**
   * @generated from field: string summarized_query_text = 4;
   */
  summarizedQueryText = ''

  /**
   * @generated from field: repeated string company_ids = 5;
   */
  companyIds: string[] = []

  /**
   * @generated from field: repeated string industry_names = 6;
   */
  industryNames: string[] = []

  /**
   * @generated from field: repeated string nikkei_needs_industry_small_ids = 7;
   */
  nikkeiNeedsIndustrySmallIds: string[] = []

  /**
   * @generated from field: repeated string nikkei_needs_industry_medium_ids = 8;
   */
  nikkeiNeedsIndustryMediumIds: string[] = []

  /**
   * @generated from field: repeated string nikkei_needs_industry_large_ids = 9;
   */
  nikkeiNeedsIndustryLargeIds: string[] = []

  /**
   * @generated from field: string requested_at = 10;
   */
  requestedAt = ''

  /**
   * @generated from field: google.protobuf.Struct summary_analysis_result_cache = 11;
   */
  summaryAnalysisResultCache?: Struct

  /**
   * @generated from field: google.protobuf.Struct analysis_result_widets_cache = 12;
   */
  analysisResultWidetsCache?: Struct

  constructor(data?: PartialMessage<UserAnalysisQuery>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.UserAnalysisQuery'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'user_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'raw_query_text', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'summarized_query_text', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'company_ids', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: 'industry_names', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: 'nikkei_needs_industry_small_ids', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 8, name: 'nikkei_needs_industry_medium_ids', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 9, name: 'nikkei_needs_industry_large_ids', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: 'requested_at', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 11, name: 'summary_analysis_result_cache', kind: 'message', T: Struct },
    { no: 12, name: 'analysis_result_widets_cache', kind: 'message', T: Struct },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserAnalysisQuery {
    return new UserAnalysisQuery().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserAnalysisQuery {
    return new UserAnalysisQuery().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserAnalysisQuery {
    return new UserAnalysisQuery().fromJsonString(jsonString, options)
  }

  static equals(
    a: UserAnalysisQuery | PlainMessage<UserAnalysisQuery> | undefined,
    b: UserAnalysisQuery | PlainMessage<UserAnalysisQuery> | undefined,
  ): boolean {
    return proto3.util.equals(UserAnalysisQuery, a, b)
  }
}

/**
 * @generated from message models.FinancialIndicatorFactor
 */
export class FinancialIndicatorFactor extends Message<FinancialIndicatorFactor> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string financial_indicator_id = 2;
   */
  financialIndicatorId = ''

  /**
   * @generated from field: google.protobuf.StringValue ir_data_source_fragment_extraction_id = 3;
   */
  irDataSourceFragmentExtractionId?: string

  /**
   * @generated from field: string title = 4;
   */
  title = ''

  constructor(data?: PartialMessage<FinancialIndicatorFactor>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.FinancialIndicatorFactor'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'financial_indicator_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'ir_data_source_fragment_extraction_id', kind: 'message', T: StringValue },
    { no: 4, name: 'title', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FinancialIndicatorFactor {
    return new FinancialIndicatorFactor().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FinancialIndicatorFactor {
    return new FinancialIndicatorFactor().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FinancialIndicatorFactor {
    return new FinancialIndicatorFactor().fromJsonString(jsonString, options)
  }

  static equals(
    a: FinancialIndicatorFactor | PlainMessage<FinancialIndicatorFactor> | undefined,
    b: FinancialIndicatorFactor | PlainMessage<FinancialIndicatorFactor> | undefined,
  ): boolean {
    return proto3.util.equals(FinancialIndicatorFactor, a, b)
  }
}

/**
 * @generated from message models.ReportableSegmentCompanyFiscalPeriodAppearance
 */
export class ReportableSegmentCompanyFiscalPeriodAppearance extends Message<ReportableSegmentCompanyFiscalPeriodAppearance> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string reportable_segment_id = 2;
   */
  reportableSegmentId = ''

  /**
   * @generated from field: string company_fiscal_period_id = 3;
   */
  companyFiscalPeriodId = ''

  /**
   * @generated from field: string ir_data_source_fragment_extraction_id = 4;
   */
  irDataSourceFragmentExtractionId = ''

  constructor(data?: PartialMessage<ReportableSegmentCompanyFiscalPeriodAppearance>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.ReportableSegmentCompanyFiscalPeriodAppearance'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'reportable_segment_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'company_fiscal_period_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'ir_data_source_fragment_extraction_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReportableSegmentCompanyFiscalPeriodAppearance {
    return new ReportableSegmentCompanyFiscalPeriodAppearance().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReportableSegmentCompanyFiscalPeriodAppearance {
    return new ReportableSegmentCompanyFiscalPeriodAppearance().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReportableSegmentCompanyFiscalPeriodAppearance {
    return new ReportableSegmentCompanyFiscalPeriodAppearance().fromJsonString(jsonString, options)
  }

  static equals(
    a: ReportableSegmentCompanyFiscalPeriodAppearance | PlainMessage<ReportableSegmentCompanyFiscalPeriodAppearance> | undefined,
    b: ReportableSegmentCompanyFiscalPeriodAppearance | PlainMessage<ReportableSegmentCompanyFiscalPeriodAppearance> | undefined,
  ): boolean {
    return proto3.util.equals(ReportableSegmentCompanyFiscalPeriodAppearance, a, b)
  }
}

/**
 * @generated from message models.MediumTermManagementPlan
 */
export class MediumTermManagementPlan extends Message<MediumTermManagementPlan> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string company_id = 2;
   */
  companyId = ''

  /**
   * @generated from field: string company_fiscal_period_id = 3;
   */
  companyFiscalPeriodId = ''

  /**
   * @generated from field: google.protobuf.DoubleValue start_fiscal_year = 4;
   */
  startFiscalYear?: number

  /**
   * @generated from field: google.protobuf.DoubleValue end_fiscal_year = 5;
   */
  endFiscalYear?: number

  /**
   * @generated from field: string ir_data_source_fragment_extraction_id = 6;
   */
  irDataSourceFragmentExtractionId = ''

  constructor(data?: PartialMessage<MediumTermManagementPlan>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.MediumTermManagementPlan'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'company_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'company_fiscal_period_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'start_fiscal_year', kind: 'message', T: DoubleValue },
    { no: 5, name: 'end_fiscal_year', kind: 'message', T: DoubleValue },
    { no: 6, name: 'ir_data_source_fragment_extraction_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MediumTermManagementPlan {
    return new MediumTermManagementPlan().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MediumTermManagementPlan {
    return new MediumTermManagementPlan().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MediumTermManagementPlan {
    return new MediumTermManagementPlan().fromJsonString(jsonString, options)
  }

  static equals(
    a: MediumTermManagementPlan | PlainMessage<MediumTermManagementPlan> | undefined,
    b: MediumTermManagementPlan | PlainMessage<MediumTermManagementPlan> | undefined,
  ): boolean {
    return proto3.util.equals(MediumTermManagementPlan, a, b)
  }
}

/**
 * @generated from message models.MediumTermManagementPlanObjective
 */
export class MediumTermManagementPlanObjective extends Message<MediumTermManagementPlanObjective> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string medium_term_management_plan_id = 2;
   */
  mediumTermManagementPlanId = ''

  /**
   * @generated from field: string ir_data_source_fragment_extraction_id = 3;
   */
  irDataSourceFragmentExtractionId = ''

  /**
   * @generated from field: string title = 4;
   */
  title = ''

  constructor(data?: PartialMessage<MediumTermManagementPlanObjective>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.MediumTermManagementPlanObjective'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'medium_term_management_plan_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'ir_data_source_fragment_extraction_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'title', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MediumTermManagementPlanObjective {
    return new MediumTermManagementPlanObjective().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MediumTermManagementPlanObjective {
    return new MediumTermManagementPlanObjective().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MediumTermManagementPlanObjective {
    return new MediumTermManagementPlanObjective().fromJsonString(jsonString, options)
  }

  static equals(
    a: MediumTermManagementPlanObjective | PlainMessage<MediumTermManagementPlanObjective> | undefined,
    b: MediumTermManagementPlanObjective | PlainMessage<MediumTermManagementPlanObjective> | undefined,
  ): boolean {
    return proto3.util.equals(MediumTermManagementPlanObjective, a, b)
  }
}

/**
 * @generated from message models.MediumTermManagementPlanFocusPoint
 */
export class MediumTermManagementPlanFocusPoint extends Message<MediumTermManagementPlanFocusPoint> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string medium_term_management_plan_id = 2;
   */
  mediumTermManagementPlanId = ''

  /**
   * @generated from field: string ir_data_source_fragment_extraction_id = 3;
   */
  irDataSourceFragmentExtractionId = ''

  /**
   * @generated from field: double index = 4;
   */
  index = 0

  /**
   * @generated from field: string title = 5;
   */
  title = ''

  constructor(data?: PartialMessage<MediumTermManagementPlanFocusPoint>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.MediumTermManagementPlanFocusPoint'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'medium_term_management_plan_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'ir_data_source_fragment_extraction_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'index', kind: 'scalar', T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: 'title', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MediumTermManagementPlanFocusPoint {
    return new MediumTermManagementPlanFocusPoint().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MediumTermManagementPlanFocusPoint {
    return new MediumTermManagementPlanFocusPoint().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MediumTermManagementPlanFocusPoint {
    return new MediumTermManagementPlanFocusPoint().fromJsonString(jsonString, options)
  }

  static equals(
    a: MediumTermManagementPlanFocusPoint | PlainMessage<MediumTermManagementPlanFocusPoint> | undefined,
    b: MediumTermManagementPlanFocusPoint | PlainMessage<MediumTermManagementPlanFocusPoint> | undefined,
  ): boolean {
    return proto3.util.equals(MediumTermManagementPlanFocusPoint, a, b)
  }
}

/**
 * @generated from message models.MediumTermManagementPlanFocusPointCase
 */
export class MediumTermManagementPlanFocusPointCase extends Message<MediumTermManagementPlanFocusPointCase> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string medium_term_management_plan_focus_point_id = 2;
   */
  mediumTermManagementPlanFocusPointId = ''

  /**
   * @generated from field: string ir_data_source_fragment_extraction_id = 3;
   */
  irDataSourceFragmentExtractionId = ''

  /**
   * @generated from field: string title = 4;
   */
  title = ''

  /**
   * @generated from field: repeated string sub_cases = 5;
   */
  subCases: string[] = []

  constructor(data?: PartialMessage<MediumTermManagementPlanFocusPointCase>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.MediumTermManagementPlanFocusPointCase'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'medium_term_management_plan_focus_point_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'ir_data_source_fragment_extraction_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'title', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'sub_cases', kind: 'scalar', T: 9 /* ScalarType.STRING */, repeated: true },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MediumTermManagementPlanFocusPointCase {
    return new MediumTermManagementPlanFocusPointCase().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MediumTermManagementPlanFocusPointCase {
    return new MediumTermManagementPlanFocusPointCase().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MediumTermManagementPlanFocusPointCase {
    return new MediumTermManagementPlanFocusPointCase().fromJsonString(jsonString, options)
  }

  static equals(
    a: MediumTermManagementPlanFocusPointCase | PlainMessage<MediumTermManagementPlanFocusPointCase> | undefined,
    b: MediumTermManagementPlanFocusPointCase | PlainMessage<MediumTermManagementPlanFocusPointCase> | undefined,
  ): boolean {
    return proto3.util.equals(MediumTermManagementPlanFocusPointCase, a, b)
  }
}

/**
 * @generated from message models.IrDataSourceFragmentExtraction
 */
export class IrDataSourceFragmentExtraction extends Message<IrDataSourceFragmentExtraction> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: models.IrDataSourceFragmentExtraction.ExtractedFactType extracted_fact_type = 2;
   */
  extractedFactType = IrDataSourceFragmentExtraction_ExtractedFactType._UNSPECIFIED_EXTRACTED_FACT_TYPE

  /**
   * @generated from field: string ir_data_source_fragment_id = 3;
   */
  irDataSourceFragmentId = ''

  /**
   * @generated from field: models.IrDataSourceFragmentExtraction.ExtractionMethod extraction_method = 4;
   */
  extractionMethod = IrDataSourceFragmentExtraction_ExtractionMethod._UNSPECIFIED_EXTRACTION_METHOD

  /**
   * @generated from field: google.protobuf.StringValue model = 5;
   */
  model?: string

  /**
   * @generated from field: string extracted_at = 6;
   */
  extractedAt = ''

  constructor(data?: PartialMessage<IrDataSourceFragmentExtraction>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.IrDataSourceFragmentExtraction'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'extracted_fact_type', kind: 'enum', T: proto3.getEnumType(IrDataSourceFragmentExtraction_ExtractedFactType) },
    { no: 3, name: 'ir_data_source_fragment_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'extraction_method', kind: 'enum', T: proto3.getEnumType(IrDataSourceFragmentExtraction_ExtractionMethod) },
    { no: 5, name: 'model', kind: 'message', T: StringValue },
    { no: 6, name: 'extracted_at', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): IrDataSourceFragmentExtraction {
    return new IrDataSourceFragmentExtraction().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): IrDataSourceFragmentExtraction {
    return new IrDataSourceFragmentExtraction().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): IrDataSourceFragmentExtraction {
    return new IrDataSourceFragmentExtraction().fromJsonString(jsonString, options)
  }

  static equals(
    a: IrDataSourceFragmentExtraction | PlainMessage<IrDataSourceFragmentExtraction> | undefined,
    b: IrDataSourceFragmentExtraction | PlainMessage<IrDataSourceFragmentExtraction> | undefined,
  ): boolean {
    return proto3.util.equals(IrDataSourceFragmentExtraction, a, b)
  }
}

/**
 * @generated from enum models.IrDataSourceFragmentExtraction.ExtractedFactType
 */
export enum IrDataSourceFragmentExtraction_ExtractedFactType {
  /**
   * @generated from enum value: _UNSPECIFIED_EXTRACTED_FACT_TYPE = 0;
   */
  _UNSPECIFIED_EXTRACTED_FACT_TYPE = 0,

  /**
   * @generated from enum value: REPORTABLE_SEGMENT = 1;
   */
  REPORTABLE_SEGMENT = 1,

  /**
   * @generated from enum value: REPORTABLE_SEGMENT_COMPANY_FISCAL_PERIOD_APPEARANCE = 2;
   */
  REPORTABLE_SEGMENT_COMPANY_FISCAL_PERIOD_APPEARANCE = 2,

  /**
   * @generated from enum value: FINANCIAL_INDICATOR = 3;
   */
  FINANCIAL_INDICATOR = 3,

  /**
   * @generated from enum value: FINANCIAL_INDICATOR_FACTOR = 4;
   */
  FINANCIAL_INDICATOR_FACTOR = 4,

  /**
   * @generated from enum value: MEDIUM_TERM_MANAGEMENT_PLAN = 5;
   */
  MEDIUM_TERM_MANAGEMENT_PLAN = 5,

  /**
   * @generated from enum value: MEDIUM_TERM_MANAGEMENT_PLAN_OBJECTIVE = 6;
   */
  MEDIUM_TERM_MANAGEMENT_PLAN_OBJECTIVE = 6,

  /**
   * @generated from enum value: MEDIUM_TERM_MANAGEMENT_PLAN_FOCUS_POINT = 7;
   */
  MEDIUM_TERM_MANAGEMENT_PLAN_FOCUS_POINT = 7,

  /**
   * @generated from enum value: MEDIUM_TERM_MANAGEMENT_PLAN_FOCUS_POINT_CASE = 8;
   */
  MEDIUM_TERM_MANAGEMENT_PLAN_FOCUS_POINT_CASE = 8,
}
// Retrieve enum metadata with: proto3.getEnumType(IrDataSourceFragmentExtraction_ExtractedFactType)
proto3.util.setEnumType(IrDataSourceFragmentExtraction_ExtractedFactType, 'models.IrDataSourceFragmentExtraction.ExtractedFactType', [
  { no: 0, name: '_UNSPECIFIED_EXTRACTED_FACT_TYPE' },
  { no: 1, name: 'REPORTABLE_SEGMENT' },
  { no: 2, name: 'REPORTABLE_SEGMENT_COMPANY_FISCAL_PERIOD_APPEARANCE' },
  { no: 3, name: 'FINANCIAL_INDICATOR' },
  { no: 4, name: 'FINANCIAL_INDICATOR_FACTOR' },
  { no: 5, name: 'MEDIUM_TERM_MANAGEMENT_PLAN' },
  { no: 6, name: 'MEDIUM_TERM_MANAGEMENT_PLAN_OBJECTIVE' },
  { no: 7, name: 'MEDIUM_TERM_MANAGEMENT_PLAN_FOCUS_POINT' },
  { no: 8, name: 'MEDIUM_TERM_MANAGEMENT_PLAN_FOCUS_POINT_CASE' },
])

/**
 * @generated from enum models.IrDataSourceFragmentExtraction.ExtractionMethod
 */
export enum IrDataSourceFragmentExtraction_ExtractionMethod {
  /**
   * @generated from enum value: _UNSPECIFIED_EXTRACTION_METHOD = 0;
   */
  _UNSPECIFIED_EXTRACTION_METHOD = 0,

  /**
   * @generated from enum value: VISION_LLM = 1;
   */
  VISION_LLM = 1,

  /**
   * @generated from enum value: PARSE_XBRL = 2;
   */
  PARSE_XBRL = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(IrDataSourceFragmentExtraction_ExtractionMethod)
proto3.util.setEnumType(IrDataSourceFragmentExtraction_ExtractionMethod, 'models.IrDataSourceFragmentExtraction.ExtractionMethod', [
  { no: 0, name: '_UNSPECIFIED_EXTRACTION_METHOD' },
  { no: 1, name: 'VISION_LLM' },
  { no: 2, name: 'PARSE_XBRL' },
])

/**
 * @generated from message models.PressRelease
 */
export class PressRelease extends Message<PressRelease> {
  /**
   * @generated from field: string id = 1;
   */
  id = ''

  /**
   * @generated from field: string company_id = 2;
   */
  companyId = ''

  /**
   * @generated from field: string title = 3;
   */
  title = ''

  /**
   * @generated from field: string summary = 4;
   */
  summary = ''

  /**
   * @generated from field: string public_url = 5;
   */
  publicUrl = ''

  /**
   * @generated from field: string released_at = 6;
   */
  releasedAt = ''

  constructor(data?: PartialMessage<PressRelease>) {
    super()
    proto3.util.initPartial(data, this)
  }

  static readonly runtime: typeof proto3 = proto3
  static readonly typeName = 'models.PressRelease'
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'company_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'title', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'summary', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'public_url', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 6, name: 'released_at', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
  ])

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PressRelease {
    return new PressRelease().fromBinary(bytes, options)
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PressRelease {
    return new PressRelease().fromJson(jsonValue, options)
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PressRelease {
    return new PressRelease().fromJsonString(jsonString, options)
  }

  static equals(a: PressRelease | PlainMessage<PressRelease> | undefined, b: PressRelease | PlainMessage<PressRelease> | undefined): boolean {
    return proto3.util.equals(PressRelease, a, b)
  }
}
